// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/icon?family=Material+Icons);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.contract-container {
  width: 90%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  font-family: "Barlow", sans-serif;
}
@media (max-width: 1024px) {
  .contract-container {
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0rem;
    margin-top: 95px;
  }
}
.contract-container .header {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 25px 0px;
}
.contract-container .header h6 {
  margin: 0px;
  width: 80%;
  font-size: 32px;
}
@media (max-width: 1024px) {
  .contract-container .header h6 {
    font-size: 18px;
    text-align: center;
  }
}
.contract-container .header h5 {
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 0px;
  color: #706f6f;
}
@media (max-width: 1024px) {
  .contract-container .header h5 {
    font-size: 14px;
    text-align: center;
  }
}
.contract-container .header h6 {
  margin: 0rem;
}

.step-container {
  display: flex;
  align-items: center;
  background-color: #F4F4F4;
  padding: 15px 20px;
  padding: 0px 20px;
  position: relative;
  height: 92px;
}

.step-container::after {
  content: "";
  position: absolute;
  bottom: -23px;
  left: 85%;
  width: 100%;
  transform: translateX(-50%);
  width: 124px;
  height: 25px;
  background-color: #F4F4F4;
  clip-path: polygon(50% 100%, 0 0, 100% 0);
}
@media (max-width: 1024px) {
  .step-container::after {
    left: 50%;
  }
}

.step {
  display: flex;
  align-items: center;
}
.step h5 {
  margin: 0px;
  color: #575756;
  font-size: 24px;
}
@media (max-width: 1024px) {
  .step h5 {
    font-size: 16px;
  }
}

.step-icon-media {
  display: none;
}
@media (max-width: 1024px) {
  .step-icon-media {
    display: block;
    width: 75px;
    height: 75px;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 16px;
    margin-right: 10px;
  }
}

.step-icon {
  width: 32px;
  height: 32px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 16px;
  margin-right: 10px;
}
@media (max-width: 1024px) {
  .step-icon {
    display: none;
  }
}

.step-title {
  font-weight: bold;
  color: #333;
  font-size: 16px;
}

.step-line {
  flex-grow: 1;
  height: 1px;
  background-color: #999;
  margin: 0 40px;
}
@media (max-width: 1024px) {
  .step-line {
    display: none;
  }
}

.check {
  background-color: #28BA62;
}

.step-disabled {
  color: #999;
  display: flex;
  align-items: center;
  font-size: 16px;
}
@media (max-width: 1024px) {
  .step-disabled {
    display: none;
  }
}

.step-disabled .circle {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  margin-right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.space {
  width: 100%;
  background-color: #fbfbfb;
  height: 80px;
  margin-bottom: -15px;
}
@media (max-width: 1024px) {
  .space {
    height: 50px;
  }
}

.bold-font {
  font-weight: bold;
  font-size: 1rem;
}

.detail-contract {
  width: 100%;
}
@media (min-width: 1025px) {
  .detail-contract {
    width: 100%;
  }
}

::ng-deep .mat-tab-group .mat-tab-label {
  color: #666; /* Cor padrão da label */
}

::ng-deep .mat-tab-group .mat-tab-label.mat-tab-label-active {
  color: #d32f2f !important; /* Cor da label quando selecionado */
}

.contract-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px 15px 0 0;
  border-top: 1px solid #ddd;
  border-left: 1px solid #ddd;
  border-right: 1px solid #ddd;
  background-color: #f4f4f4;
  height: 90px;
}
@media (max-width: 1024px) {
  .contract-header {
    height: 100px;
  }
}

.contract-title {
  padding-left: 16px;
  width: 50%;
}
@media (max-width: 1024px) {
  .contract-title {
    width: 100%;
  }
}
.contract-title .type-concession {
  display: flex;
}
@media (max-width: 1024px) {
  .contract-title .type-concession {
    width: 100%;
    justify-content: center;
  }
}
.contract-title .type-concession img {
  padding-right: 8px;
}
.contract-title .type-concession p {
  font-size: 16px;
  margin-top: 5px;
  margin-bottom: 5px;
  margin-left: 3px;
}
.contract-title h2 {
  font-size: 1.5rem;
  margin: 0;
  padding: 0rem;
  line-height: normal;
}
@media (max-width: 1024px) {
  .contract-title h2 {
    width: 100%;
    text-align: start;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-left: 16px;
  }
}
.contract-title span {
  font-size: 16px;
  color: #888;
}

.contract-type {
  width: 50%;
  display: flex;
  justify-content: center;
}
@media (max-width: 1024px) {
  .contract-type {
    display: none;
  }
}
.contract-type p {
  font-size: 16px;
  margin: 0 16px;
}

p {
  font-size: 16px;
  margin: 0 16px;
}

.contract-info {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 20px;
  background-color: #fbfbfb;
}

.contract-info .infos {
  width: 100%;
  padding: 0 16px;
}
@media (max-width: 1024px) {
  .contract-info .infos {
    width: 100%;
  }
}

.dates {
  display: flex;
}

.entity,
.values,
.duration {
  width: 100%;
  display: flex;
  flex-direction: row !important;
  justify-content: space-between !important;
}

.entity p,
.values p,
.dates p,
.duration p,
.user-info p {
  margin: 10px 32px 24px 0px;
  width: auto;
}

.values,
.duration {
  display: flex;
  flex-direction: column;
}

.user-info {
  width: 30% !important;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.user-info .icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  border: 2px solid black;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.user-info img {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-bottom: 10px;
}

.accordion {
  margin-top: 32px;
  border-bottom: 1px rgb(174, 15, 10) solid;
}

.accordion-active {
  margin-top: 32px;
  border-bottom: 1px rgb(174, 15, 10) solid;
}

.accordion-inactive {
  margin-top: 32px;
  border-bottom: 1px #706F6F solid;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

mat-panel-title img {
  padding-left: 16px;
}
mat-panel-title h1 {
  font-size: 24px !important;
  padding-left: 16px;
}

mat-expansion-panel-header {
  padding: 0 !important;
}

@media (max-width: 1024px) {
  .entity,
  .values,
  .dates,
  .duration {
    width: 100%;
    display: flex;
    flex-direction: column !important;
    align-items: flex-start !important;
    justify-content: flex-start !important;
  }
  .contract-header {
    flex-direction: column;
    text-align: center;
  }
  .contract-info {
    flex-direction: column;
  }
  .contract-info > div {
    text-align: center;
  }
  .user-info {
    margin-top: 2rem;
    width: 100% !important;
    display: flex !important;
    justify-content: center !important;
  }
}
@media (min-width: 1025px) {
  .header {
    flex-direction: column !important;
    justify-content: center !important;
    align-items: start !important;
  }
}
::ng-deep .mat-tab-label {
  border-bottom: 2px solid transparent;
  /* Borda padrão para todas as abas */
  font-weight: bold;
  /* Estilo da fonte */
  padding: 8px 16px;
  transition: border-color 0.3s ease;
}

::ng-deep .mat-tab-label-active {
  border-bottom: 3px solid #1976d2;
  /* Borda azul para a aba ativa */
  color: #1976d2;
  /* Cor do texto da aba ativa */
}

::ng-deep .mat-tab-label {
  font-size: 16px;
  /* Tamanho do texto */
}

::ng-deep .mat-tab-group {
  background-color: #f5f5f5;
  /* Cor de fundo do cabeçalho das abas */
  padding: 0 16px;
}

.mat-ripple {
  overflow: hidden;
  position: relative;
}
.mat-ripple:not(:empty) {
  transform: translateZ(0);
}

.mat-ripple.mat-ripple-unbounded {
  overflow: visible;
}

.mat-ripple-element {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);
  transform: scale3d(0, 0, 0);
}
.cdk-high-contrast-active .mat-ripple-element {
  display: none;
}

.cdk-visually-hidden {
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  white-space: nowrap;
  outline: 0;
  -webkit-appearance: none;
  -moz-appearance: none;
  left: 0;
}
[dir=rtl] .cdk-visually-hidden {
  left: auto;
  right: 0;
}

.cdk-overlay-container, .cdk-global-overlay-wrapper {
  pointer-events: none;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.cdk-overlay-container {
  position: fixed;
  z-index: 1000;
}
.cdk-overlay-container:empty {
  display: none;
}

.cdk-global-overlay-wrapper {
  display: flex;
  position: absolute;
  z-index: 1000;
}

.cdk-overlay-pane {
  position: absolute;
  pointer-events: auto;
  box-sizing: border-box;
  z-index: 1000;
  display: flex;
  max-width: 100%;
  max-height: 100%;
}

.cdk-overlay-backdrop {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  pointer-events: auto;
  -webkit-tap-highlight-color: transparent;
  transition: opacity 400ms cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
}
.cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 1;
}
.cdk-high-contrast-active .cdk-overlay-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0.6;
}

.cdk-overlay-dark-backdrop {
  background: rgba(0, 0, 0, 0.32);
}

.cdk-overlay-transparent-backdrop {
  transition: visibility 1ms linear, opacity 1ms linear;
  visibility: hidden;
  opacity: 1;
}
.cdk-overlay-transparent-backdrop.cdk-overlay-backdrop-showing {
  opacity: 0;
  visibility: visible;
}

.cdk-overlay-backdrop-noop-animation {
  transition: none;
}

.cdk-overlay-connected-position-bounding-box {
  position: absolute;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  min-width: 1px;
  min-height: 1px;
}

.cdk-global-scrollblock {
  position: fixed;
  width: 100%;
  overflow-y: scroll;
}

textarea.cdk-textarea-autosize {
  resize: none;
}

textarea.cdk-textarea-autosize-measuring {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: auto !important;
  overflow: hidden !important;
}

textarea.cdk-textarea-autosize-measuring-firefox {
  padding: 2px 0 !important;
  box-sizing: content-box !important;
  height: 0 !important;
}

@keyframes cdk-text-field-autofill-start { /*!*/ }
@keyframes cdk-text-field-autofill-end { /*!*/ }
.cdk-text-field-autofill-monitored:-webkit-autofill {
  animation: cdk-text-field-autofill-start 0s 1ms;
}

.cdk-text-field-autofill-monitored:not(:-webkit-autofill) {
  animation: cdk-text-field-autofill-end 0s 1ms;
}

.mat-focus-indicator {
  position: relative;
}
.mat-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-focus-indicator-display, none);
  border: var(--mat-focus-indicator-border-width, 3px) var(--mat-focus-indicator-border-style, solid) var(--mat-focus-indicator-border-color, transparent);
  border-radius: var(--mat-focus-indicator-border-radius, 4px);
}
.mat-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-focus-indicator-display: block;
}

.mat-mdc-focus-indicator {
  position: relative;
}
.mat-mdc-focus-indicator::before {
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  position: absolute;
  box-sizing: border-box;
  pointer-events: none;
  display: var(--mat-mdc-focus-indicator-display, none);
  border: var(--mat-mdc-focus-indicator-border-width, 3px) var(--mat-mdc-focus-indicator-border-style, solid) var(--mat-mdc-focus-indicator-border-color, transparent);
  border-radius: var(--mat-mdc-focus-indicator-border-radius, 4px);
}
.mat-mdc-focus-indicator:focus::before {
  content: "";
}

.cdk-high-contrast-active {
  --mat-mdc-focus-indicator-display: block;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
body {
  font-family: "Barlow", sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
}

h1 {
  font-size: 64px;
  line-height: 78px;
}

h2 {
  font-size: 56px;
  line-height: 68px;
}

h3 {
  font-size: 48px;
  line-height: 58px;
}

h4 {
  font-size: 40px;
  line-height: 48px;
}

h5 {
  font-size: 32px;
  line-height: 39px;
}

h6 {
  font-size: 24px;
  line-height: 29px;
}

a {
  font-size: 16px;
  font-weight: 400;
  line-height: 19px;
  color: rgb(174, 15, 10);
  cursor: pointer;
  text-decoration: underline;
}

caption {
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
}

th {
  font-weight: 700;
  cursor: pointer;
}

/* 
	Colors values 
	300 = tint
	500 = default
	700 = shade
*/
.p-0 {
  padding: 0px;
}

.pt-0 {
  padding-top: 0px;
}

.pr-0 {
  padding-right: 0px;
}

.pb-0 {
  padding-bottom: 0px;
}

.pl-0 {
  padding-left: 0px;
}

.px-0 {
  padding-left: 0px;
  padding-right: 0px;
}

.py-0 {
  padding-top: 0px;
  padding-bottom: 0px;
}

.m-0 {
  margin: 0px;
}

.mt-0 {
  margin-top: 0px;
}

.mr-0 {
  margin-right: 0px;
}

.mb-0 {
  margin-bottom: 0px;
}

.ml-0 {
  margin-left: 0px;
}

.mx-0 {
  margin-left: 0px;
  margin-right: 0px;
}

.my-0 {
  margin-top: 0px;
  margin-bottom: 0px;
}

.p-1 {
  padding: 8px;
}

.pt-1 {
  padding-top: 8px;
}

.pr-1 {
  padding-right: 8px;
}

.pb-1 {
  padding-bottom: 8px;
}

.pl-1 {
  padding-left: 8px;
}

.px-1 {
  padding-left: 8px;
  padding-right: 8px;
}

.py-1 {
  padding-top: 8px;
  padding-bottom: 8px;
}

.m-1 {
  margin: 8px;
}

.mt-1 {
  margin-top: 8px;
}

.mr-1 {
  margin-right: 8px;
}

.mb-1 {
  margin-bottom: 8px;
}

.ml-1 {
  margin-left: 8px;
}

.mx-1 {
  margin-left: 8px;
  margin-right: 8px;
}

.my-1 {
  margin-top: 8px;
  margin-bottom: 8px;
}

.p-2 {
  padding: 16px;
}

.pt-2 {
  padding-top: 16px;
}

.pr-2 {
  padding-right: 16px;
}

.pb-2 {
  padding-bottom: 16px;
}

.pl-2 {
  padding-left: 16px;
}

.px-2 {
  padding-left: 16px;
  padding-right: 16px;
}

.py-2 {
  padding-top: 16px;
  padding-bottom: 16px;
}

.m-2 {
  margin: 16px;
}

.mt-2 {
  margin-top: 16px;
}

.mr-2 {
  margin-right: 16px;
}

.mb-2 {
  margin-bottom: 16px;
}

.ml-2 {
  margin-left: 16px;
}

.mx-2 {
  margin-left: 16px;
  margin-right: 16px;
}

.my-2 {
  margin-top: 16px;
  margin-bottom: 16px;
}

.p-3 {
  padding: 24px;
}

.pt-3 {
  padding-top: 24px;
}

.pr-3 {
  padding-right: 24px;
}

.pb-3 {
  padding-bottom: 24px;
}

.pl-3 {
  padding-left: 24px;
}

.px-3 {
  padding-left: 24px;
  padding-right: 24px;
}

.py-3 {
  padding-top: 24px;
  padding-bottom: 24px;
}

.m-3 {
  margin: 24px;
}

.mt-3 {
  margin-top: 24px;
}

.mr-3 {
  margin-right: 24px;
}

.mb-3 {
  margin-bottom: 24px;
}

.ml-3 {
  margin-left: 24px;
}

.mx-3 {
  margin-left: 24px;
  margin-right: 24px;
}

.my-3 {
  margin-top: 24px;
  margin-bottom: 24px;
}

.p-4 {
  padding: 32px;
}

.pt-4 {
  padding-top: 32px;
}

.pr-4 {
  padding-right: 32px;
}

.pb-4 {
  padding-bottom: 32px;
}

.pl-4 {
  padding-left: 32px;
}

.px-4 {
  padding-left: 32px;
  padding-right: 32px;
}

.py-4 {
  padding-top: 32px;
  padding-bottom: 32px;
}

.m-4 {
  margin: 32px;
}

.mt-4 {
  margin-top: 32px;
}

.mr-4 {
  margin-right: 32px;
}

.mb-4 {
  margin-bottom: 32px;
}

.ml-4 {
  margin-left: 32px;
}

.mx-4 {
  margin-left: 32px;
  margin-right: 32px;
}

.my-4 {
  margin-top: 32px;
  margin-bottom: 32px;
}

.p-5 {
  padding: 40px;
}

.pt-5 {
  padding-top: 40px;
}

.pr-5 {
  padding-right: 40px;
}

.pb-5 {
  padding-bottom: 40px;
}

.pl-5 {
  padding-left: 40px;
}

.px-5 {
  padding-left: 40px;
  padding-right: 40px;
}

.py-5 {
  padding-top: 40px;
  padding-bottom: 40px;
}

.m-5 {
  margin: 40px;
}

.mt-5 {
  margin-top: 40px;
}

.mr-5 {
  margin-right: 40px;
}

.mb-5 {
  margin-bottom: 40px;
}

.ml-5 {
  margin-left: 40px;
}

.mx-5 {
  margin-left: 40px;
  margin-right: 40px;
}

.my-5 {
  margin-top: 40px;
  margin-bottom: 40px;
}

.p-6 {
  padding: 48px;
}

.pt-6 {
  padding-top: 48px;
}

.pr-6 {
  padding-right: 48px;
}

.pb-6 {
  padding-bottom: 48px;
}

.pl-6 {
  padding-left: 48px;
}

.px-6 {
  padding-left: 48px;
  padding-right: 48px;
}

.py-6 {
  padding-top: 48px;
  padding-bottom: 48px;
}

.m-6 {
  margin: 48px;
}

.mt-6 {
  margin-top: 48px;
}

.mr-6 {
  margin-right: 48px;
}

.mb-6 {
  margin-bottom: 48px;
}

.ml-6 {
  margin-left: 48px;
}

.mx-6 {
  margin-left: 48px;
  margin-right: 48px;
}

.my-6 {
  margin-top: 48px;
  margin-bottom: 48px;
}

.p-7 {
  padding: 56px;
}

.pt-7 {
  padding-top: 56px;
}

.pr-7 {
  padding-right: 56px;
}

.pb-7 {
  padding-bottom: 56px;
}

.pl-7 {
  padding-left: 56px;
}

.px-7 {
  padding-left: 56px;
  padding-right: 56px;
}

.py-7 {
  padding-top: 56px;
  padding-bottom: 56px;
}

.m-7 {
  margin: 56px;
}

.mt-7 {
  margin-top: 56px;
}

.mr-7 {
  margin-right: 56px;
}

.mb-7 {
  margin-bottom: 56px;
}

.ml-7 {
  margin-left: 56px;
}

.mx-7 {
  margin-left: 56px;
  margin-right: 56px;
}

.my-7 {
  margin-top: 56px;
  margin-bottom: 56px;
}

.p-8 {
  padding: 64px;
}

.pt-8 {
  padding-top: 64px;
}

.pr-8 {
  padding-right: 64px;
}

.pb-8 {
  padding-bottom: 64px;
}

.pl-8 {
  padding-left: 64px;
}

.px-8 {
  padding-left: 64px;
  padding-right: 64px;
}

.py-8 {
  padding-top: 64px;
  padding-bottom: 64px;
}

.m-8 {
  margin: 64px;
}

.mt-8 {
  margin-top: 64px;
}

.mr-8 {
  margin-right: 64px;
}

.mb-8 {
  margin-bottom: 64px;
}

.ml-8 {
  margin-left: 64px;
}

.mx-8 {
  margin-left: 64px;
  margin-right: 64px;
}

.my-8 {
  margin-top: 64px;
  margin-bottom: 64px;
}

.p-9 {
  padding: 72px;
}

.pt-9 {
  padding-top: 72px;
}

.pr-9 {
  padding-right: 72px;
}

.pb-9 {
  padding-bottom: 72px;
}

.pl-9 {
  padding-left: 72px;
}

.px-9 {
  padding-left: 72px;
  padding-right: 72px;
}

.py-9 {
  padding-top: 72px;
  padding-bottom: 72px;
}

.m-9 {
  margin: 72px;
}

.mt-9 {
  margin-top: 72px;
}

.mr-9 {
  margin-right: 72px;
}

.mb-9 {
  margin-bottom: 72px;
}

.ml-9 {
  margin-left: 72px;
}

.mx-9 {
  margin-left: 72px;
  margin-right: 72px;
}

.my-9 {
  margin-top: 72px;
  margin-bottom: 72px;
}

.p-10 {
  padding: 80px;
}

.pt-10 {
  padding-top: 80px;
}

.pr-10 {
  padding-right: 80px;
}

.pb-10 {
  padding-bottom: 80px;
}

.pl-10 {
  padding-left: 80px;
}

.px-10 {
  padding-left: 80px;
  padding-right: 80px;
}

.py-10 {
  padding-top: 80px;
  padding-bottom: 80px;
}

.m-10 {
  margin: 80px;
}

.mt-10 {
  margin-top: 80px;
}

.mr-10 {
  margin-right: 80px;
}

.mb-10 {
  margin-bottom: 80px;
}

.ml-10 {
  margin-left: 80px;
}

.mx-10 {
  margin-left: 80px;
  margin-right: 80px;
}

.my-10 {
  margin-top: 80px;
  margin-bottom: 80px;
}

html {
  --mdc-outlined-text-field-focus-outline-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mdc-outlined-text-field-focus-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-option-selected-state-label-text-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-datepicker-toggle-active-state-icon-color: rgba(
    174,
    15,
    10,
    1
  ) !important;
  --mdc-filled-text-field-focus-active-indicator-color: rgba(
    135,
    135,
    135,
    1
  ) !important;
  --mat-sidenav-content-background-color: white !important;
}

/* You can add global styles to this file, and also import other style files */
/* Angular 15 adds grey background on mat form components */
/* below removes that background color */
/* Manipulate initial background color*/
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

/*Manipulate background color on hover and focus*/
.mat-mdc-form-field-focus-overlay {
  background-color: transparent !important;
}

.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {
  width: 0px;
  padding-left: 6px;
  padding-right: 6px;
}
.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted span {
  display: none;
}

/* Pagination menu */
.g-bubble-container {
  display: flex;
  gap: 4px;
  margin-left: 8px;
}

.g-bubble {
  background-color: rgb(245, 246, 249);
  border-radius: 4px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(34, 36, 40) !important;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;
  text-align: center;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

.g-bubble:hover {
  background-color: rgb(189, 188, 188);
  color: rgb(245, 246, 249);
}

.g-bubble__active {
  background-color: rgb(227, 6, 19);
  color: rgb(227, 227, 227) !important;
  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12), 0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);
}

mat-paginator {
  background: transparent !important;
}

.mat-mdc-paginator-range-actions {
  margin-right: 12px !important;
}

.mat-mdc-paginator-container {
  justify-content: center !important;
}

.mat-mdc-paginator-navigation-next,
.mat-mdc-paginator-navigation-previous {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: rgb(34, 36, 40) !important;
  padding: 0 !important;
  border-radius: 4px !important;
  width: 34px !important;
  height: 34px !important;
  background-color: rgb(245, 246, 249) !important;
  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);
}

/* End of pagination menu */
body {
  margin: 0;
}

.snackbar {
  width: 50vw;
  margin: 10px 0px !important;
}
.snackbar .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
}
.snackbar .mdc-snackbar__label {
  color: black !important;
}
.snackbar .mat-icon {
  margin-right: 12px;
}

.snackbar-custom {
  width: 50vw;
  margin-top: 75px !important;
}

.snacbar-warning {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-warning .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid #e0ac08;
}
.snacbar-warning .mdc-snackbar__label {
  color: black !important;
}
.snacbar-warning .mat-icon {
  margin-right: 12px;
}

.snacbar-sucess {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-sucess .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid green;
}
.snacbar-sucess .mdc-snackbar__label {
  color: black !important;
}
.snacbar-sucess .mat-icon {
  margin-right: 12px;
}

.snacbar-error {
  width: 50vw;
  margin: 10px 0px;
}
.snacbar-error .mdc-snackbar__surface {
  background-color: rgb(245, 246, 249) !important;
  border-radius: 10px !important;
  width: 33vw;
  border: 1px solid red;
}
.snacbar-error .mdc-snackbar__label {
  color: black !important;
}
.snacbar-error .mat-icon {
  margin-right: 12px;
}

.flex {
  display: flex;
}

.mat-mdc-menu-panel {
  overflow: hidden !important;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .menu-header {
  font-size: 12px;
  padding: 1rem;
  padding-bottom: 0.25rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item {
  margin-left: 1rem;
  padding-left: 0;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:first-of-type {
  margin-top: 0.75rem;
}
.mat-mdc-menu-panel .mat-mdc-menu-content .mat-mdc-menu-item:not(:last-child) {
  border-bottom: 1px solid rgb(189, 188, 188);
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 3000;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sort-icon-container {
  display: inline-flex;
  align-items: center;
}
.sort-icon-container mat-icon {
  height: 1rem;
  width: 1rem;
}

@media (max-width: 767px) {
  app-edit-contract .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}

.btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(174, 15, 10);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40%;
    height: 45px;
  }
}
.btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
  background: white;
  color: rgb(174, 15, 10);
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-secondary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}
.btn-secondary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}

.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(189, 188, 188);
  color: white;
  width: 14rem;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 767px) {
  .btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    width: 100%;
    height: 45px;
  }
}

/* 
  IONIC components
*/
ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-item.no-padding-full {
  --padding-end: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  --inner-padding-start: 0;
}

ion-checkbox {
  --checkbox-background-checked: rgba(174, 15, 10, 1);
  --border-color-checked: rgba(174, 15, 10, 1);
}

ion-input.custom-input {
  --border-color: rgba(135, 135, 135, 1);
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.custom-input-user {
  --border-color: #EFEFEF;
  --padding-top: 5px;
  --highlight-color: rgba(135, 135, 135, 1);
}

ion-input.width-full {
  --border-color: #EFEFEF !important;
  --padding-top: 5px;
  --highlight-color: rgb(37, 19, 19);
}

.filter-panel {
  max-width: 100vw !important;
}

.date-select-modal-filter .mdc-text-field {
  height: 35px;
}
.date-select-modal-filter .mat-mdc-form-field-infix {
  height: 35px;
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
.date-select-modal-filter .select-year .mat-mdc-text-field-wrapper {
  background-color: #f4f4f4;
  border: 1px solid rgb(189, 188, 188);
}
.date-select-modal-filter .mdc-notched-outline__leading {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__notch {
  border: none !important;
}
.date-select-modal-filter .mdc-notched-outline__trailing {
  border: none !important;
}

@media (min-width: 1025px) {
  .filter-panel {
    max-height: 33rem !important;
    min-width: 60vw;
  }
  .anotation-panel {
    max-width: 30rem !important;
    max-height: 30rem !important;
    min-width: 50vw;
  }
  .historic-panel {
    min-width: 49.5rem;
    min-height: 35.625rem;
    min-width: 50vw;
  }
  .segments-panel {
    width: 72vw;
    min-width: 760px;
    max-width: 1100px !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    min-width: 49.5rem;
    min-height: 23.625rem;
    min-width: 50vw;
  }
}
@media (max-width: 1024px) {
  .btn-actions {
    margin-right: 15px;
  }
  .filter-panel {
    min-height: 30rem;
    max-width: 100vw !important;
    min-width: 90vw;
  }
  .historic-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
  .segments-panel {
    max-width: 90vw !important;
    min-width: 90vw !important;
    max-height: 90vh !important;
  }
  .new-highway-modal-panel {
    max-width: 49.5rem;
    min-width: 90vw !important;
  }
}
@media (max-width: 1024px) {
  .anotation-panel {
    width: 90%;
  }
}
.mdc-text-field--filled:not(.mdc-text-field--disabled) {
  background-color: transparent !important;
}

@media (max-width: 1024px) {
  .mat-mdc-form-field-label {
    font-size: 0.8rem;
    /* Tamanho de fonte para dispositivos móveis */
  }
}
.button_cad {
  background-color: rgb(174, 15, 10);
  padding: 0.5rem 2rem;
  border-radius: 0.5rem;
  color: #fff;
  font-style: none;
  text-decoration: none;
}
.button_cad mat-icon {
  color: #fff !important;
}

::ng-deep.mat-mdc-card-header-text {
  display: none !important;
}

.input-error {
  border: 1px solid red; /* Ajuste o estilo conforme necessário */
}

.card-mobile {
  min-height: 10rem;
  margin: 1rem auto;
  border: 1px solid #cdcdcd;
}
.card-mobile .mat-mdc-card-header {
  width: 90%;
  display: flex;
  margin: auto;
  justify-content: space-between;
  padding: 0rem;
}
.card-mobile .mat-mdc-card-header p {
  font-weight: bolder;
  font-size: 1.2rem;
  text-transform: uppercase;
}
.card-mobile .mat-mdc-card-header span,
.card-mobile .mat-mdc-card-header .subtitle {
  font-size: 1rem;
  font-weight: normal;
  color: #cdcdcd;
}
@media (max-width: 1024px) {
  .card-mobile .mat-mdc-card-header {
    width: 100%;
    margin: 0 16px;
  }
}
.card-mobile .mat-mdc-card-footer {
  margin: 1rem 0rem;
  border-top: 1px solid black;
  display: flex;
  align-items: center;
}
.card-mobile .mat-mdc-card-footer button {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.card-mobile .extension {
  font-weight: bold;
  color: rgb(174, 15, 10);
}
@media (max-width: 1024px) {
  .card-mobile .formatAnotation {
    padding: 0 16px;
  }
}
.card-mobile .content-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-mobile .content-status {
  width: 40%;
  align-items: center;
  display: flex;
  flex-direction: column;
}
.card-mobile .content-status p {
  font-weight: bold;
}

.card-mobile-empty {
  border: 1px solid #cdcdcd;
  display: flex;
  align-items: center;
  justify-content: center;
}

ion-button.more-filters-btn {
  --background: rgba(174, 15, 10, 1);
  --color: white;
  --border-radius: 10px;
  width: 100%;
  max-width: 15rem;
  text-transform: capitalize;
  font-size: 0.9rem;
  height: 100%;
  font-weight: 600;
  letter-spacing: 0.08em;
}

ion-item.fast-filters {
  padding: 0.25rem 0rem;
}

ion-chip.fast-filter-active-primary {
  background-color: rgb(40, 186, 98);
  color: white;
}

ion-chip.fast-filter-active-secondary {
  background-color: rgb(235, 68, 90);
  color: white;
}

ion-chip.fast-filter-active-primary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

ion-chip.fast-filter-active-secondary-contract {
  color: #AE0F0A;
  border: 1px solid #AE0F0A;
  background: #E4ADB5;
}

.more-filters-btn-row {
  justify-content: center;
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.more-filters-btn-row button {
  margin: 5px;
}
@media (max-width: 767px) {
  .more-filters-btn-row button {
    margin: 5px 0;
  }
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

ion-textarea,
ion-input {
  --border-color: rgba(87, 87, 86, 1);
  --padding-top: 5px !important;
  --highlight-color: rgba(135, 135, 135, 1);
  --highlight-color-focused: rgba(135, 135, 135, 1) !important;
  --highlight-color-valid: rgba(135, 135, 135, 1) !important;
  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;
}

ion-alert.custom-alert {
  --backdrop-opacity: 0.7;
}

ion-list.filtered-list {
  display: flex;
  flex-wrap: wrap;
}
ion-list.filtered-list span {
  padding: 0.75rem 0;
  margin: 0 0.75rem;
  border-bottom: 1px solid rgb(189, 188, 188);
  width: 100%;
}

ion-item.no-padding {
  --padding-end: 0;
  --padding-start: 0;
}

ion-toast.snackbar-toast {
  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
  --width: fit-content;
  --border-radius: 0.75rem;
  --white-space: pre-line;
}

ion-toast.snackbar-toast::part(container) {
  background: #fff;
  color: rgb(34, 36, 40);
  width: -moz-fit-content;
  width: fit-content;
  border-radius: 0.75rem;
}

ion-toast.snackbar-toast.toast-success::part(container) {
  border: 1px solid rgb(45, 211, 111);
}
ion-toast.snackbar-toast.toast-success::part(icon) {
  color: rgb(45, 211, 111);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-error::part(container) {
  border: 1px solid rgb(235, 68, 90);
}
ion-toast.snackbar-toast.toast-error::part(icon) {
  color: rgb(235, 68, 90);
  font-size: 1.25rem;
}

ion-toast.snackbar-toast.toast-right {
  --start: right;
  --box-shadow: none;
  --background: none;
}
ion-toast.snackbar-toast.toast-right::part(container) {
  transform: translateY(72px) !important;
  box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);
}

::ng-deep.mat-tab-label {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

/* Styles for the active tab label */
::ng-deep.mat-tab-label.mat-tab-label-active {
  min-width: 25px !important;
  padding: 5px;
  background-color: transparent;
  color: red !important;
  font-weight: 700;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border-color: #2b2b2b;
}

::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #2b2b2b;
}

.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {
  box-shadow: none !important;
}

.g-bubble {
  box-shadow: none !important;
}

app-modal-historic-segment {
  display: block;
  width: 100%;
  height: 45em;
}

.column-flex {
  display: flex;
  flex-flow: column;
}

.master-icon {
  background-color: rgb(255, 202, 34);
  color: rgb(34, 36, 40);
  border-radius: 10px;
  align-self: flex-start;
  font-size: 10px;
  padding: 0px 9px;
  margin: 6px 0;
  line-height: 17px;
  font-weight: 600;
}
.master-icon.center-horizontal {
  place-self: center;
}

ion-popover {
  --min-width: 375px;
  --max-width: 500px;
}

.custom-tooltip-menu {
  padding: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  border: 1px solid #e0e0e0;
  border-radius: 4px;
}
.custom-tooltip-menu .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {
  background: none;
}
.custom-tooltip-menu .mdc-evolution-chip__text-label {
  color: #c00;
}

.custom-tooltip-menu .filter-title {
  font-size: 12px;
  font-weight: bold;
  color: #333;
  display: block;
  margin-bottom: 4px;
  border-bottom: 1px solid grey;
}

.custom-tooltip-menu .tags {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.custom-tooltip-menu mat-chip {
  border: 1px solid #c00;
  height: 20px;
}

.custom-tooltip-menu mat-chip mat-icon {
  color: #c00 !important;
  cursor: pointer;
  font-size: 14px !important;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0px !important;
}

.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {
  color: #c00 !important;
  cursor: pointer;
  font-size: 12px !important;
  opacity: 1;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline {
  border: 1px solid #c00 !important;
}

::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {
  color: #c00 !important;
}

ion-toggle {
  --handle-background-checked: rgba(174, 15, 10, 1);
  --track-background-checked: rgba(174, 15, 10, 0.38);
}

app-list-contracts thead {
  background: #F4F4F4 !important;
}

app-table-default thead {
  background: #F4F4F4 !important;
}

.mat-expansion-panel-body {
  padding: 0px !important;
}

.mat-mdc-paginator-range-actions {
  overflow-wrap: anywhere !important;
  flex-grow: 1;
  justify-content: center !important;
  position: relative !important;
}

.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {
  position: absolute !important;
  left: 0 !important;
}

.mat-mdc-tab {
  background-color: #F4F4F4 !important;
}

.mdc-tab--active {
  background-color: white !important;
}

@media (max-width: 1025px) {
  #paginator {
    width: 100%;
  }
}

ion-icon.search-icon-absolute {
  position: absolute;
  left: 16px;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 3;
}

ion-input.search-input label.input-wrapper {
  --padding-start: 55px;
}
.mat-mdc-icon-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.mat-mdc-unelevated-button[disabled] {
  cursor: default;
  pointer-events: auto;
  opacity: 0.38;
}

.item-inner {
  padding-right: 0 !important;
}

@media (max-width: 496px) {
  .mat-mdc-paginator-page-size-label {
    display: none !important;
  }
}

.comentarios .mdc-text-field--outlined {
  --mdc-outlined-text-field-outline-width: 1px;
  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */
  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */
  --mdc-outlined-text-field-container-shape: 4px;
}

.g-0 {
  gap: 0 !important;
}

.g-1 {
  gap: 0.25rem !important;
}

.g-2 {
  gap: 0.5rem !important;
}

.g-3 {
  gap: 1rem !important;
}

.g-4 {
  gap: 1.5rem !important;
}

.g-5 {
  gap: 3rem !important;
}

.gx-0 {
  column-gap: 0 !important;
}

.gx-1 {
  column-gap: 0.25rem !important;
}

.gx-2 {
  column-gap: 0.5rem !important;
}

.gx-3 {
  column-gap: 1rem !important;
}

.gx-4 {
  column-gap: 1.5rem !important;
}

.gx-5 {
  column-gap: 3rem !important;
}

.gy-0 {
  row-gap: 0 !important;
}

.gy-1 {
  row-gap: 0.25rem !important;
}

.gy-2 {
  row-gap: 0.5rem !important;
}

.gy-3 {
  row-gap: 1rem !important;
}

.gy-4 {
  row-gap: 1.5rem !important;
}

.gy-5 {
  row-gap: 3rem !important;
}

.col {
  flex: 1 0 0%;
  max-width: 100%;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.col-1 {
  flex: 0 0 6.333333%;
  max-width: 6.333333%;
}

.col-2 {
  flex: 0 0 14.666667%;
  max-width: 14.666667%;
}

.col-3 {
  flex: 0 0 23%;
  max-width: 23%;
}

.col-4 {
  flex: 0 0 31.333333%;
  max-width: 31.333333%;
}

.col-5 {
  flex: 0 0 39.666667%;
  max-width: 39.666667%;
}

.col-6 {
  flex: 0 0 48%;
  max-width: 48%;
}

.col-7 {
  flex: 0 0 56.333333%;
  max-width: 56.333333%;
}

.col-8 {
  flex: 0 0 64.666667%;
  max-width: 64.666667%;
}

.col-9 {
  flex: 0 0 73%;
  max-width: 73%;
}

.col-10 {
  flex: 0 0 81.333333%;
  max-width: 81.333333%;
}

.col-11 {
  flex: 0 0 89.666667%;
  max-width: 89.666667%;
}

.col-12 {
  flex: 0 0 98%;
  max-width: 98%;
}

/* Colunas responsivas */
@media (min-width: 576px) { /* sm */
  .col-sm-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-sm-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-sm-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-sm-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-sm-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-sm-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-sm-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-sm-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-sm-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-sm-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-sm-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-sm-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 768px) { /* md */
  .col-md-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-md-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-md-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-md-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-md-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-md-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-md-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-md-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-md-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-md-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-md-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
@media (min-width: 992px) { /* lg */
  .col-lg-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-lg-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-lg-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-lg-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-lg-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-lg-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-lg-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-lg-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-lg-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-lg-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-lg-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-lg-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1200px) { /* xl */
  .col-xl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
@media (min-width: 1400px) { /* xxl */
  .col-xxl-1 {
    flex: 0 0 6.333333%;
    max-width: 6.333333%;
  }
  .col-xxl-2 {
    flex: 0 0 14.666667%;
    max-width: 14.666667%;
  }
  .col-xxl-3 {
    flex: 0 0 23%;
    max-width: 23%;
  }
  .col-xxl-4 {
    flex: 0 0 31.333333%;
    max-width: 31.333333%;
  }
  .col-xxl-5 {
    flex: 0 0 39.666667%;
    max-width: 39.666667%;
  }
  .col-xxl-6 {
    flex: 0 0 48%;
    max-width: 48%;
  }
  .col-xxl-7 {
    flex: 0 0 56.333333%;
    max-width: 56.333333%;
  }
  .col-xxl-8 {
    flex: 0 0 64.666667%;
    max-width: 64.666667%;
  }
  .col-xxl-9 {
    flex: 0 0 73%;
    max-width: 73%;
  }
  .col-xxl-10 {
    flex: 0 0 81.333333%;
    max-width: 81.333333%;
  }
  .col-xxl-11 {
    flex: 0 0 89.666667%;
    max-width: 89.666667%;
  }
  .col-xxl-12 {
    flex: 0 0 98%;
    max-width: 98%;
  }
}
.ampliacao-panel {
  max-width: 60vw !important;
}

.popover-content {
  max-height: 150px;
}

app-form-projetos thead tr th {
  font-family: "Barlow", sans-serif !important;
  font-weight: 500 !important;
  font-size: 18px !important;
  line-height: 100% !important;
}

app-form-projetos .mat-mdc-header-cell {
  border: none !important;
}

app-form-projetos .mat-mdc-form-field-subscript-wrapper {
  display: none;
}

.mdc-checkbox .mdc-checkbox__native-control:enabled:checked ~ .mdc-checkbox__background {
  border-color: #AE0F0A !important;
  background-color: #AE0F0A !important;
}

.field-width {
  width: 70%;
}
@media (max-width: 1024px) {
  .field-width {
    width: 90%;
    margin-left: 15px;
  }
}

.text {
  width: 100%;
  padding-left: 1rem;
}
.text p {
  font-size: 0.8rem;
}

.status-container {
  display: flex;
  align-items: center;
}
.status-container .mat-icon {
  width: 1rem;
}
.status-container .status-icon {
  font-size: 8px;
  align-content: center;
  text-align: center;
}
.status-container .active {
  color: rgb(40, 186, 98);
}
.status-container .inactive {
  color: rgb(235, 68, 90);
}

.login-container {
  display: flex;
}
@media (max-width: 1024px) {
  .login-container {
    flex-direction: column;
  }
}

.form-container {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
}

.bold-font {
  font-weight: bold;
  font-size: 1rem;
}

.login-form {
  width: 100%;
  margin-bottom: 10rem;
  padding: 0 8rem;
}
@media (max-width: 1024px) {
  .login-form {
    height: 92vh;
  }
}
.login-form form {
  height: inherit;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .login-form form {
    height: 92vh;
  }
}
.login-form .fields {
  width: 100%;
  flex: 1;
  min-height: 55vh;
}
@media (max-width: 1024px) {
  .login-form .fields {
    width: 100%;
  }
}
.login-form .subtitle {
  border-bottom: 1px solid black;
  margin: 1rem 0rem;
}
.login-form .subtitle h6 {
  margin: 0rem;
}
.login-form .line {
  display: flex;
  justify-content: center;
}
.login-form .line hr {
  border: none;
  height: 2px;
  background-color: #bdbcbc;
  width: 80%;
  border-radius: 5px;
}
@media (max-width: 1024px) {
  .login-form .line hr {
    width: 100%;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
  background: rgb(0, 87, 158);
  color: white;
  border-radius: 10px;
  padding: 0.75rem 0;
  border: none;
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed {
    margin-top: 15px;
    margin-right: 0 !important;
    width: 40% !important;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
  background: white;
  color: rgb(174, 15, 10);
  border-radius: 10px;
  padding: 0.75rem 0;
  border: 2px solid rgb(174, 15, 10);
  font-weight: bold;
  margin-top: 2.5rem;
  align-self: center;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {
    margin-top: 15px;
    width: 40%;
    height: 45px;
  }
}
.login-form .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2)[disabled] {
  background: rgb(189, 188, 188);
}
.login-form .name-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .invalid {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 15px;
}
@media (max-width: 1024px) {
  .login-form .invalid {
    margin-left: 5px;
  }
}
.login-form .invalid .icon-error {
  padding-left: 10px;
  padding-right: 8px;
}
.login-form .login-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-form-field {
  text-align: center;
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix {
  color: rgb(60, 60, 59);
}
.login-form .email-field-prefix-invalid {
  padding-top: 7px;
  padding-bottom: 15px;
  color: rgb(60, 60, 59);
}
.login-form h6 {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-form h6 mat-icon {
  cursor: pointer;
}
@media (max-width: 1024px) {
  .login-form h6 {
    margin-top: 2rem;
    margin-bottom: 2rem;
  }
}
.login-form .buttons {
  width: 100%;
  padding-bottom: 1rem;
  display: flex;
  justify-content: center;
  margin-top: 32px;
}
.login-form .buttons .back {
  width: 33%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 20px;
}
.login-form .buttons .back img {
  margin-right: 10px;
  cursor: pointer;
}
.login-form .buttons .actions {
  width: 77%;
  display: flex;
  justify-content: start;
  align-items: center;
}
.login-form .buttons .actions button {
  margin: 0% 15px !important;
}
@media (max-width: 1024px) {
  .login-form .buttons {
    flex-direction: column;
  }
}
.login-form .buttons button:first-of-type {
  margin-right: 10px;
  width: 40% !important;
}

.buttons {
  width: 100%;
  padding-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  margin-top: 32px;
}
.buttons .back {
  width: 30%;
  display: flex;
  justify-content: start;
  align-items: center;
  margin-left: 20px;
}
@media (max-width: 1024px) {
  .buttons .back {
    margin-left: 20px;
  }
}
.buttons .back img {
  margin-right: 10px;
  cursor: pointer;
}
@media (max-width: 1024px) {
  .buttons {
    flex-direction: column;
  }
}
.buttons button:first-of-type {
  margin-right: 10px;
}

.first-input {
  width: 100%;
}

.mat-expansion-panel-header-title {
  font-size: 1rem;
}

.panel-with-border .mat-expansion-panel-header {
  border-bottom: 1px solid black;
  /* Estilo da borda quando o painel está aberto */
}

.panel-with-border .mat-expansion-panel-header.mat-expanded {
  border-bottom: none;
  /* Remove a borda inferior quando o painel está aberto */
}

.panel-with-border.mat-expansion-panel {
  border-bottom: 1px solid black;
  /* Estilo da borda do painel quando fechado */
}

.mat-expansion-panel {
  box-shadow: none !important;
  background-color: transparent;
  border-radius: 0;
}

.mat-mdc-select-arrow-wrapper {
  display: none !important;
}

/* Estilizar o novo ícone */
.custom-select-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 24px;
  /* Ajuste o tamanho do ícone conforme necessário */
}

.form-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.form-group .mat-mdc-form-field {
  width: 45%;
}
.form-group .first-input {
  width: 100%;
}
.form-group .date-input {
  width: 20%;
}
.form-group .bank-form-field {
  width: 70%;
}
.form-group p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.form-group-row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group-row .mat-mdc-form-field {
  width: 30%;
}
.form-group-row .first-input {
  width: 100%;
}
.form-group-row .bank-form-field {
  width: 70%;
}
.form-group-row p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.form-group-row2 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.form-group-row2 .mat-mdc-form-field {
  width: 20%;
}
.form-group-row2 .first-input {
  width: 100%;
}
.form-group-row2 .bank-form-field {
  width: 70%;
}
.form-group-row2 p {
  margin-top: 0px;
  font-size: 1.1rem;
}

.date-select {
  width: 30%;
  display: flex;
}
.date-select .mat-mdc-form-field {
  width: 70%;
}
.date-select .select-year {
  width: 30%;
}

.btn-primary {
  margin: 1rem 0rem;
}

.btn-exclude {
  border: 2px solid rgb(112, 111, 111) !important;
  background-color: transparent !important;
  color: rgb(112, 111, 111) !important;
  font-weight: bold !important;
}

.btn-submit {
  background-color: rgb(174, 15, 10) !important;
  color: #fff !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.disabled-button {
  background-color: rgb(112, 111, 111) !important;
  color: white;
  border: 2px solid rgb(112, 111, 111) !important;
  cursor: not-allowed;
}

.btn-submit {
  background-color: transparent !important;
  color: rgb(174, 15, 10) !important;
  border: 2px solid rgb(174, 15, 10) !important;
}

.header-form {
  display: flex;
  flex-direction: column;
}
.header-form .header-title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-form .header-title h6 {
  margin: 0px;
  width: 80%;
  font-size: 32px;
}
@media (max-width: 1024px) {
  .header-form .header-title h6 {
    font-size: 18px;
    text-align: center;
  }
}
.header-form .header-title h5 {
  font-size: 24px;
  margin-top: 10px;
  margin-bottom: 0px;
  color: #706f6f;
}
@media (max-width: 1024px) {
  .header-form .header-title h5 {
    font-size: 14px;
    text-align: center;
  }
}
.header-form .header-title h6 {
  margin-bottom: 0px;
}
.header-form .header-title .btn-header {
  display: flex;
  align-items: center;
}

.status-cadastrando {
  background-color: rgb(219, 151, 5);
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-aprovado {
  background-color: green;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-rejeitado {
  background-color: red;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.status-desconhecido {
  background-color: gray;
  color: #fff;
  padding: 0.2rem 2rem;
  border-radius: 0.3rem;
}

.mat-mdc-expansion-panel-body {
  padding: 0px !important;
}

.data-eficacia-form-group {
  display: flex;
  align-items: center;
  width: 30%;
}
.data-eficacia-form-group .mat-mdc-form-field {
  width: 90%;
}

.form-section-field {
  margin: 2rem auto;
}

.header-legend {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.header-legend .first-filter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header-legend .first-filter .mat-mdc-form-field {
  width: 90%;
}
.header-legend .first-filter .btn {
  padding: 1rem 2rem;
  background-color: rgb(227, 6, 19);
  color: #fff;
  border-radius: 0.5rem;
  cursor: pointer;
  border: none;
}
.header-legend .first-filter .btn:hover {
  background-color: rgb(174, 15, 10);
}

.header-form {
  width: 100%;
  display: flex;
}
.header-form h6 {
  width: 80%;
}

.bredCrumb {
  margin: 1rem 0rem;
  align-items: center;
  justify-content: flex-start;
}

.bredCrumb p {
  display: inline;
  cursor: pointer;
}

.bredCrumb p.selected {
  font-weight: bold;
}

.anexos {
  display: flex;
  align-items: center;
}

@media (max-width: 1024px) {
  .form-group-row,
  .form-group {
    flex-direction: column;
  }
  .form-group-row .mat-mdc-form-field,
  .form-group .mat-mdc-form-field {
    width: 100%;
  }
  .data-eficacia-form-group {
    width: 100%;
  }
  .date-select {
    width: 100%;
  }
  .fields {
    flex: 1;
    min-height: auto !important;
  }
  .first-filter {
    flex-direction: column;
    width: 100%;
  }
  .first-filter .mat-mdc-form-field {
    width: 100%;
  }
  .first-filter .btn {
    margin: 1rem 0rem;
    width: 90%;
  }
  .filters {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }
  .filters .mat-mdc-form-field {
    width: 100%;
  }
  .login-form {
    width: 90% !important;
    margin: auto;
  }
  .buttons {
    width: 100%;
    align-items: center;
    margin: 0rem auto;
    margin-top: 24px;
  }
}
@media (max-width: 1024px) {
  .bredCrumb {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
}
.container-interveniente {
  border-radius: 1rem 1rem 0rem 0rem;
}
@media (max-width: 1024px) {
  .container-interveniente {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.container-interveniente .title {
  font-size: 1.2rem;
  font-weight: 700;
}
.container-interveniente .header-container {
  border-bottom: 1px solid;
}
.container-interveniente .header-container h3 {
  font-size: 1.2rem;
  margin: 0rem;
}
.container-interveniente .filters {
  width: 100%;
  display: flex;
  flex-direction: column;
}
.container-interveniente .filters .row {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.container-interveniente .filters .row .mat-mdc-form-field {
  width: 80%;
}
.container-interveniente .filters .more-filters {
  display: flex;
  justify-content: flex-end;
}
.container-interveniente .filters .more-filters .mat-mdc-form-field:first-child {
  margin-right: 2rem;
}
@media (max-width: 1024px) {
  .container-interveniente .filters .more-filters .mat-mdc-form-field:first-child {
    margin-right: 0;
  }
}
@media (max-width: 1024px) {
  .container-interveniente .filters .more-filters {
    width: 96%;
    display: flex;
    flex-direction: column;
  }
}
.container-interveniente .filters button {
  cursor: pointer;
  padding: 1rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
}

table {
  width: 100%;
}

th {
  font-weight: 700;
}

.entitie-list-table-wrapper {
  overflow: auto;
}
.entitie-list-table-wrapper th {
  cursor: pointer;
}
@media (max-width: 1024px) {
  .entitie-list-table-wrapper {
    width: 96%;
  }
}

.document-container {
  border-radius: 1rem 1rem 0rem 0rem;
}
@media (max-width: 1024px) {
  .document-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
}
.document-container .title-document {
  font-size: 1.2rem;
  font-weight: 700;
}
.document-container .header-document {
  display: flex;
  align-items: center;
}
.document-container .header-document span {
  margin-left: 1rem;
}
.document-container .header-document .button-add {
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
}

@media (max-width: 1024px) {
  .btn-doc {
    margin: 0 !important;
    font-weight: 500;
  }
  .bredCrumb {
    align-items: flex-start;
  }
  .header-document {
    display: flex;
    flex-direction: column;
    align-items: flex-start !important;
    width: 96%;
  }
  .header-document span {
    margin: 1rem 0rem;
    margin-left: 0px !important;
  }
  .row {
    margin: 1rem auto;
    flex-direction: column;
  }
  .row .mat-mdc-form-field {
    width: 100% !important;
  }
  .row button {
    width: 100%;
  }
}
.legend {
  border-bottom: 1px solid black;
  padding: 1rem;
  font-weight: bold;
  margin: 1rem auto;
  display: flex;
}
.legend .btn-adc {
  display: flex;
  margin-left: 16px;
  font-family: "Barlow", sans-serif !important;
  min-width: 150px;
}
@media (max-width: 1024px) {
  .legend {
    margin: 0rem;
    width: 96%;
  }
}

.header {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.header .mat-mdc-form-field {
  width: 100% !important;
}
.header .filtered-more-options {
  width: 75%;
  display: flex;
  flex-direction: column;
}
@media (max-width: 1024px) {
  .header .filtered-more-options {
    width: 96%;
  }
}
.header .filtered-more-options .mat-mdc-form-field {
  width: 100% !important;
}
.header .filtered-more-options .row-filter button {
  cursor: pointer;
  padding: 1rem 2rem;
  background-color: rgb(174, 15, 10);
  color: #fff;
  border: none;
  border-radius: 0.6rem;
  width: 100%;
}
@media (max-width: 1024px) {
  .header {
    margin: 16px 0px;
  }
}

@media (min-width: 1025px) {
  .header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  .header .mat-mdc-form-field {
    width: 20% !important;
  }
  .header .filtered-more-options {
    width: 75%;
  }
  .header .filtered-more-options .mat-mdc-form-field {
    width: 70% !important;
  }
  .header .filtered-more-options .row-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .header .filtered-more-options .row-filter button {
    margin: 1rem;
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.tab-label-wrap {
  white-space: normal;
  word-break: break-word;
  text-align: center; /* opcional, só se quiser centralizar */
}

.prazos-form {
  padding: 1rem 0;
}

.prazos-content-wrapper {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
}
.prazos-content-wrapper .prazos-actions-side {
  display: flex;
  align-items: center;
  padding-top: 4px;
}
.prazos-content-wrapper .prazos-actions-side .prazo-separator {
  color: #bbb;
  font-size: 20px;
  line-height: 1;
  margin-right: 4px;
}
.prazos-content-wrapper .prazos-actions-side .btn-historico-prazo {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #757575;
  font-family: "Barlow", sans-serif;
  font-weight: normal;
}
.prazos-content-wrapper .prazos-actions-side .btn-historico-prazo mat-icon {
  font-size: 18px;
  height: 18px;
  width: 18px;
  color: #757575;
}

.prazo-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
  flex-wrap: wrap;
}
.prazo-row .prazo-label {
  width: 90px;
  font-weight: bold;
  font-family: "Barlow", sans-serif;
}
.prazo-row .prazo-input-group {
  display: flex;
  align-items: center;
  gap: 8px;
}
.prazo-row .prazo-input-group .prazo-dias-field {
  width: 90px;
}
.prazo-row .prazo-input-group .dias-text {
  font-family: "Barlow", sans-serif;
  color: #555;
}

.prazo-save-container {
  margin-top: 16px;
  padding: 8px 0;
}
.prazo-save-container .btn-save-prazo {
  color: rgb(174, 15, 10);
  font-family: "Barlow", sans-serif;
  font-weight: bold;
}
.prazo-save-container .btn-save-prazo mat-icon {
  margin-right: 4px;
}
.prazo-save-container .btn-save-prazo:disabled {
  opacity: 0.5;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/components/contracts/edit-contract/edit-contract.component.scss","webpack://./node_modules/@angular/material/core/ripple/_ripple.scss","webpack://./node_modules/@angular/cdk/a11y/_index.scss","webpack://./node_modules/@angular/cdk/overlay/_index.scss","webpack://./node_modules/@angular/cdk/text-field/_index.scss","webpack://./node_modules/@angular/material/core/focus-indicators/_private.scss","webpack://./node_modules/@angular/material/core/style/_layout-common.scss","webpack://./src/theme/variables.scss","webpack://./src/theme/typography.scss","webpack://./src/theme/spacing.scss","webpack://./src/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACKd;EACE,gBAAA;EAIA,kBAAA;ADAJ;ACOI;EACE,wBAAA;ADLN;;ACSE;EACE,iBAAA;ADNJ;;ACSE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADVJ;AEyBI;EDXE,aAAA;ADXN;;AEzBE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AFgBJ;AEdI;EACE,UAAA;EACA,QAAA;AFgBN;;AGhCE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AHgCJ;;AG5BE;EACE,eAAA;EACA,aA3BwB;AH0D5B;AG7BI;EAGE,aAAA;AH6BN;;AGrBE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AHkElB;;AGpBE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AHkBJ;;AGfE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AHgBJ;AGdI;EACE,UAAA;AHgBN;AGXM;EAGE,YAAA;AHWR;;AGNE;EACE,+BAtFqB;AH+FzB;;AGNE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHQJ;AGFI;EACE,UAAA;EACA,mBAAA;AHIN;;AGAE;EACE,gBAAA;AHGJ;;AGEE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHRJ;;AGYE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHjBJ;;AIhIE;EACE,YAAA;AJmIJ;;AI7HE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJiIJ;;AIxHE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJ4HJ;;AIlHE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJmHJ;;AIhHE;EAEE,6CAAA;AJkHJ;;AKjJE;EACE,kBAAA;ALoJJ;AKlJI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;AL6IN;AKrII;EACE,WAAA;ALuIN;;AE5FM;EG7BA,oCAAA;AL6HN;;AKxKE;EACE,kBAAA;AL2KJ;AKzKI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;ALoKN;AK5JI;EACE,WAAA;AL8JN;;AEnHM;EG7BA,wCAAA;ALoJN;;AO7MA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;;;;;;EAME,qCAAA;EACA,gBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;ARoNF;;AQjNA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;ARoNF;;AQjNA;EACE,gBAAA;EACA,eAAA;ARoNF;;AOtRA;;;;;CAAA;AEeE;EACE,YAAA;ATgRJ;;AS9QE;EACE,gBAAA;ATiRJ;;AS/QE;EACE,kBAAA;ATkRJ;;AShRE;EACE,mBAAA;ATmRJ;;ASjRE;EACE,iBAAA;AToRJ;;ASlRE;EACE,iBAAA;EACA,kBAAA;ATqRJ;;ASnRE;EACE,gBAAA;EACA,mBAAA;ATsRJ;;ASnRE;EACE,WAAA;ATsRJ;;ASpRE;EACE,eAAA;ATuRJ;;ASrRE;EACE,iBAAA;ATwRJ;;AStRE;EACE,kBAAA;ATyRJ;;ASvRE;EACE,gBAAA;AT0RJ;;ASxRE;EACE,gBAAA;EACA,iBAAA;AT2RJ;;ASzRE;EACE,eAAA;EACA,kBAAA;AT4RJ;;ASzUE;EACE,YAAA;AT4UJ;;AS1UE;EACE,gBAAA;AT6UJ;;AS3UE;EACE,kBAAA;AT8UJ;;AS5UE;EACE,mBAAA;AT+UJ;;AS7UE;EACE,iBAAA;ATgVJ;;AS9UE;EACE,iBAAA;EACA,kBAAA;ATiVJ;;AS/UE;EACE,gBAAA;EACA,mBAAA;ATkVJ;;AS/UE;EACE,WAAA;ATkVJ;;AShVE;EACE,eAAA;ATmVJ;;ASjVE;EACE,iBAAA;AToVJ;;ASlVE;EACE,kBAAA;ATqVJ;;ASnVE;EACE,gBAAA;ATsVJ;;ASpVE;EACE,gBAAA;EACA,iBAAA;ATuVJ;;ASrVE;EACE,eAAA;EACA,kBAAA;ATwVJ;;ASrYE;EACE,aAAA;ATwYJ;;AStYE;EACE,iBAAA;ATyYJ;;ASvYE;EACE,mBAAA;AT0YJ;;ASxYE;EACE,oBAAA;AT2YJ;;ASzYE;EACE,kBAAA;AT4YJ;;AS1YE;EACE,kBAAA;EACA,mBAAA;AT6YJ;;AS3YE;EACE,iBAAA;EACA,oBAAA;AT8YJ;;AS3YE;EACE,YAAA;AT8YJ;;AS5YE;EACE,gBAAA;AT+YJ;;AS7YE;EACE,kBAAA;ATgZJ;;AS9YE;EACE,mBAAA;ATiZJ;;AS/YE;EACE,iBAAA;ATkZJ;;AShZE;EACE,iBAAA;EACA,kBAAA;ATmZJ;;ASjZE;EACE,gBAAA;EACA,mBAAA;AToZJ;;ASjcE;EACE,aAAA;ATocJ;;ASlcE;EACE,iBAAA;ATqcJ;;ASncE;EACE,mBAAA;ATscJ;;ASpcE;EACE,oBAAA;ATucJ;;ASrcE;EACE,kBAAA;ATwcJ;;AStcE;EACE,kBAAA;EACA,mBAAA;ATycJ;;ASvcE;EACE,iBAAA;EACA,oBAAA;AT0cJ;;ASvcE;EACE,YAAA;AT0cJ;;ASxcE;EACE,gBAAA;AT2cJ;;ASzcE;EACE,kBAAA;AT4cJ;;AS1cE;EACE,mBAAA;AT6cJ;;AS3cE;EACE,iBAAA;AT8cJ;;AS5cE;EACE,iBAAA;EACA,kBAAA;AT+cJ;;AS7cE;EACE,gBAAA;EACA,mBAAA;ATgdJ;;AS7fE;EACE,aAAA;ATggBJ;;AS9fE;EACE,iBAAA;ATigBJ;;AS/fE;EACE,mBAAA;ATkgBJ;;AShgBE;EACE,oBAAA;ATmgBJ;;ASjgBE;EACE,kBAAA;ATogBJ;;ASlgBE;EACE,kBAAA;EACA,mBAAA;ATqgBJ;;ASngBE;EACE,iBAAA;EACA,oBAAA;ATsgBJ;;ASngBE;EACE,YAAA;ATsgBJ;;ASpgBE;EACE,gBAAA;ATugBJ;;ASrgBE;EACE,kBAAA;ATwgBJ;;AStgBE;EACE,mBAAA;ATygBJ;;ASvgBE;EACE,iBAAA;AT0gBJ;;ASxgBE;EACE,iBAAA;EACA,kBAAA;AT2gBJ;;ASzgBE;EACE,gBAAA;EACA,mBAAA;AT4gBJ;;ASzjBE;EACE,aAAA;AT4jBJ;;AS1jBE;EACE,iBAAA;AT6jBJ;;AS3jBE;EACE,mBAAA;AT8jBJ;;AS5jBE;EACE,oBAAA;AT+jBJ;;AS7jBE;EACE,kBAAA;ATgkBJ;;AS9jBE;EACE,kBAAA;EACA,mBAAA;ATikBJ;;AS/jBE;EACE,iBAAA;EACA,oBAAA;ATkkBJ;;AS/jBE;EACE,YAAA;ATkkBJ;;AShkBE;EACE,gBAAA;ATmkBJ;;ASjkBE;EACE,kBAAA;ATokBJ;;ASlkBE;EACE,mBAAA;ATqkBJ;;ASnkBE;EACE,iBAAA;ATskBJ;;ASpkBE;EACE,iBAAA;EACA,kBAAA;ATukBJ;;ASrkBE;EACE,gBAAA;EACA,mBAAA;ATwkBJ;;ASrnBE;EACE,aAAA;ATwnBJ;;AStnBE;EACE,iBAAA;ATynBJ;;ASvnBE;EACE,mBAAA;AT0nBJ;;ASxnBE;EACE,oBAAA;AT2nBJ;;ASznBE;EACE,kBAAA;AT4nBJ;;AS1nBE;EACE,kBAAA;EACA,mBAAA;AT6nBJ;;AS3nBE;EACE,iBAAA;EACA,oBAAA;AT8nBJ;;AS3nBE;EACE,YAAA;AT8nBJ;;AS5nBE;EACE,gBAAA;AT+nBJ;;AS7nBE;EACE,kBAAA;ATgoBJ;;AS9nBE;EACE,mBAAA;ATioBJ;;AS/nBE;EACE,iBAAA;ATkoBJ;;AShoBE;EACE,iBAAA;EACA,kBAAA;ATmoBJ;;ASjoBE;EACE,gBAAA;EACA,mBAAA;ATooBJ;;ASjrBE;EACE,aAAA;ATorBJ;;ASlrBE;EACE,iBAAA;ATqrBJ;;ASnrBE;EACE,mBAAA;ATsrBJ;;ASprBE;EACE,oBAAA;ATurBJ;;ASrrBE;EACE,kBAAA;ATwrBJ;;AStrBE;EACE,kBAAA;EACA,mBAAA;ATyrBJ;;ASvrBE;EACE,iBAAA;EACA,oBAAA;AT0rBJ;;ASvrBE;EACE,YAAA;AT0rBJ;;ASxrBE;EACE,gBAAA;AT2rBJ;;ASzrBE;EACE,kBAAA;AT4rBJ;;AS1rBE;EACE,mBAAA;AT6rBJ;;AS3rBE;EACE,iBAAA;AT8rBJ;;AS5rBE;EACE,iBAAA;EACA,kBAAA;AT+rBJ;;AS7rBE;EACE,gBAAA;EACA,mBAAA;ATgsBJ;;AS7uBE;EACE,aAAA;ATgvBJ;;AS9uBE;EACE,iBAAA;ATivBJ;;AS/uBE;EACE,mBAAA;ATkvBJ;;AShvBE;EACE,oBAAA;ATmvBJ;;ASjvBE;EACE,kBAAA;ATovBJ;;ASlvBE;EACE,kBAAA;EACA,mBAAA;ATqvBJ;;ASnvBE;EACE,iBAAA;EACA,oBAAA;ATsvBJ;;ASnvBE;EACE,YAAA;ATsvBJ;;ASpvBE;EACE,gBAAA;ATuvBJ;;ASrvBE;EACE,kBAAA;ATwvBJ;;AStvBE;EACE,mBAAA;ATyvBJ;;ASvvBE;EACE,iBAAA;AT0vBJ;;ASxvBE;EACE,iBAAA;EACA,kBAAA;AT2vBJ;;ASzvBE;EACE,gBAAA;EACA,mBAAA;AT4vBJ;;ASzyBE;EACE,aAAA;AT4yBJ;;AS1yBE;EACE,iBAAA;AT6yBJ;;AS3yBE;EACE,mBAAA;AT8yBJ;;AS5yBE;EACE,oBAAA;AT+yBJ;;AS7yBE;EACE,kBAAA;ATgzBJ;;AS9yBE;EACE,kBAAA;EACA,mBAAA;ATizBJ;;AS/yBE;EACE,iBAAA;EACA,oBAAA;ATkzBJ;;AS/yBE;EACE,YAAA;ATkzBJ;;AShzBE;EACE,gBAAA;ATmzBJ;;ASjzBE;EACE,kBAAA;ATozBJ;;ASlzBE;EACE,mBAAA;ATqzBJ;;ASnzBE;EACE,iBAAA;ATszBJ;;ASpzBE;EACE,iBAAA;EACA,kBAAA;ATuzBJ;;ASrzBE;EACE,gBAAA;EACA,mBAAA;ATwzBJ;;ASr2BE;EACE,aAAA;ATw2BJ;;ASt2BE;EACE,iBAAA;ATy2BJ;;ASv2BE;EACE,mBAAA;AT02BJ;;ASx2BE;EACE,oBAAA;AT22BJ;;ASz2BE;EACE,kBAAA;AT42BJ;;AS12BE;EACE,kBAAA;EACA,mBAAA;AT62BJ;;AS32BE;EACE,iBAAA;EACA,oBAAA;AT82BJ;;AS32BE;EACE,YAAA;AT82BJ;;AS52BE;EACE,gBAAA;AT+2BJ;;AS72BE;EACE,kBAAA;ATg3BJ;;AS92BE;EACE,mBAAA;ATi3BJ;;AS/2BE;EACE,iBAAA;ATk3BJ;;ASh3BE;EACE,iBAAA;EACA,kBAAA;ATm3BJ;;ASj3BE;EACE,gBAAA;EACA,mBAAA;ATo3BJ;;AUx6BA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVu6BF;;AUp6BA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA,iDAAA;AACA;EACE,wCAAA;AVu6BF;;AUp6BA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVu6BF;AUr6BE;EACE,aAAA;AVu6BJ;;AUn6BA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVs6BF;;AUn6BA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVs6BF;;AUl6BA;EACE,oCAAA;EACA,yBAAA;AVq6BF;;AUl6BA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AVq6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;EACE,6BAAA;AVo6BF;;AUj6BA;EACE,kCAAA;AVo6BF;;AUj6BA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AVo6BF;;AUh6BA,2BAAA;AAEA;EACE,SAAA;AVk6BF;;AU/5BA;EACE,WAAA;EACA,2BAAA;AVk6BF;AUh6BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AVk6BJ;AU/5BE;EACE,uBAAA;AVi6BJ;AU95BE;EACE,kBAAA;AVg6BJ;;AU55BA;EACE,WAAA;EACA,2BAAA;AV+5BF;;AU55BA;EACE,WAAA;EACA,gBAAA;AV+5BF;AU75BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AV+5BJ;AU55BE;EACE,uBAAA;AV85BJ;AU35BE;EACE,kBAAA;AV65BJ;;AUz5BA;EACE,WAAA;EACA,gBAAA;AV45BF;AU15BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AV45BJ;AUz5BE;EACE,uBAAA;AV25BJ;AUx5BE;EACE,kBAAA;AV05BJ;;AUt5BA;EACE,WAAA;EACA,gBAAA;AVy5BF;AUv5BE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVy5BJ;AUt5BE;EACE,uBAAA;AVw5BJ;AUr5BE;EACE,kBAAA;AVu5BJ;;AUn5BA;EACE,aAAA;AVs5BF;;AUn5BA;EACE,2BAAA;AVs5BF;AUn5BI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AVq5BN;AUl5BI;EACE,iBAAA;EACA,eAAA;AVo5BN;AUj5BI;EACE,mBAAA;AVm5BN;AUh5BI;EACE,2CAAA;AVk5BN;;AU74BA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AVg5BF;;AU74BA;EACE,oBAAA;EACA,mBAAA;AVg5BF;AU94BE;EACE,YAAA;EACA,WAAA;AVg5BJ;;AU34BI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EV+4BJ;AACF;;AU54BA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;AU94BE;EACE,8BAAA;AVg5BJ;;AU54BA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AV+4BF;AU74BE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EVg5BF;AACF;;AU74BA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AVg5BF;;AU74BA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AVg5BF;;AU94BA;EACE,mDAAA;EACA,4CAAA;AVi5BF;;AU94BA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AVi5BF;;AU/4BA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AVk5BF;;AUh5BA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AVm5BF;;AUj5BA;EACE,2BAAA;AVo5BF;;AUj5BE;EACE,YAAA;AVo5BJ;AUl5BE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AVo5BJ;AUj5BI;EACE,yBAAA;EACA,oCAAA;AVm5BN;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;AU/4BE;EACE,uBAAA;AVi5BJ;;AU74BA;EACE;IACE,4BAAA;IACA,eAAA;EVg5BF;EU74BA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EV+4BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;EU54BA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EV84BF;EU54BA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EV84BF;AACF;AU34BA;EACE;IACE,kBAAA;EV64BF;EU34BA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EV64BF;EU14BA;IACE,kBAAA;IACA,0BAAA;EV44BF;EU14BA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EV44BF;EU14BE;IACF,kBAAA;IACE,0BAAA;EV44BF;AACF;AUz4BA;EACE;IACE,UAAA;EV24BF;AACF;AUx4BA;EACE,wCAAA;AV04BF;;AUv4BA;EACE;IACE,iBAAA;IACA,8CAAA;EV04BF;AACF;AUv4BA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVy4BF;AUv4BE;EACE,sBAAA;AVy4BJ;;AUr4BA;EACE,wBAAA;AVw4BF;;AUt4BA;EACE,qBAAA,EAAA,wCAAA;AVy4BF;;AUv4BA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AV04BF;AUx4BE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVy4BJ;AUv4BI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVy4BN;AUt4BI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVw4BN;AUt4BI;EApBF;IAqBI,WAAA;IACA,cAAA;EVy4BJ;AACF;AUt4BE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVw4BJ;AUt4BI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVw4BN;AUp4BE;EACE,iBAAA;EACA,uBAAA;AVs4BJ;AUn4BI;EADF;IAEI,eAAA;EVs4BJ;AACF;AUn4BE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AVq4BJ;AUl4BE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AVo4BJ;AUl4BI;EACE,iBAAA;AVo4BN;;AU/3BA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AVk4BF;;AU/3BA;EACE,qBAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AU/3BA;EACE,kCAAA;EACA,YAAA;AVk4BF;;AUh4BA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AVk4BF;;AU93BA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AVi4BF;;AU/3BA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AVk4BF;AUh4BE;EACE,WAAA;AVk4BJ;AU/3BE;EACE;IACE,aAAA;EVi4BJ;AACF;;AU73BA;EACE,aAAA;EACA,mBAAA;AVg4BF;AU93BE;EACE,WAAA;AVg4BJ;AU73BE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AV+3BJ;AU53BE;EACE,uBAAA;AV83BJ;AU33BE;EACE,uBAAA;AV63BJ;;AUz3BA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AV43BF;;AUz3BA;EACE,uBAAA;AV43BF;;AUz3BA;EACE,aAAA;EACA,eAAA;AV43BF;AU13BE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AV43BJ;;AUx3BA;EACE,gBAAA;EACA,kBAAA;AV23BF;;AUv3BA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AV03BF;;AUt3BE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVy3BJ;;AUp3BE;EACE,mCAAA;AVu3BJ;AUp3BE;EACE,wBAAA;EACA,kBAAA;AVs3BJ;;AUj3BE;EACE,kCAAA;AVo3BJ;AUj3BE;EACE,uBAAA;EACA,kBAAA;AVm3BJ;;AU/2BA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AVk3BF;AUh3BE;EACE,sCAAA;EACA,+CAAA;AVk3BJ;;AU92BA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AVi3BF;;AU92BA;EAEE,qBAAA;AVg3BF;;AUz2BA;EAEE,cAAA;AV22BF;;AUx2BA;EACM,2BAAA;AV22BN;;AUz2BA;EACE,2BAAA;AV42BF;;AU12BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AV62BF;;AU12BA;EACE,aAAA;EACA,iBAAA;AV62BF;;AU12BA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AV62BF;AU32BE;EACE,kBAAA;AV62BJ;;AUz2BA;EACE,kBAAA;EACA,kBAAA;AV42BF;;AU12BA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AV42BF;AU12BE;EACE,gBAAA;AV42BJ;AU12BE;EACE,WAAA;AV42BJ;;AUx2BA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AV22BF;;AUx2BA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,YAAA;AV22BF;;AUx2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AV22BF;;AUz2BA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AV42BF;;AU12BA;EACE,iCAAA;AV62BF;;AU32BA;EACE,sBAAA;AV82BF;;AU52BA;EACE,iDAAA;EACA,mDAAA;AV+2BF;;AU52BE;EACE,8BAAA;AV+2BJ;;AU32BE;EACE,8BAAA;AV82BJ;;AU32BA;EACE,uBAAA;AV82BF;;AU52BA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AV82BF;;AU52BA;EACE,6BAAA;EACA,kBAAA;AV+2BF;;AU72BA;EACE,oCAAA;AVg3BF;;AU92BA;EACE,kCAAA;AVi3BF;;AU92BE;EADF;IAEI,WAAA;EVk3BF;AACF;;AU/2BA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AVk3BF;;AU92BE;EACE,qBAAA;AVi3BJ;AUt2BA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVw2BJ;;AUt2BA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVy2BJ;;AUt2BA;EACE,2BAAA;AVy2BF;;AUr2BE;EADF;IAEI,wBAAA;EVy2BF;AACF;;AUv2BA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AV02BF;;AUv2BA;EAAO,iBAAA;AV22BP;;AU12BA;EAAO,uBAAA;AV82BP;;AU72BA;EAAO,sBAAA;AVi3BP;;AUh3BA;EAAO,oBAAA;AVo3BP;;AUn3BA;EAAO,sBAAA;AVu3BP;;AUt3BA;EAAO,oBAAA;AV03BP;;AUv3BA;EAAQ,wBAAA;AV23BR;;AU13BA;EAAQ,8BAAA;AV83BR;;AU73BA;EAAQ,6BAAA;AVi4BR;;AUh4BA;EAAQ,2BAAA;AVo4BR;;AUn4BA;EAAQ,6BAAA;AVu4BR;;AUt4BA;EAAQ,2BAAA;AV04BR;;AUv4BA;EAAQ,qBAAA;AV24BR;;AU14BA;EAAQ,2BAAA;AV84BR;;AU74BA;EAAQ,0BAAA;AVi5BR;;AUh5BA;EAAQ,wBAAA;AVo5BR;;AUn5BA;EAAQ,0BAAA;AVu5BR;;AUt5BA;EAAQ,wBAAA;AV05BR;;AUz5BA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AV45BF;;AUz5BA;EAAS,mBAAA;EAAqB,oBAAA;AV85B9B;;AU75BA;EAAS,oBAAA;EAAsB,qBAAA;AVk6B/B;;AUj6BA;EAAS,aAAA;EAAe,cAAA;AVs6BxB;;AUr6BA;EAAS,oBAAA;EAAsB,qBAAA;AV06B/B;;AUz6BA;EAAS,oBAAA;EAAsB,qBAAA;AV86B/B;;AU76BA;EAAS,aAAA;EAAe,cAAA;AVk7BxB;;AUj7BA;EAAS,oBAAA;EAAsB,qBAAA;AVs7B/B;;AUr7BA;EAAS,oBAAA;EAAsB,qBAAA;AV07B/B;;AUz7BA;EAAS,aAAA;EAAe,cAAA;AV87BxB;;AU77BA;EAAU,oBAAA;EAAsB,qBAAA;AVk8BhC;;AUj8BA;EAAU,oBAAA;EAAsB,qBAAA;AVs8BhC;;AUr8BA;EAAU,aAAA;EAAe,cAAA;AV08BzB;;AUx8BA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV68BjC;EU58BA;IAAY,oBAAA;IAAsB,qBAAA;EVg9BlC;EU/8BA;IAAY,aAAA;IAAe,cAAA;EVm9B3B;EUl9BA;IAAY,oBAAA;IAAsB,qBAAA;EVs9BlC;EUr9BA;IAAY,oBAAA;IAAsB,qBAAA;EVy9BlC;EUx9BA;IAAY,aAAA;IAAe,cAAA;EV49B3B;EU39BA;IAAY,oBAAA;IAAsB,qBAAA;EV+9BlC;EU99BA;IAAY,oBAAA;IAAsB,qBAAA;EVk+BlC;EUj+BA;IAAY,aAAA;IAAe,cAAA;EVq+B3B;EUp+BA;IAAa,oBAAA;IAAsB,qBAAA;EVw+BnC;EUv+BA;IAAa,oBAAA;IAAsB,qBAAA;EV2+BnC;EU1+BA;IAAa,aAAA;IAAe,cAAA;EV8+B5B;AACF;AU5+BA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVg/BjC;EU/+BA;IAAY,oBAAA;IAAsB,qBAAA;EVm/BlC;EUl/BA;IAAY,aAAA;IAAe,cAAA;EVs/B3B;EUr/BA;IAAY,oBAAA;IAAsB,qBAAA;EVy/BlC;EUx/BA;IAAY,oBAAA;IAAsB,qBAAA;EV4/BlC;EU3/BA;IAAY,aAAA;IAAe,cAAA;EV+/B3B;EU9/BA;IAAY,oBAAA;IAAsB,qBAAA;EVkgClC;EUjgCA;IAAY,oBAAA;IAAsB,qBAAA;EVqgClC;EUpgCA;IAAY,aAAA;IAAe,cAAA;EVwgC3B;EUvgCA;IAAa,oBAAA;IAAsB,qBAAA;EV2gCnC;EU1gCA;IAAa,oBAAA;IAAsB,qBAAA;EV8gCnC;EU7gCA;IAAa,cAAA;IAAgB,eAAA;EVihC7B;AACF;AU/gCA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVmhCjC;EUlhCA;IAAY,oBAAA;IAAsB,qBAAA;EVshClC;EUrhCA;IAAY,aAAA;IAAe,cAAA;EVyhC3B;EUxhCA;IAAY,oBAAA;IAAsB,qBAAA;EV4hClC;EU3hCA;IAAY,oBAAA;IAAsB,qBAAA;EV+hClC;EU9hCA;IAAY,aAAA;IAAe,cAAA;EVkiC3B;EUjiCA;IAAY,oBAAA;IAAsB,qBAAA;EVqiClC;EUpiCA;IAAY,oBAAA;IAAsB,qBAAA;EVwiClC;EUviCA;IAAY,aAAA;IAAe,cAAA;EV2iC3B;EU1iCA;IAAa,oBAAA;IAAsB,qBAAA;EV8iCnC;EU7iCA;IAAa,oBAAA;IAAsB,qBAAA;EVijCnC;EUhjCA;IAAa,aAAA;IAAe,cAAA;EVojC5B;AACF;AUljCA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVsjCjC;EUrjCA;IAAY,oBAAA;IAAsB,qBAAA;EVyjClC;EUxjCA;IAAY,aAAA;IAAe,cAAA;EV4jC3B;EU3jCA;IAAY,oBAAA;IAAsB,qBAAA;EV+jClC;EU9jCA;IAAY,oBAAA;IAAsB,qBAAA;EVkkClC;EUjkCA;IAAY,aAAA;IAAe,cAAA;EVqkC3B;EUpkCA;IAAY,oBAAA;IAAsB,qBAAA;EVwkClC;EUvkCA;IAAY,oBAAA;IAAsB,qBAAA;EV2kClC;EU1kCA;IAAY,aAAA;IAAe,cAAA;EV8kC3B;EU7kCA;IAAa,oBAAA;IAAsB,qBAAA;EVilCnC;EUhlCA;IAAa,oBAAA;IAAsB,qBAAA;EVolCnC;EUnlCA;IAAa,aAAA;IAAe,cAAA;EVulC5B;AACF;AUrlCA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVylClC;EUxlCA;IAAa,oBAAA;IAAsB,qBAAA;EV4lCnC;EU3lCA;IAAa,aAAA;IAAe,cAAA;EV+lC5B;EU9lCA;IAAa,oBAAA;IAAsB,qBAAA;EVkmCnC;EUjmCA;IAAa,oBAAA;IAAsB,qBAAA;EVqmCnC;EUpmCA;IAAa,aAAA;IAAe,cAAA;EVwmC5B;EUvmCA;IAAa,oBAAA;IAAsB,qBAAA;EV2mCnC;EU1mCA;IAAa,oBAAA;IAAsB,qBAAA;EV8mCnC;EU7mCA;IAAa,aAAA;IAAe,cAAA;EVinC5B;EUhnCA;IAAc,oBAAA;IAAsB,qBAAA;EVonCpC;EUnnCA;IAAc,oBAAA;IAAsB,qBAAA;EVunCpC;EUtnCA;IAAc,aAAA;IAAe,cAAA;EV0nC7B;AACF;AUznCA;EACE,0BAAA;AV2nCF;;AUznCA;EACE,iBAAA;AV4nCF;;AU1nCA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AV6nCJ;;AU1nCA;EACI,uBAAA;AV6nCJ;;AU1nCA;EACI,aAAA;AV6nCJ;;AU1nCA;EAEI,gCAAA;EACA,oCAAA;AV4nCJ;;AAvsEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;AA0sEF;AAzsEE;EANF;IAOI,WAAA;IACA,aAAA;IACA,sBAAA;IACA,aAAA;IACA,gBAAA;EA4sEF;AACF;AA1sEE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AA4sEJ;AAxsEI;EACE,WAAA;EACA,UAAA;EACA,eAAA;AA0sEN;AAxsEM;EALF;IAMI,eAAA;IACA,kBAAA;EA2sEN;AACF;AAzsEI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AA2sEN;AA1sEM;EALF;IAMI,eAAA;IACA,kBAAA;EA6sEN;AACF;AA1sEI;EACE,YAAA;AA4sEN;;AAxsEA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,YAAA;AA0sEF;;AAvsEA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,yCAAA;AA0sEF;AAxsEE;EAZF;IAaE,SAAA;EA2sEA;AACF;;AAvsEA;EACE,aAAA;EACA,mBAAA;AA0sEF;AAzsEE;EACI,WAAA;EACA,cAAA;EACA,eAAA;AA2sEN;AA1sEM;EAJJ;IAKQ,eAAA;EA6sER;AACF;;AAzsEA;EAEE,aAAA;AA2sEF;AA1sEE;EAHF;IAIM,cAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;IACA,kBAAA;IACA,eAAA;IACA,kBAAA;EA6sEJ;AACF;;AA3sEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AA8sEF;AA7sEE;EAVF;IAWM,aAAA;EAgtEJ;AACF;;AA9sEA;EACE,iBAAA;EACA,WAAA;EACA,eAAA;AAitEF;;AA/sEA;EACE,YAAA;EACA,WAAA;EACA,sBAAA;EACA,cAAA;AAktEF;AAjtEE;EALF;IAMI,aAAA;EAotEF;AACF;;AAjtEA;EACE,yBAAA;AAotEF;;AAltEA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AAqtEF;AAptEE;EALF;IAMM,aAAA;EAutEJ;AACF;;AAptEA;EACE,WAAA;EACA,YAAA;EAEA,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAstEF;;AAptEA;EACE,WAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;AAutEF;AAttEE;EALF;IAMI,YAAA;EAytEF;AACF;;AAvtEA;EACE,iBAAA;EACA,eAAA;AA0tEF;;AAvtEA;EACE,WAAA;AA0tEF;AAztEE;EAFF;IAGI,WAAA;EA4tEF;AACF;;AA1tEA;EACE,WAAA,EAAA,wBAAA;AA6tEF;;AA1tEA;EACE,yBAAA,EAAA,oCAAA;AA6tEF;;AA3tEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;EACA,yBAAA;EACA,YAAA;AA8tEF;AA7tEE;EAVF;IAWI,aAAA;EAguEF;AACF;;AA9tEA;EACE,kBAAA;EACA,UAAA;AAiuEF;AAhuEE;EAHF;IAII,WAAA;EAmuEF;AACF;AAluEE;EACE,aAAA;AAouEJ;AAnuEI;EAFF;IAGI,WAAA;IACA,uBAAA;EAsuEJ;AACF;AAruEI;EACE,kBAAA;AAuuEN;AAruEI;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAuuEN;AApuEE;EACE,iBAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAsuEJ;AAruEI;EALF;IAMI,WAAA;IACA,iBAAA;IACA,gBAAA;IACA,mBAAA;IACA,iBAAA;EAwuEJ;AACF;AAruEE;EACE,eAAA;EACA,WAAA;AAuuEJ;;AAnuEA;EACE,UAAA;EACA,aAAA;EACA,uBAAA;AAsuEF;AAruEE;EAJF;IAKI,aAAA;EAwuEF;AACF;AAvuEE;EACE,eAAA;EACA,cAAA;AAyuEJ;;AAtuEA;EACE,eAAA;EACA,cAAA;AAyuEF;;AAtuEA;EACE,aAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;AAyuEF;;AAtuEA;EACE,WAAA;EACA,eAAA;AAyuEF;AAvuEE;EAJF;IAKI,WAAA;EA0uEF;AACF;;AAxuEA;EACE,aAAA;AA2uEF;;AAxuEA;;;EAGE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,yCAAA;AA2uEF;;AAxuEA;;;;;EAKE,0BAAA;EACA,WAAA;AA2uEF;;AAxuEA;;EAEE,aAAA;EACA,sBAAA;AA2uEF;;AAxuEA;EACE,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AA2uEF;AAzuEE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AA2uEJ;;AAtuEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;AAyuEF;;AAtuEA;EACE,gBAAA;EACA,yCAAA;AAyuEF;;AAvuEA;EACE,gBAAA;EACA,yCAAA;AA0uEF;;AAxuEA;EACE,gBAAA;EACA,gCAAA;AA2uEF;;AAzuEA;EACE,uBAAA;AA4uEF;;AAzuEE;EACE,kBAAA;AA4uEJ;AA1uEE;EACE,0BAAA;EACA,kBAAA;AA4uEJ;;AAxuEA;EACE,qBAAA;AA2uEF;;AAzuEA;EACE;;;;IAIE,WAAA;IACA,aAAA;IACA,iCAAA;IACA,kCAAA;IACA,sCAAA;EA4uEF;EAzuEA;IACE,sBAAA;IACA,kBAAA;EA2uEF;EAxuEA;IACE,sBAAA;EA0uEF;EAtuEA;IACE,kBAAA;EAwuEF;EAruEA;IACE,gBAAA;IACA,sBAAA;IAEA,wBAAA;IACA,kCAAA;EAsuEF;AACF;AAnuEA;EACE;IACE,iCAAA;IACA,kCAAA;IACA,6BAAA;EAquEF;AACF;AAluEA;EACE,oCAAA;EACA,oCAAA;EACA,iBAAA;EACA,oBAAA;EACA,iBAAA;EACA,kCAAA;AAouEF;;AAjuEA;EACE,gCAAA;EACA,gCAAA;EACA,cAAA;EACA,8BAAA;AAouEF;;AAjuEA;EACE,eAAA;EACA,qBAAA;AAouEF;;AAjuEA;EACE,yBAAA;EACA,uCAAA;EACA,eAAA;AAouEF;;AC1oFE;EACE,gBAAA;EAIA,kBAAA;AD0oFJ;ACnoFI;EACE,wBAAA;ADqoFN;;ACjoFE;EACE,iBAAA;ADooFJ;;ACjoFE;EACE,kBAAA;EACA,kBAAA;EACA,oBAAA;EAEA,6DAAA;EAIA,2BAAA;ADgoFJ;AEjnFI;EDXE,aAAA;AD+nFN;;AEnqFE;EACE,SAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,UAAA;EACA,kBAAA;EACA,UAAA;EAIA,mBAAA;EAGA,UAAA;EAGA,wBAAA;EACA,qBAAA;EAMA,OAAA;AF0pFJ;AExpFI;EACE,UAAA;EACA,QAAA;AF0pFN;;AG1qFE;EAEE,oBAAA;EAGA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;AH0qFJ;;AGtqFE;EACE,eAAA;EACA,aA3BwB;AHosF5B;AGvqFI;EAGE,aAAA;AHuqFN;;AG/pFE;EACE,aAAA;EACA,kBAAA;EACA,aA1Cc;AH4sFlB;;AG9pFE;EAGE,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,aApDc;EAwDd,aAAA;EACA,eAAA;EACA,gBAAA;AH4pFJ;;AGzpFE;EAEE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EAEA,aApEuB;EAqEvB,oBAAA;EACA,wCAAA;EACA,0DAAA;EACA,UAAA;AH0pFJ;AGxpFI;EACE,UAAA;AH0pFN;AGrpFM;EAGE,YAAA;AHqpFR;;AGhpFE;EACE,+BAtFqB;AHyuFzB;;AGhpFE;EAEE,qDAAA;EACA,kBAAA;EACA,UAAA;AHkpFJ;AG5oFI;EACE,UAAA;EACA,mBAAA;AH8oFN;;AG1oFE;EACE,gBAAA;AH6oFJ;;AGxoFE;EACE,kBAAA;EACA,aArHc;EA0Hd,aAAA;EAIA,sBAAA;EAGA,cAAA;EACA,eAAA;AHkoFJ;;AG9nFE;EACE,eAAA;EAKA,WAAA;EAKA,kBAAA;AHynFJ;;AI1wFE;EACE,YAAA;AJ6wFJ;;AIvwFE;EAyCA,yBAAA;EACA,kCAAA;EAxCE,uBAAA;EACA,2BAAA;AJ2wFJ;;AIlwFE;EA6BA,yBAAA;EACA,kCAAA;EA5BE,oBAAA;AJswFJ;;AI5vFE,2CAAA,IAAA,EAAA;AACA,yCAAA,IAAA,EAAA;AAEA;EAEE,+CAAA;AJ6vFJ;;AI1vFE;EAEE,6CAAA;AJ4vFJ;;AK3xFE;EACE,kBAAA;AL8xFJ;AK5xFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,iDAAA;EACA,wJAAA;EAYA,4DAAA;ALuxFN;AK/wFI;EACE,WAAA;ALixFN;;AEtuFM;EG7BA,oCAAA;ALuwFN;;AKlzFE;EACE,kBAAA;ALqzFJ;AKnzFI;ECfF,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EDaI,sBAAA;EACA,oBAAA;EACA,qDAAA;EACA,oKAAA;EAYA,gEAAA;AL8yFN;AKtyFI;EACE,WAAA;ALwyFN;;AE7vFM;EG7BA,wCAAA;AL8xFN;;AOv1FA;;;;;CAAA;ACEA;EACE,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AR81FF;;AQ31FA;;;;;;EAME,qCAAA;EACA,gBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,uBAAA;EACA,eAAA;EACA,0BAAA;AR81FF;;AQ31FA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AR81FF;;AQ31FA;EACE,gBAAA;EACA,eAAA;AR81FF;;AOh6FA;;;;;CAAA;AEeE;EACE,YAAA;AT05FJ;;ASx5FE;EACE,gBAAA;AT25FJ;;ASz5FE;EACE,kBAAA;AT45FJ;;AS15FE;EACE,mBAAA;AT65FJ;;AS35FE;EACE,iBAAA;AT85FJ;;AS55FE;EACE,iBAAA;EACA,kBAAA;AT+5FJ;;AS75FE;EACE,gBAAA;EACA,mBAAA;ATg6FJ;;AS75FE;EACE,WAAA;ATg6FJ;;AS95FE;EACE,eAAA;ATi6FJ;;AS/5FE;EACE,iBAAA;ATk6FJ;;ASh6FE;EACE,kBAAA;ATm6FJ;;ASj6FE;EACE,gBAAA;ATo6FJ;;ASl6FE;EACE,gBAAA;EACA,iBAAA;ATq6FJ;;ASn6FE;EACE,eAAA;EACA,kBAAA;ATs6FJ;;ASn9FE;EACE,YAAA;ATs9FJ;;ASp9FE;EACE,gBAAA;ATu9FJ;;ASr9FE;EACE,kBAAA;ATw9FJ;;ASt9FE;EACE,mBAAA;ATy9FJ;;ASv9FE;EACE,iBAAA;AT09FJ;;ASx9FE;EACE,iBAAA;EACA,kBAAA;AT29FJ;;ASz9FE;EACE,gBAAA;EACA,mBAAA;AT49FJ;;ASz9FE;EACE,WAAA;AT49FJ;;AS19FE;EACE,eAAA;AT69FJ;;AS39FE;EACE,iBAAA;AT89FJ;;AS59FE;EACE,kBAAA;AT+9FJ;;AS79FE;EACE,gBAAA;ATg+FJ;;AS99FE;EACE,gBAAA;EACA,iBAAA;ATi+FJ;;AS/9FE;EACE,eAAA;EACA,kBAAA;ATk+FJ;;AS/gGE;EACE,aAAA;ATkhGJ;;AShhGE;EACE,iBAAA;ATmhGJ;;ASjhGE;EACE,mBAAA;ATohGJ;;ASlhGE;EACE,oBAAA;ATqhGJ;;ASnhGE;EACE,kBAAA;ATshGJ;;ASphGE;EACE,kBAAA;EACA,mBAAA;ATuhGJ;;ASrhGE;EACE,iBAAA;EACA,oBAAA;ATwhGJ;;ASrhGE;EACE,YAAA;ATwhGJ;;ASthGE;EACE,gBAAA;ATyhGJ;;ASvhGE;EACE,kBAAA;AT0hGJ;;ASxhGE;EACE,mBAAA;AT2hGJ;;ASzhGE;EACE,iBAAA;AT4hGJ;;AS1hGE;EACE,iBAAA;EACA,kBAAA;AT6hGJ;;AS3hGE;EACE,gBAAA;EACA,mBAAA;AT8hGJ;;AS3kGE;EACE,aAAA;AT8kGJ;;AS5kGE;EACE,iBAAA;AT+kGJ;;AS7kGE;EACE,mBAAA;ATglGJ;;AS9kGE;EACE,oBAAA;ATilGJ;;AS/kGE;EACE,kBAAA;ATklGJ;;AShlGE;EACE,kBAAA;EACA,mBAAA;ATmlGJ;;ASjlGE;EACE,iBAAA;EACA,oBAAA;ATolGJ;;ASjlGE;EACE,YAAA;ATolGJ;;ASllGE;EACE,gBAAA;ATqlGJ;;ASnlGE;EACE,kBAAA;ATslGJ;;ASplGE;EACE,mBAAA;ATulGJ;;ASrlGE;EACE,iBAAA;ATwlGJ;;AStlGE;EACE,iBAAA;EACA,kBAAA;ATylGJ;;ASvlGE;EACE,gBAAA;EACA,mBAAA;AT0lGJ;;ASvoGE;EACE,aAAA;AT0oGJ;;ASxoGE;EACE,iBAAA;AT2oGJ;;ASzoGE;EACE,mBAAA;AT4oGJ;;AS1oGE;EACE,oBAAA;AT6oGJ;;AS3oGE;EACE,kBAAA;AT8oGJ;;AS5oGE;EACE,kBAAA;EACA,mBAAA;AT+oGJ;;AS7oGE;EACE,iBAAA;EACA,oBAAA;ATgpGJ;;AS7oGE;EACE,YAAA;ATgpGJ;;AS9oGE;EACE,gBAAA;ATipGJ;;AS/oGE;EACE,kBAAA;ATkpGJ;;AShpGE;EACE,mBAAA;ATmpGJ;;ASjpGE;EACE,iBAAA;ATopGJ;;ASlpGE;EACE,iBAAA;EACA,kBAAA;ATqpGJ;;ASnpGE;EACE,gBAAA;EACA,mBAAA;ATspGJ;;ASnsGE;EACE,aAAA;ATssGJ;;ASpsGE;EACE,iBAAA;ATusGJ;;ASrsGE;EACE,mBAAA;ATwsGJ;;AStsGE;EACE,oBAAA;ATysGJ;;ASvsGE;EACE,kBAAA;AT0sGJ;;ASxsGE;EACE,kBAAA;EACA,mBAAA;AT2sGJ;;ASzsGE;EACE,iBAAA;EACA,oBAAA;AT4sGJ;;ASzsGE;EACE,YAAA;AT4sGJ;;AS1sGE;EACE,gBAAA;AT6sGJ;;AS3sGE;EACE,kBAAA;AT8sGJ;;AS5sGE;EACE,mBAAA;AT+sGJ;;AS7sGE;EACE,iBAAA;ATgtGJ;;AS9sGE;EACE,iBAAA;EACA,kBAAA;ATitGJ;;AS/sGE;EACE,gBAAA;EACA,mBAAA;ATktGJ;;AS/vGE;EACE,aAAA;ATkwGJ;;AShwGE;EACE,iBAAA;ATmwGJ;;ASjwGE;EACE,mBAAA;ATowGJ;;ASlwGE;EACE,oBAAA;ATqwGJ;;ASnwGE;EACE,kBAAA;ATswGJ;;ASpwGE;EACE,kBAAA;EACA,mBAAA;ATuwGJ;;ASrwGE;EACE,iBAAA;EACA,oBAAA;ATwwGJ;;ASrwGE;EACE,YAAA;ATwwGJ;;AStwGE;EACE,gBAAA;ATywGJ;;ASvwGE;EACE,kBAAA;AT0wGJ;;ASxwGE;EACE,mBAAA;AT2wGJ;;ASzwGE;EACE,iBAAA;AT4wGJ;;AS1wGE;EACE,iBAAA;EACA,kBAAA;AT6wGJ;;AS3wGE;EACE,gBAAA;EACA,mBAAA;AT8wGJ;;AS3zGE;EACE,aAAA;AT8zGJ;;AS5zGE;EACE,iBAAA;AT+zGJ;;AS7zGE;EACE,mBAAA;ATg0GJ;;AS9zGE;EACE,oBAAA;ATi0GJ;;AS/zGE;EACE,kBAAA;ATk0GJ;;ASh0GE;EACE,kBAAA;EACA,mBAAA;ATm0GJ;;ASj0GE;EACE,iBAAA;EACA,oBAAA;ATo0GJ;;ASj0GE;EACE,YAAA;ATo0GJ;;ASl0GE;EACE,gBAAA;ATq0GJ;;ASn0GE;EACE,kBAAA;ATs0GJ;;ASp0GE;EACE,mBAAA;ATu0GJ;;ASr0GE;EACE,iBAAA;ATw0GJ;;ASt0GE;EACE,iBAAA;EACA,kBAAA;ATy0GJ;;ASv0GE;EACE,gBAAA;EACA,mBAAA;AT00GJ;;ASv3GE;EACE,aAAA;AT03GJ;;ASx3GE;EACE,iBAAA;AT23GJ;;ASz3GE;EACE,mBAAA;AT43GJ;;AS13GE;EACE,oBAAA;AT63GJ;;AS33GE;EACE,kBAAA;AT83GJ;;AS53GE;EACE,kBAAA;EACA,mBAAA;AT+3GJ;;AS73GE;EACE,iBAAA;EACA,oBAAA;ATg4GJ;;AS73GE;EACE,YAAA;ATg4GJ;;AS93GE;EACE,gBAAA;ATi4GJ;;AS/3GE;EACE,kBAAA;ATk4GJ;;ASh4GE;EACE,mBAAA;ATm4GJ;;ASj4GE;EACE,iBAAA;ATo4GJ;;ASl4GE;EACE,iBAAA;EACA,kBAAA;ATq4GJ;;ASn4GE;EACE,gBAAA;EACA,mBAAA;ATs4GJ;;ASn7GE;EACE,aAAA;ATs7GJ;;ASp7GE;EACE,iBAAA;ATu7GJ;;ASr7GE;EACE,mBAAA;ATw7GJ;;ASt7GE;EACE,oBAAA;ATy7GJ;;ASv7GE;EACE,kBAAA;AT07GJ;;ASx7GE;EACE,kBAAA;EACA,mBAAA;AT27GJ;;ASz7GE;EACE,iBAAA;EACA,oBAAA;AT47GJ;;ASz7GE;EACE,YAAA;AT47GJ;;AS17GE;EACE,gBAAA;AT67GJ;;AS37GE;EACE,kBAAA;AT87GJ;;AS57GE;EACE,mBAAA;AT+7GJ;;AS77GE;EACE,iBAAA;ATg8GJ;;AS97GE;EACE,iBAAA;EACA,kBAAA;ATi8GJ;;AS/7GE;EACE,gBAAA;EACA,mBAAA;ATk8GJ;;AS/+GE;EACE,aAAA;ATk/GJ;;ASh/GE;EACE,iBAAA;ATm/GJ;;ASj/GE;EACE,mBAAA;ATo/GJ;;ASl/GE;EACE,oBAAA;ATq/GJ;;ASn/GE;EACE,kBAAA;ATs/GJ;;ASp/GE;EACE,kBAAA;EACA,mBAAA;ATu/GJ;;ASr/GE;EACE,iBAAA;EACA,oBAAA;ATw/GJ;;ASr/GE;EACE,YAAA;ATw/GJ;;ASt/GE;EACE,gBAAA;ATy/GJ;;ASv/GE;EACE,kBAAA;AT0/GJ;;ASx/GE;EACE,mBAAA;AT2/GJ;;ASz/GE;EACE,iBAAA;AT4/GJ;;AS1/GE;EACE,iBAAA;EACA,kBAAA;AT6/GJ;;AS3/GE;EACE,gBAAA;EACA,mBAAA;AT8/GJ;;AUljHA;EACE;;;;;cAAA;EAMA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA;;;;;cAAA;EAOA,wDAAA;AVijHF;;AU9iHA,8EAAA;AACA,2DAAA;AACA,wCAAA;AACA,uCAAA;AACA;EACE,wCAAA;AVijHF;;AU9iHA,iDAAA;AACA;EACE,wCAAA;AVijHF;;AU9iHA;EACE,UAAA;EACA,iBAAA;EACA,kBAAA;AVijHF;AU/iHE;EACE,aAAA;AVijHJ;;AU7iHA,oBAAA;AACA;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AVgjHF;;AU7iHA;EACE,oCAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,kBAAA;EACA,wHAAA;AVgjHF;;AU5iHA;EACE,oCAAA;EACA,yBAAA;AV+iHF;;AU5iHA;EACE,iCAAA;EACA,oCAAA;EACA,0HAAA;AV+iHF;;AU3iHA;EACE,kCAAA;AV8iHF;;AU3iHA;EACE,6BAAA;AV8iHF;;AU3iHA;EACE,kCAAA;AV8iHF;;AU3iHA;;EAEE,wBAAA;EACA,8BAAA;EACA,kCAAA;EACA,iCAAA;EACA,qBAAA;EACA,6BAAA;EACA,sBAAA;EACA,uBAAA;EACA,+CAAA;EACA,wHAAA;AV8iHF;;AU1iHA,2BAAA;AAEA;EACE,SAAA;AV4iHF;;AUziHA;EACE,WAAA;EACA,2BAAA;AV4iHF;AU1iHE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;AV4iHJ;AUziHE;EACE,uBAAA;AV2iHJ;AUxiHE;EACE,kBAAA;AV0iHJ;;AUtiHA;EACE,WAAA;EACA,2BAAA;AVyiHF;;AUtiHA;EACE,WAAA;EACA,gBAAA;AVyiHF;AUviHE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,yBAAA;AVyiHJ;AUtiHE;EACE,uBAAA;AVwiHJ;AUriHE;EACE,kBAAA;AVuiHJ;;AUniHA;EACE,WAAA;EACA,gBAAA;AVsiHF;AUpiHE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,uBAAA;AVsiHJ;AUniHE;EACE,uBAAA;AVqiHJ;AUliHE;EACE,kBAAA;AVoiHJ;;AUhiHA;EACE,WAAA;EACA,gBAAA;AVmiHF;AUjiHE;EACE,+CAAA;EACA,8BAAA;EACA,WAAA;EACA,qBAAA;AVmiHJ;AUhiHE;EACE,uBAAA;AVkiHJ;AU/hHE;EACE,kBAAA;AViiHJ;;AU7hHA;EACE,aAAA;AVgiHF;;AU7hHA;EACE,2BAAA;AVgiHF;AU7hHI;EACE,eAAA;EACA,aAAA;EACA,uBAAA;AV+hHN;AU5hHI;EACE,iBAAA;EACA,eAAA;AV8hHN;AU3hHI;EACE,mBAAA;AV6hHN;AU1hHI;EACE,2CAAA;AV4hHN;;AUvhHA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AV0hHF;;AUvhHA;EACE,oBAAA;EACA,mBAAA;AV0hHF;AUxhHE;EACE,YAAA;EACA,WAAA;AV0hHJ;;AUrhHI;EADF;IAEI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EVyhHJ;AACF;;AUthHA;EACE,4BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVyhHF;AUvhHE;EAXF;IAYI,gBAAA;IACA,0BAAA;IACA,UAAA;IACA,YAAA;EV0hHF;AACF;AUxhHE;EACE,8BAAA;AV0hHJ;;AUthHA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVyhHF;AUvhHE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV0hHF;AACF;AUxhHE;EACE,8BAAA;AV0hHJ;;AUthHA;EACE,8BAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;AVyhHF;AUvhHE;EAXF;IAYI,gBAAA;IACA,WAAA;IACA,YAAA;EV0hHF;AACF;;AUvhHA;;CAAA;AAGA;EACE,gBAAA;EACA,kBAAA;AV0hHF;;AUvhHA;EACE,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,wBAAA;AV0hHF;;AUxhHA;EACE,mDAAA;EACA,4CAAA;AV2hHF;;AUxhHA;EACE,sCAAA;EACA,kBAAA;EACA,yCAAA;AV2hHF;;AUzhHA;EACE,uBAAA;EACA,kBAAA;EACA,yCAAA;AV4hHF;;AU1hHA;EACE,kCAAA;EACA,kBAAA;EACA,kCAAA;AV6hHF;;AU3hHA;EACE,2BAAA;AV8hHF;;AU3hHE;EACE,YAAA;AV8hHJ;AU5hHE;EACE,YAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;EACA,8BAAA;AV8hHJ;AU3hHI;EACE,yBAAA;EACA,oCAAA;AV6hHN;AUzhHE;EACE,uBAAA;AV2hHJ;AUzhHE;EACE,uBAAA;AV2hHJ;AUzhHE;EACE,uBAAA;AV2hHJ;;AUvhHA;EACE;IACE,4BAAA;IACA,eAAA;EV0hHF;EUvhHA;IACE,2BAAA;IACA,4BAAA;IACA,eAAA;EVyhHF;EUthHA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVwhHF;EUthHA;IACE,WAAA;IACA,gBAAA;IACA,4BAAA;IACA,2BAAA;EVwhHF;EUthHA;IACE,kBAAA;IACA,qBAAA;IACA,eAAA;EVwhHF;AACF;AUrhHA;EACE;IACE,kBAAA;EVuhHF;EUrhHA;IACE,iBAAA;IACA,2BAAA;IACA,eAAA;EVuhHF;EUphHA;IACE,kBAAA;IACA,0BAAA;EVshHF;EUphHA;IACE,0BAAA;IACA,0BAAA;IACA,2BAAA;EVshHF;EUphHE;IACF,kBAAA;IACE,0BAAA;EVshHF;AACF;AUnhHA;EACE;IACE,UAAA;EVqhHF;AACF;AUlhHA;EACE,wCAAA;AVohHF;;AUjhHA;EACE;IACE,iBAAA;IACA,8CAAA;EVohHF;AACF;AUjhHA;EACE,kCAAA;EACA,oBAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,qBAAA;AVmhHF;AUjhHE;EACE,sBAAA;AVmhHJ;;AU/gHA;EACE,wBAAA;AVkhHF;;AUhhHA;EACE,qBAAA,EAAA,wCAAA;AVmhHF;;AUjhHA;EACE,iBAAA;EACA,iBAAA;EACA,yBAAA;AVohHF;AUlhHE;EACE,UAAA;EACA,aAAA;EACA,YAAA;EAEA,8BAAA;EACA,aAAA;AVmhHJ;AUjhHI;EACE,mBAAA;EACA,iBAAA;EACA,yBAAA;AVmhHN;AUhhHI;;EAEE,eAAA;EACA,mBAAA;EACA,cAAA;AVkhHN;AUhhHI;EApBF;IAqBI,WAAA;IACA,cAAA;EVmhHJ;AACF;AUhhHE;EACE,iBAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;AVkhHJ;AUhhHI;EACE,WAAA;EACA,aAAA;EACA,yBAAA;AVkhHN;AU9gHE;EACE,iBAAA;EACA,uBAAA;AVghHJ;AU7gHI;EADF;IAEI,eAAA;EVghHJ;AACF;AU7gHE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AV+gHJ;AU5gHE;EACE,UAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AV8gHJ;AU5gHI;EACE,iBAAA;AV8gHN;;AUzgHA;EACE,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AV4gHF;;AUzgHA;EACE,kCAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AV4gHF;;AUzgHA;EACE,qBAAA;AV4gHF;;AUzgHA;EACE,kCAAA;EACA,YAAA;AV4gHF;;AUzgHA;EACE,kCAAA;EACA,YAAA;AV4gHF;;AU1gHA;EAEE,cAAA;EACA,yBAAA;EACA,mBAAA;AV4gHF;;AUxgHA;EACE,cAAA;EACA,yBAAA;EACA,mBAAA;AV2gHF;;AUzgHA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AV4gHF;AU1gHE;EACE,WAAA;AV4gHJ;AUzgHE;EACE;IACE,aAAA;EV2gHJ;AACF;;AUvgHA;EACE,aAAA;EACA,mBAAA;AV0gHF;AUxgHE;EACE,WAAA;AV0gHJ;AUvgHE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AVygHJ;AUtgHE;EACE,uBAAA;AVwgHJ;AUrgHE;EACE,uBAAA;AVugHJ;;AUngHA;;EAEE,mCAAA;EACA,6BAAA;EACA,yCAAA;EACA,4DAAA;EACA,0DAAA;EACA,0DAAA;AVsgHF;;AUngHA;EACE,uBAAA;AVsgHF;;AUngHA;EACE,aAAA;EACA,eAAA;AVsgHF;AUpgHE;EACE,kBAAA;EACA,iBAAA;EACA,2CAAA;EACA,WAAA;AVsgHJ;;AUlgHA;EACE,gBAAA;EACA,kBAAA;AVqgHF;;AUjgHA;EACE,iDAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;AVogHF;;AUhgHE;EACE,gBAAA;EACA,sBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,sBAAA;AVmgHJ;;AU9/GE;EACE,mCAAA;AVigHJ;AU9/GE;EACE,wBAAA;EACA,kBAAA;AVggHJ;;AU3/GE;EACE,kCAAA;AV8/GJ;AU3/GE;EACE,uBAAA;EACA,kBAAA;AV6/GJ;;AUz/GA;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;AV4/GF;AU1/GE;EACE,sCAAA;EACA,+CAAA;AV4/GJ;;AUx/GA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV2/GF;;AUx/GA,oCAAA;AACA;EACE,0BAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;AV2/GF;;AUx/GA;EAEE,qBAAA;AV0/GF;;AUn/GA;EAEE,cAAA;AVq/GF;;AUl/GA;EACM,2BAAA;AVq/GN;;AUn/GA;EACE,2BAAA;AVs/GF;;AUp/GA;EACE,cAAA;EACA,WAAA;EACA,YAAA;AVu/GF;;AUp/GA;EACE,aAAA;EACA,iBAAA;AVu/GF;;AUp/GA;EACE,mCAAA;EACA,sBAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;AVu/GF;AUr/GE;EACE,kBAAA;AVu/GJ;;AUn/GA;EACE,kBAAA;EACA,kBAAA;AVs/GF;;AUp/GA;EACE,YAAA;EAEA,wCAAA;EACA,yBAAA;EACA,kBAAA;AVs/GF;AUp/GE;EACE,gBAAA;AVs/GJ;AUp/GE;EACE,WAAA;AVs/GJ;;AUl/GA;EACE,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,6BAAA;AVq/GF;;AUl/GA;EACE,aAAA;EACA,eAAA;EACA,QAAA;AVq/GF;;AUl/GA;EACE,sBAAA;EACA,YAAA;AVq/GF;;AUl/GA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,6BAAA;AVq/GF;;AUn/GA;EACE,sBAAA;EACA,eAAA;EACA,0BAAA;EACA,UAAA;AVs/GF;;AUp/GA;EACE,iCAAA;AVu/GF;;AUr/GA;EACE,sBAAA;AVw/GF;;AUt/GA;EACE,iDAAA;EACA,mDAAA;AVy/GF;;AUt/GE;EACE,8BAAA;AVy/GJ;;AUr/GE;EACE,8BAAA;AVw/GJ;;AUr/GA;EACE,uBAAA;AVw/GF;;AUt/GA;EAEE,kCAAA;EACA,YAAA;EACA,kCAAA;EACA,6BAAA;AVw/GF;;AUt/GA;EACE,6BAAA;EACA,kBAAA;AVy/GF;;AUv/GA;EACE,oCAAA;AV0/GF;;AUx/GA;EACE,kCAAA;AV2/GF;;AUx/GE;EADF;IAEI,WAAA;EV4/GF;AACF;;AUz/GA;EACE,kBAAA;EACA,UAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,UAAA;AV4/GF;;AUx/GE;EACE,qBAAA;AV2/GJ;AUh/GA;EACI,eAAA;EACI,oBAAA;EACJ,aAAA;AVk/GJ;;AUh/GA;EACI,eAAA;EACE,oBAAA;EACF,aAAA;AVm/GJ;;AUh/GA;EACE,2BAAA;AVm/GF;;AU/+GE;EADF;IAEI,wBAAA;EVm/GF;AACF;;AUj/GA;EACE,4CAAA;EACA,gDAAA,EAAA,iBAAA;EACA,sDAAA,EAAA,mBAAA;EACA,8CAAA;AVo/GF;;AUj/GA;EAAO,iBAAA;AVq/GP;;AUp/GA;EAAO,uBAAA;AVw/GP;;AUv/GA;EAAO,sBAAA;AV2/GP;;AU1/GA;EAAO,oBAAA;AV8/GP;;AU7/GA;EAAO,sBAAA;AVigHP;;AUhgHA;EAAO,oBAAA;AVogHP;;AUjgHA;EAAQ,wBAAA;AVqgHR;;AUpgHA;EAAQ,8BAAA;AVwgHR;;AUvgHA;EAAQ,6BAAA;AV2gHR;;AU1gHA;EAAQ,2BAAA;AV8gHR;;AU7gHA;EAAQ,6BAAA;AVihHR;;AUhhHA;EAAQ,2BAAA;AVohHR;;AUjhHA;EAAQ,qBAAA;AVqhHR;;AUphHA;EAAQ,2BAAA;AVwhHR;;AUvhHA;EAAQ,0BAAA;AV2hHR;;AU1hHA;EAAQ,wBAAA;AV8hHR;;AU7hHA;EAAQ,0BAAA;AViiHR;;AUhiHA;EAAQ,wBAAA;AVoiHR;;AUniHA;EACE,YAAA;EACA,eAAA;EACA,qBAAA;EACA,oBAAA;AVsiHF;;AUniHA;EAAS,mBAAA;EAAqB,oBAAA;AVwiH9B;;AUviHA;EAAS,oBAAA;EAAsB,qBAAA;AV4iH/B;;AU3iHA;EAAS,aAAA;EAAe,cAAA;AVgjHxB;;AU/iHA;EAAS,oBAAA;EAAsB,qBAAA;AVojH/B;;AUnjHA;EAAS,oBAAA;EAAsB,qBAAA;AVwjH/B;;AUvjHA;EAAS,aAAA;EAAe,cAAA;AV4jHxB;;AU3jHA;EAAS,oBAAA;EAAsB,qBAAA;AVgkH/B;;AU/jHA;EAAS,oBAAA;EAAsB,qBAAA;AVokH/B;;AUnkHA;EAAS,aAAA;EAAe,cAAA;AVwkHxB;;AUvkHA;EAAU,oBAAA;EAAsB,qBAAA;AV4kHhC;;AU3kHA;EAAU,oBAAA;EAAsB,qBAAA;AVglHhC;;AU/kHA;EAAU,aAAA;EAAe,cAAA;AVolHzB;;AUllHA,wBAAA;AACA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVulHjC;EUtlHA;IAAY,oBAAA;IAAsB,qBAAA;EV0lHlC;EUzlHA;IAAY,aAAA;IAAe,cAAA;EV6lH3B;EU5lHA;IAAY,oBAAA;IAAsB,qBAAA;EVgmHlC;EU/lHA;IAAY,oBAAA;IAAsB,qBAAA;EVmmHlC;EUlmHA;IAAY,aAAA;IAAe,cAAA;EVsmH3B;EUrmHA;IAAY,oBAAA;IAAsB,qBAAA;EVymHlC;EUxmHA;IAAY,oBAAA;IAAsB,qBAAA;EV4mHlC;EU3mHA;IAAY,aAAA;IAAe,cAAA;EV+mH3B;EU9mHA;IAAa,oBAAA;IAAsB,qBAAA;EVknHnC;EUjnHA;IAAa,oBAAA;IAAsB,qBAAA;EVqnHnC;EUpnHA;IAAa,aAAA;IAAe,cAAA;EVwnH5B;AACF;AUtnHA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV0nHjC;EUznHA;IAAY,oBAAA;IAAsB,qBAAA;EV6nHlC;EU5nHA;IAAY,aAAA;IAAe,cAAA;EVgoH3B;EU/nHA;IAAY,oBAAA;IAAsB,qBAAA;EVmoHlC;EUloHA;IAAY,oBAAA;IAAsB,qBAAA;EVsoHlC;EUroHA;IAAY,aAAA;IAAe,cAAA;EVyoH3B;EUxoHA;IAAY,oBAAA;IAAsB,qBAAA;EV4oHlC;EU3oHA;IAAY,oBAAA;IAAsB,qBAAA;EV+oHlC;EU9oHA;IAAY,aAAA;IAAe,cAAA;EVkpH3B;EUjpHA;IAAa,oBAAA;IAAsB,qBAAA;EVqpHnC;EUppHA;IAAa,oBAAA;IAAsB,qBAAA;EVwpHnC;EUvpHA;IAAa,cAAA;IAAgB,eAAA;EV2pH7B;AACF;AUzpHA,4BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EV6pHjC;EU5pHA;IAAY,oBAAA;IAAsB,qBAAA;EVgqHlC;EU/pHA;IAAY,aAAA;IAAe,cAAA;EVmqH3B;EUlqHA;IAAY,oBAAA;IAAsB,qBAAA;EVsqHlC;EUrqHA;IAAY,oBAAA;IAAsB,qBAAA;EVyqHlC;EUxqHA;IAAY,aAAA;IAAe,cAAA;EV4qH3B;EU3qHA;IAAY,oBAAA;IAAsB,qBAAA;EV+qHlC;EU9qHA;IAAY,oBAAA;IAAsB,qBAAA;EVkrHlC;EUjrHA;IAAY,aAAA;IAAe,cAAA;EVqrH3B;EUprHA;IAAa,oBAAA;IAAsB,qBAAA;EVwrHnC;EUvrHA;IAAa,oBAAA;IAAsB,qBAAA;EV2rHnC;EU1rHA;IAAa,aAAA;IAAe,cAAA;EV8rH5B;AACF;AU5rHA,6BAAA,OAAA;EACE;IAAY,mBAAA;IAAqB,oBAAA;EVgsHjC;EU/rHA;IAAY,oBAAA;IAAsB,qBAAA;EVmsHlC;EUlsHA;IAAY,aAAA;IAAe,cAAA;EVssH3B;EUrsHA;IAAY,oBAAA;IAAsB,qBAAA;EVysHlC;EUxsHA;IAAY,oBAAA;IAAsB,qBAAA;EV4sHlC;EU3sHA;IAAY,aAAA;IAAe,cAAA;EV+sH3B;EU9sHA;IAAY,oBAAA;IAAsB,qBAAA;EVktHlC;EUjtHA;IAAY,oBAAA;IAAsB,qBAAA;EVqtHlC;EUptHA;IAAY,aAAA;IAAe,cAAA;EVwtH3B;EUvtHA;IAAa,oBAAA;IAAsB,qBAAA;EV2tHnC;EU1tHA;IAAa,oBAAA;IAAsB,qBAAA;EV8tHnC;EU7tHA;IAAa,aAAA;IAAe,cAAA;EViuH5B;AACF;AU/tHA,6BAAA,QAAA;EACE;IAAa,mBAAA;IAAqB,oBAAA;EVmuHlC;EUluHA;IAAa,oBAAA;IAAsB,qBAAA;EVsuHnC;EUruHA;IAAa,aAAA;IAAe,cAAA;EVyuH5B;EUxuHA;IAAa,oBAAA;IAAsB,qBAAA;EV4uHnC;EU3uHA;IAAa,oBAAA;IAAsB,qBAAA;EV+uHnC;EU9uHA;IAAa,aAAA;IAAe,cAAA;EVkvH5B;EUjvHA;IAAa,oBAAA;IAAsB,qBAAA;EVqvHnC;EUpvHA;IAAa,oBAAA;IAAsB,qBAAA;EVwvHnC;EUvvHA;IAAa,aAAA;IAAe,cAAA;EV2vH5B;EU1vHA;IAAc,oBAAA;IAAsB,qBAAA;EV8vHpC;EU7vHA;IAAc,oBAAA;IAAsB,qBAAA;EViwHpC;EUhwHA;IAAc,aAAA;IAAe,cAAA;EVowH7B;AACF;AUnwHA;EACE,0BAAA;AVqwHF;;AUnwHA;EACE,iBAAA;AVswHF;;AUpwHA;EACI,4CAAA;EACA,2BAAA;EACA,0BAAA;EACA,4BAAA;AVuwHJ;;AUpwHA;EACI,uBAAA;AVuwHJ;;AUpwHA;EACI,aAAA;AVuwHJ;;AUpwHA;EAEI,gCAAA;EACA,oCAAA;AVswHJ;;AAl6IA;EACE,UAAA;AAq6IF;AAn6IE;EAHF;IAII,UAAA;IACA,iBAAA;EAs6IF;AACF;;AAn6IA;EACE,WAAA;EACA,kBAAA;AAs6IF;AAr6IE;EACE,iBAAA;AAu6IJ;;AAp6IA;EACE,aAAA;EACA,mBAAA;AAu6IF;AAr6IE;EACE,WAAA;AAu6IJ;AAp6IE;EACE,cAAA;EACA,qBAAA;EACA,kBAAA;AAs6IJ;AAn6IE;EACE,uBAAA;AAq6IJ;AAl6IE;EACE,uBAAA;AAo6IJ;;AAh6IA;EACE,aAAA;AAm6IF;AAj6IE;EAHF;IAII,sBAAA;EAo6IF;AACF;;AAj6IA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EAEA,WAAA;AAm6IF;;AAh6IA;EACE,iBAAA;EACA,eAAA;AAm6IF;;AAh6IA;EACE,WAAA;EAEA,oBAAA;EACA,eAAA;AAk6IF;AAh6IE;EANF;IAOI,YAAA;EAm6IF;AACF;AAj6IE;EACE,eAAA;EACA,aAAA;EACA,sBAAA;AAm6IJ;AAj6II;EALF;IAMI,YAAA;EAo6IJ;AACF;AAj6IE;EACE,WAAA;EACA,OAAA;EACA,gBAAA;AAm6IJ;AAj6II;EALF;IAMI,WAAA;EAo6IJ;AACF;AAh6IE;EACE,8BAAA;EACA,iBAAA;AAk6IJ;AAh6II;EACE,YAAA;AAk6IN;AA95IE;EACE,aAAA;EACA,uBAAA;AAg6IJ;AA95II;EACE,YAAA;EACA,WAAA;EACA,yBAAA;EACA,UAAA;EACA,kBAAA;AAg6IN;AA95IM;EAPF;IAQI,WAAA;EAi6IN;AACF;AA75IE;EACE,2BAAA;EACA,YAAA;EAEA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA85IJ;AA55II;EAZF;IAaI,gBAAA;IACA,0BAAA;IACA,qBAAA;IACA,YAAA;EA+5IJ;AACF;AA75II;EACE,8BAAA;AA+5IN;AA35IE;EACE,iBAAA;EACA,uBAAA;EAEA,mBAAA;EACA,kBAAA;EACA,kCAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA45IJ;AA15II;EAZF;IAaI,gBAAA;IACA,UAAA;IACA,YAAA;EA65IJ;AACF;AA35II;EACE,8BAAA;AA65IN;AAz5IE;EACE,kBAAA;EACA,sBAAA;AA25IJ;AAx5IE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,mBAAA;AA05IJ;AAx5II;EANF;IAOI,gBAAA;EA25IJ;AACF;AAz5II;EACE,kBAAA;EACA,kBAAA;AA25IN;AAv5IE;EACE,sBAAA;AAy5IJ;AAt5IE;EACE,kBAAA;EACA,sBAAA;AAw5IJ;AAr5IE;EACE,sBAAA;AAu5IJ;AAp5IE;EACE,gBAAA;EACA,oBAAA;EACA,sBAAA;AAs5IJ;AAn5IE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAq5IJ;AAn5II;EACE,eAAA;AAq5IN;AAl5II;EATF;IAUI,gBAAA;IACA,mBAAA;EAq5IJ;AACF;AAl5IE;EACE,WAAA;EACI,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,gBAAA;AAo5IR;AAn5II;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAq5IN;AAn5IM;EACI,kBAAA;EACA,eAAA;AAq5IV;AAl5IE;EACI,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAo5IN;AAl5IM;EACI,0BAAA;AAo5IV;AAj5II;EA5BF;IA6BI,sBAAA;EAo5IJ;AACF;AAl5II;EACE,kBAAA;EACA,qBAAA;AAo5IN;;AAh5IA;EACE,WAAA;EACI,oBAAA;EACA,aAAA;EACA,8BAAA;EACA,gBAAA;AAm5IN;AAl5IE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;AAo5IJ;AAn5II;EANF;IAQI,iBAAA;EAq5IJ;AACF;AAp5II;EACI,kBAAA;EACA,eAAA;AAs5IR;AAn5IE;EArBF;IAsBI,sBAAA;EAs5IF;AACF;AAp5IE;EACE,kBAAA;AAs5IJ;;AAn5IA;EACE,WAAA;AAs5IF;;AAn5IA;EACE,eAAA;AAs5IF;;AAn5IA;EACE,8BAAA;EACA,gDAAA;AAs5IF;;AAn5IA;EACE,mBAAA;EACA,wDAAA;AAs5IF;;AAn5IA;EACE,8BAAA;EACA,6CAAA;AAs5IF;;AAn5IA;EACE,2BAAA;EACA,6BAAA;EAEA,gBAAA;AAq5IF;;AAl5IA;EACE,wBAAA;AAq5IF;;AAl5IA,2BAAA;AACA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,eAAA;EACA,kDAAA;AAq5IF;;AAl5IA;EACE,WAAA;EACA,aAAA;EAEA,8BAAA;AAo5IF;AAl5IE;EACE,UAAA;AAo5IJ;AAj5IE;EACE,WAAA;AAm5IJ;AAh5IE;EACE,UAAA;AAk5IJ;AA/4IE;EACE,UAAA;AAi5IJ;AA94IE;EACE,eAAA;EACA,iBAAA;AAg5IJ;;AA54IA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA+4IF;AA74IE;EACE,UAAA;AA+4IJ;AA54IE;EACE,WAAA;AA84IJ;AA34IE;EACE,UAAA;AA64IJ;AA14IE;EACE,eAAA;EACA,iBAAA;AA44IJ;;AAx4IA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AA24IF;AAz4IE;EACE,UAAA;AA24IJ;AAx4IE;EACE,WAAA;AA04IJ;AAv4IE;EACE,UAAA;AAy4IJ;AAt4IE;EACE,eAAA;EACA,iBAAA;AAw4IJ;;AAp4IA;EACE,UAAA;EACA,aAAA;AAu4IF;AAr4IE;EAEE,UAAA;AAs4IJ;AAn4IE;EAEE,UAAA;AAo4IJ;;AAh4IA;EACE,iBAAA;AAm4IF;;AAh4IA;EACE,+CAAA;EACA,wCAAA;EACA,oCAAA;EACA,4BAAA;AAm4IF;;AAh4IA;EACE,6CAAA;EACA,sBAAA;EACA,6CAAA;AAm4IF;;AAh4IA;EACE,+CAAA;EACA,YAAA;EACA,+CAAA;EACA,mBAAA;AAm4IF;;AAh4IA;EACE,wCAAA;EACA,kCAAA;EACA,6CAAA;AAm4IF;;AAh4IA;EACE,aAAA;EACA,sBAAA;AAm4IF;AAj4IE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAm4IJ;AAl4II;EACE,WAAA;EACA,UAAA;EACA,eAAA;AAo4IN;AAl4IM;EALF;IAMI,eAAA;IACA,kBAAA;EAq4IN;AACF;AAn4II;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAq4IN;AAp4IM;EALF;IAMI,eAAA;IACA,kBAAA;EAu4IN;AACF;AAr4II;EACE,kBAAA;AAu4IN;AAp4II;EACE,aAAA;EACA,mBAAA;AAs4IN;;AAj4IA;EACE,kCAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAo4IF;;AAj4IA;EACE,uBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAo4IF;;AAj4IA;EACE,qBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAo4IF;;AAj4IA;EACE,sBAAA;EACA,WAAA;EACA,oBAAA;EACA,qBAAA;AAo4IF;;AAj4IA;EACE,uBAAA;AAo4IF;;AAj4IA;EACE,aAAA;EACA,mBAAA;EACA,UAAA;AAo4IF;AAl4IE;EACE,UAAA;AAo4IJ;;AAh4IA;EACE,iBAAA;AAm4IF;;AAh4IA;EACE,WAAA;EACA,aAAA;EACA,sBAAA;AAm4IF;AAj4IE;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAm4IJ;AAj4II;EACE,UAAA;AAm4IN;AAh4II;EACE,kBAAA;EACA,iCAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,YAAA;AAk4IN;AAh4IM;EACE,kCAAA;AAk4IR;;AA53IA;EACE,WAAA;EACA,aAAA;AA+3IF;AA53IE;EACE,UAAA;AA83IJ;;AA13IA;EACE,iBAAA;EAEA,mBAAA;EACA,2BAAA;AA43IF;;AAz3IA;EACE,eAAA;EACA,eAAA;AA43IF;;AAz3IA;EACE,iBAAA;AA43IF;;AAz3IA;EACE,aAAA;EACA,mBAAA;AA43IF;;AAz3IA;EACE;;IAEE,sBAAA;EA43IF;EA13IE;;IACE,WAAA;EA63IJ;EAz3IA;IACE,WAAA;EA23IF;EAx3IA;IACE,WAAA;EA03IF;EAv3IA;IACE,OAAA;IACA,2BAAA;EAy3IF;EAt3IA;IACE,sBAAA;IACA,WAAA;EAw3IF;EAt3IE;IACE,WAAA;EAw3IJ;EAr3IE;IACE,iBAAA;IACA,UAAA;EAu3IJ;EAn3IA;IACE,aAAA;IACA,sBAAA;IACA,WAAA;IACA,mBAAA;EAq3IF;EAp3IE;IACE,WAAA;EAs3IJ;EAl3IA;IACE,qBAAA;IACA,YAAA;EAo3IF;EAj3IA;IACE,WAAA;IACA,mBAAA;IACA,iBAAA;IACA,gBAAA;EAm3IF;AACF;AAh3IA;EACE;IACE,aAAA;IACA,sBAAA;IACA,2BAAA;EAk3IF;AACF;AA/2IA;EACE,kCAAA;AAi3IF;AAh3IE;EAFF;IAGI,WAAA;IACA,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EAm3IF;AACF;AAl3IE;EACE,iBAAA;EACA,gBAAA;AAo3IJ;AAj3IE;EACE,wBAAA;AAm3IJ;AAj3II;EACE,iBAAA;EACA,YAAA;AAm3IN;AA/2IE;EACE,WAAA;EACA,aAAA;EAEA,sBAAA;AAg3IJ;AA92II;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAg3IN;AA92IM;EACE,UAAA;AAg3IR;AA52II;EACE,aAAA;EAEA,yBAAA;AA62IN;AA32IM;EACE,kBAAA;AA62IR;AA52IQ;EAFF;IAGI,eAAA;EA+2IR;AACF;AA72IM;EAXF;IAYI,UAAA;IACA,aAAA;IACA,sBAAA;EAg3IN;AACF;AA72II;EACE,eAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA+2IN;;AA12IA;EACE,WAAA;AA62IF;;AA12IA;EACE,gBAAA;AA62IF;;AA12IA;EACE,cAAA;AA62IF;AA32IE;EACE,eAAA;AA62IJ;AA12IE;EAPF;IAQI,UAAA;EA62IF;AACF;;AA12IA;EACE,kCAAA;AA62IF;AA52IE;EAFF;IAGI,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,sBAAA;EA+2IF;AACF;AA92IE;EACE,iBAAA;EACA,gBAAA;AAg3IJ;AA72IE;EACE,aAAA;EACA,mBAAA;AA+2IJ;AA92II;EACE,iBAAA;AAg3IN;AA72II;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;AA+2IN;;AA12IA;EACE;IACE,oBAAA;IACA,gBAAA;EA62IF;EA32IA;IACE,uBAAA;EA62IF;EA12IA;IAGE,aAAA;IACA,sBAAA;IACA,kCAAA;IACA,UAAA;EA02IF;EAx2IE;IACE,iBAAA;IACA,2BAAA;EA02IJ;EAt2IA;IACE,iBAAA;IACA,sBAAA;EAw2IF;EAt2IE;IACE,sBAAA;EAw2IJ;EAr2IE;IACE,WAAA;EAu2IJ;AACF;AAn2IA;EACE,8BAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,aAAA;AAq2IF;AAp2IE;EACE,aAAA;EACA,iBAAA;EACA,4CAAA;EACA,gBAAA;AAs2IJ;AAp2IE;EAZF;IAaI,YAAA;IACA,UAAA;EAu2IF;AACF;;AAp2IA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;AAu2IF;AAr2IE;EACE,sBAAA;AAu2IJ;AAp2IE;EACE,UAAA;EACA,aAAA;EACA,sBAAA;AAs2IJ;AAp2II;EALF;IAMI,UAAA;EAu2IJ;AACF;AAr2II;EACE,sBAAA;AAu2IN;AAn2IM;EACE,eAAA;EAEA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,WAAA;AAo2IR;AA/1IE;EApCF;IAqCI,gBAAA;EAk2IF;AACF;;AA/1IA;EACE;IACE,aAAA;IACA,mBAAA;IACA,8BAAA;EAk2IF;EAh2IE;IACE,qBAAA;EAk2IJ;EA/1IE;IACE,UAAA;EAi2IJ;EA/1II;IACE,qBAAA;EAi2IN;EA91II;IACE,aAAA;IACA,mBAAA;IACA,mBAAA;IACA,8BAAA;EAg2IN;EA91IM;IACE,YAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,uBAAA;EAg2IR;AACF;AA31IA;EACE,mBAAA;EACA,sBAAA;EACA,kBAAA,EAAA,uCAAA;AA61IF;;AA11IA;EACE,eAAA;AA61IF;;AA11IA;EACE,oBAAA;EACA,uBAAA;EACA,QAAA;AA61IF;AA31IE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AA61IJ;AA31II;EACE,WAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA61IN;AA11II;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,iCAAA;EACA,mBAAA;AA41IN;AA11IM;EACE,eAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AA41IR;;AAt1IA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;EACA,eAAA;AAy1IF;AAv1IE;EACE,WAAA;EACA,iBAAA;EACA,iCAAA;AAy1IJ;AAt1IE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAw1IJ;AAt1II;EACE,WAAA;AAw1IN;AAr1II;EACE,iCAAA;EACA,WAAA;AAu1IN;;AAl1IA;EACE,gBAAA;EACA,cAAA;AAq1IF;AAn1IE;EACE,uBAAA;EACA,iCAAA;EACA,iBAAA;AAq1IJ;AAn1II;EACE,iBAAA;AAq1IN;AAl1II;EACE,YAAA;AAo1IN","sourcesContent":["@import \"src/styles\";\n.contract-container {\n  width: 90%;\n  display: flex;\n  flex-direction: column;\n  padding: 2rem;\n  font-family: \"Barlow\", sans-serif;\n  @media (max-width: 1024px) {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    padding: 0rem;\n    margin-top: 95px;\n  }\n\n  .header {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    margin: 25px 0px;\n    @media (max-width: 1024px) {\n\n    }\n    h6 {\n      margin: 0px;\n      width: 80%;\n      font-size: 32px;\n    \n      @media (max-width: 1024px) {\n        font-size: 18px;\n        text-align: center;\n      }\n    }\n    h5 {\n      font-size: 24px;\n      margin-top: 10px;\n      margin-bottom: 0px;\n      color: #706f6f;\n      @media (max-width: 1024px) {\n        font-size: 14px;\n        text-align: center;\n      }\n    }\n   \n    h6 {\n      margin: 0rem;\n    }\n  }\n}\n.step-container {\n  display: flex;\n  align-items: center;\n  background-color: #F4F4F4;\n  padding: 15px 20px;\n  padding: 0px 20px;\n  position: relative;\n  // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  height: 92px;\n\n}\n.step-container::after {\n  content: \"\";\n  position: absolute;\n  bottom: -23px;\n  left: 85%;\n  width: 100%;\n  transform: translateX(-50%);\n  width: 124px;\n  height: 25px;\n  background-color: #F4F4F4;\n  clip-path: polygon(50% 100%, 0 0, 100% 0);\n\n  @media (max-width: 1024px) {\n  left:50%\n        \n    }\n\n}\n.step {\n  display: flex;\n  align-items: center;\n  h5{\n      margin: 0px; \n      color: #575756; \n      font-size: 24px;\n      @media (max-width: 1024px) {\n          font-size: 16px;\n            \n        }\n  }\n}\n.step-icon-media{\n\n  display: none;\n  @media (max-width: 1024px) {\n      display: block;\n      width: 75px;\n      height: 75px;\n      color: white;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      border-radius: 50%;\n      font-size: 16px;\n      margin-right: 10px;\n      }\n}\n.step-icon {\n  width: 32px;\n  height: 32px;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  font-size: 16px;\n  margin-right: 10px;\n  @media (max-width: 1024px) {\n      display: none;\n  }\n}\n.step-title {\n  font-weight: bold;\n  color: #333;\n  font-size: 16px;\n}\n.step-line {\n  flex-grow: 1;\n  height: 1px;\n  background-color: #999;\n  margin: 0 40px;\n  @media (max-width: 1024px) {\n    display: none;\n      \n  }\n}\n.check{\n  background-color: #28BA62;\n}\n.step-disabled {\n  color: #999;\n  display: flex;\n  align-items: center;\n  font-size: 16px;\n  @media (max-width: 1024px) {\n      display: none;\n        \n    }\n}\n.step-disabled .circle {\n  width: 32px;\n  height: 32px;\n\n  border-radius: 50%;\n  margin-right: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.space {\n  width: 100%;\n  background-color: #fbfbfb;\n  height: 80px;\n  margin-bottom: -15px;\n  @media(max-width:1024px){\n    height: 50px;\n  }\n}\n.bold-font {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.detail-contract {\n  width: 100%;\n  @media (min-width: 1025px) {\n    width: 100%;\n  }\n}\n::ng-deep .mat-tab-group .mat-tab-label {\n  color: #666; /* Cor padrão da label */\n}\n\n::ng-deep .mat-tab-group .mat-tab-label.mat-tab-label-active {\n  color: #d32f2f !important; /* Cor da label quando selecionado */\n}\n.contract-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 15px 15px 0 0;\n  border-top: 1px solid #ddd;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  background-color: #f4f4f4;\n  height: 90px;\n  @media (max-width: 1024px) {\n    height: 100px;\n  }\n}\n.contract-title {\n  padding-left: 16px;\n  width: 50%;\n  @media(max-width:1024px){\n    width: 100%;\n  }\n  .type-concession {\n    display: flex;\n    @media(max-width:1024px){\n      width: 100%;\n      justify-content: center;\n    }\n    img {\n      padding-right: 8px;\n    }\n    p {\n      font-size: 16px;\n      margin-top: 5px;\n      margin-bottom: 5px;\n      margin-left: 3px;\n    }\n  }\n  h2 {\n    font-size: 1.5rem;\n    margin: 0;\n    padding: 0rem;\n    line-height: normal;\n    @media(max-width:1024px){\n      width: 100%;\n      text-align: start;\n      margin-top: 16px;\n      margin-bottom: 16px;\n      margin-left: 16px;\n    }\n  }\n\n  span {\n    font-size: 16px;\n    color: #888;\n  }\n}\n\n.contract-type {\n  width: 50%;\n  display: flex;\n  justify-content: center;\n  @media(max-width:1024px){\n    display: none;\n  }\n  p {\n    font-size: 16px;\n    margin: 0 16px;\n  }\n}\np {\n  font-size: 16px;\n  margin: 0 16px;\n}\n\n.contract-info {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  padding-top: 20px;\n  background-color: #fbfbfb;\n}\n\n.contract-info .infos {\n  width: 100%;\n  padding: 0 16px;\n\n  @media (max-width: 1024px) {\n    width: 100%;\n  }\n}\n.dates {\n  display: flex;\n}\n\n.entity,\n.values,\n.duration {\n  width: 100%;\n  display: flex;\n  flex-direction: row !important;\n  justify-content: space-between !important;\n}\n\n.entity p,\n.values p,\n.dates p,\n.duration p,\n.user-info p {\n  margin: 10px 32px 24px 0px;\n  width: auto;\n}\n\n.values,\n.duration {\n  display: flex;\n  flex-direction: column;\n}\n\n.user-info {\n  width: 30% !important;\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n\n  .icon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    display: flex;\n    border: 2px solid black;\n    align-items: center;\n    justify-content: center;\n    background-color: #fff;\n \n  }\n}\n\n.user-info img {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  margin-bottom: 10px;\n}\n\n.accordion{\n  margin-top: 32px;\n  border-bottom: 1px rgb(174, 15, 10) solid;\n}\n.accordion-active{\n  margin-top: 32px;\n  border-bottom: 1px rgb(174, 15, 10) solid;\n}\n.accordion-inactive{\n  margin-top: 32px;\n  border-bottom: 1px #706F6F solid;\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\nmat-panel-title{\n  img{\n    padding-left: 16px;\n  }\n  h1{\n    font-size: 24px !important;\n    padding-left: 16px;\n  }\n \n}\nmat-expansion-panel-header{\n  padding: 0 !important;\n}\n@media (max-width: 1024px) {\n  .entity,\n  .values,\n  .dates,\n  .duration {\n    width: 100%;\n    display: flex;\n    flex-direction: column !important;\n    align-items: flex-start !important;\n    justify-content: flex-start !important;\n  }\n\n  .contract-header {\n    flex-direction: column;\n    text-align: center;\n  }\n\n  .contract-info {\n    flex-direction: column;\n    // align-items: center;\n  }\n\n  .contract-info > div {\n    text-align: center;\n  }\n\n  .user-info {\n    margin-top: 2rem;\n    width: 100% !important;\n\n    display: flex !important;\n    justify-content: center !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .header {\n    flex-direction: column !important;\n    justify-content: center !important;\n    align-items: start !important;\n  }\n}\n\n::ng-deep .mat-tab-label {\n  border-bottom: 2px solid transparent;\n  /* Borda padrão para todas as abas */\n  font-weight: bold;\n  /* Estilo da fonte */\n  padding: 8px 16px;\n  transition: border-color 0.3s ease;\n}\n\n::ng-deep .mat-tab-label-active {\n  border-bottom: 3px solid #1976d2;\n  /* Borda azul para a aba ativa */\n  color: #1976d2;\n  /* Cor do texto da aba ativa */\n}\n\n::ng-deep .mat-tab-label {\n  font-size: 16px;\n  /* Tamanho do texto */\n}\n\n::ng-deep .mat-tab-group {\n  background-color: #f5f5f5;\n  /* Cor de fundo do cabeçalho das abas */\n  padding: 0 16px;\n}\n\n@import \"src/styles\";\n\n.field-width {\n  width: 70%;\n\n  @media (max-width: 1024px) {\n    width: 90%;\n    margin-left: 15px;\n  }\n}\n\n.text {\n  width: 100%;\n  padding-left: 1rem;\n  p {\n    font-size: 0.8rem;\n  }\n}\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\n.login-container {\n  display: flex;\n\n  @media (max-width: 1024px) {\n    flex-direction: column;\n  }\n}\n\n.form-container {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  // height: 92vh;\n  width: 100%;\n}\n\n.bold-font {\n  font-weight: bold;\n  font-size: 1rem;\n}\n\n.login-form {\n  width: 100%;\n  // height: 100%;\n  margin-bottom: 10rem;\n  padding: 0 8rem;\n\n  @media (max-width: 1024px) {\n    height: 92vh;\n  }\n\n  form {\n    height: inherit;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 1024px) {\n      height: 92vh;\n    }\n  }\n\n  .fields {\n    width: 100%;\n    flex: 1;\n    min-height: 55vh;\n\n    @media (max-width: 1024px) {\n      width: 100%;\n      // min-height: 55%;\n    }\n  }\n\n  .subtitle {\n    border-bottom: 1px solid black;\n    margin: 1rem 0rem;\n\n    h6 {\n      margin: 0rem;\n    }\n  }\n\n  .line {\n    display: flex;\n    justify-content: center;\n\n    hr {\n      border: none;\n      height: 2px;\n      background-color: #bdbcbc;\n      width: 80%;\n      border-radius: 5px;\n\n      @media (max-width: 1024px) {\n        width: 100%;\n      }\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    background: map-get($secondary-color, 500);\n    color: white;\n    // width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: none;\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed:nth-of-type(2) {\n    background: white;\n    color: map-get($primary-color, 500);\n    // width: 14rem;\n    border-radius: 10px;\n    padding: 0.75rem 0;\n    border: 2px solid map-get($primary-color, 500);\n    font-weight: bold;\n    margin-top: 2.5rem;\n    align-self: center;\n    cursor: pointer;\n\n    @media (max-width: 1024px) {\n      margin-top: 15px;\n      width: 40%;\n      height: 45px;\n    }\n\n    &[disabled] {\n      background: map-get($medium-color, 700);\n    }\n  }\n\n  .name-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .invalid {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 15px;\n\n    @media (max-width: 1024px) {\n      margin-left: 5px;\n    }\n\n    .icon-error {\n      padding-left: 10px;\n      padding-right: 8px;\n    }\n  }\n\n  .login-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-form-field {\n    text-align: center;\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix {\n    color: map-get($dark-color, 300);\n  }\n\n  .email-field-prefix-invalid {\n    padding-top: 7px;\n    padding-bottom: 15px;\n    color: map-get($dark-color, 300);\n  }\n\n  h6 {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    mat-icon {\n      cursor: pointer;\n    }\n\n    @media (max-width: 1024px) {\n      margin-top: 2rem;\n      margin-bottom: 2rem;\n    }\n  }\n\n  .buttons {\n    width: 100%;\n        padding-bottom: 1rem;\n        display: flex;\n        justify-content: center;\n        margin-top: 32px;\n    .back{\n      width: 33%;\n      display: flex;\n      justify-content: start;\n      align-items: center;\n      margin-left: 20px;\n     \n      img{\n          margin-right: 10px;\n          cursor: pointer;\n      }\n  }\n  .actions{\n      width: 77%;\n      display: flex;\n      justify-content: start;\n      align-items: center;\n\n      button{\n          margin: 0% 15px !important;\n      }\n  }\n    @media (max-width: 1024px) {\n      flex-direction: column;\n    }\n\n    button:first-of-type {\n      margin-right: 10px;\n      width: 40% !important;\n    }\n  }\n}\n.buttons {\n  width: 100%;\n      padding-bottom: 1rem;\n      display: flex;\n      justify-content: space-between;\n      margin-top: 32px;\n  .back{\n    width: 30%;\n    display: flex;\n    justify-content: start;\n    align-items: center;\n    margin-left: 20px;\n    @media (max-width: 1024px) {\n      // width: 40%;\n      margin-left: 20px;\n    }\n    img{\n        margin-right: 10px;\n        cursor: pointer;\n    }\n}\n  @media (max-width: 1024px) {\n    flex-direction: column;\n  }\n\n  button:first-of-type {\n    margin-right: 10px;\n  }\n}\n.first-input {\n  width: 100%;\n}\n\n.mat-expansion-panel-header-title {\n  font-size: 1rem;\n}\n\n.panel-with-border .mat-expansion-panel-header {\n  border-bottom: 1px solid black;\n  /* Estilo da borda quando o painel está aberto */\n}\n\n.panel-with-border .mat-expansion-panel-header.mat-expanded {\n  border-bottom: none;\n  /* Remove a borda inferior quando o painel está aberto */\n}\n\n.panel-with-border.mat-expansion-panel {\n  border-bottom: 1px solid black;\n  /* Estilo da borda do painel quando fechado */\n}\n\n.mat-expansion-panel {\n  box-shadow: none !important;\n  background-color: transparent;\n  // border-bottom: 1px solid;\n  border-radius: 0;\n}\n\n.mat-mdc-select-arrow-wrapper {\n  display: none !important;\n}\n\n/* Estilizar o novo ícone */\n.custom-select-icon {\n  position: absolute;\n  right: 10px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  font-size: 24px;\n  /* Ajuste o tamanho do ícone conforme necessário */\n}\n\n.form-group {\n  width: 100%;\n  display: flex;\n  // align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 45%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .date-input {\n    width: 20%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.form-group-row {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 30%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.form-group-row2 {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  .mat-mdc-form-field {\n    width: 20%;\n  }\n\n  .first-input {\n    width: 100%;\n  }\n\n  .bank-form-field {\n    width: 70%;\n  }\n\n  p {\n    margin-top: 0px;\n    font-size: 1.1rem;\n  }\n}\n\n.date-select {\n  width: 30%;\n  display: flex;\n\n  .mat-mdc-form-field {\n    // margin-bottom: -1.5rem;\n    width: 70%;\n  }\n\n  .select-year {\n    // margin-bottom: -1.5rem;\n    width: 30%;\n  }\n}\n\n.btn-primary {\n  margin: 1rem 0rem;\n}\n\n.btn-exclude {\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  background-color: transparent !important;\n  color: rgba(112, 111, 111, 1) !important;\n  font-weight: bold !important;\n}\n\n.btn-submit {\n  background-color: rgba(174, 15, 10, 1) !important;\n  color: #fff !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.disabled-button {\n  background-color: rgba(112, 111, 111, 1) !important;\n  color: white;\n  border: 2px solid rgba(112, 111, 111, 1) !important;\n  cursor: not-allowed;\n}\n\n.btn-submit {\n  background-color: transparent !important;\n  color: rgba(174, 15, 10, 1) !important;\n  border: 2px solid rgba(174, 15, 10, 1) !important;\n}\n\n.header-form {\n  display: flex;\n  flex-direction: column;\n\n  .header-title {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    h6 {\n      margin: 0px;\n      width: 80%;\n      font-size: 32px;\n    \n      @media (max-width: 1024px) {\n        font-size: 18px;\n        text-align: center;\n      }\n    }\n    h5 {\n      font-size: 24px;\n      margin-top: 10px;\n      margin-bottom: 0px;\n      color: #706f6f;\n      @media (max-width: 1024px) {\n        font-size: 14px;\n        text-align: center;\n      }\n    }\n    h6 {\n      margin-bottom: 0px;\n    }\n\n    .btn-header {\n      display: flex;\n      align-items: center;\n    }\n  }\n}\n\n.status-cadastrando {\n  background-color: rgb(219, 151, 5);\n  color: #fff;\n  padding: 0.2rem 2rem;\n  border-radius: 0.3rem;\n}\n\n.status-aprovado {\n  background-color: green;\n  color: #fff;\n  padding: 0.2rem 2rem;\n  border-radius: 0.3rem;\n}\n\n.status-rejeitado {\n  background-color: red;\n  color: #fff;\n  padding: 0.2rem 2rem;\n  border-radius: 0.3rem;\n}\n\n.status-desconhecido {\n  background-color: gray;\n  color: #fff;\n  padding: 0.2rem 2rem;\n  border-radius: 0.3rem;\n}\n\n.mat-mdc-expansion-panel-body {\n  padding: 0px !important;\n}\n\n.data-eficacia-form-group {\n  display: flex;\n  align-items: center;\n  width: 30%;\n\n  .mat-mdc-form-field {\n    width: 90%;\n  }\n}\n\n.form-section-field {\n  margin: 2rem auto;\n}\n\n.header-legend {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n\n  .first-filter {\n    width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 90%;\n    }\n\n    .btn {\n      padding: 1rem 2rem;\n      background-color: rgba(227, 6, 19, 1);\n      color: #fff;\n      border-radius: 0.5rem;\n      cursor: pointer;\n      border: none;\n\n      &:hover {\n        background-color: rgba(174, 15, 10, 1);\n      }\n    }\n  }\n}\n\n.header-form {\n  width: 100%;\n  display: flex;\n  // align-items: center;\n\n  h6 {\n    width: 80%;\n  }\n}\n\n.bredCrumb {\n  margin: 1rem 0rem;\n  // display: flex;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.bredCrumb p {\n  display: inline;\n  cursor: pointer;\n}\n\n.bredCrumb p.selected {\n  font-weight: bold;\n}\n\n.anexos {\n  display: flex;\n  align-items: center;\n}\n\n@media (max-width: 1024px) {\n  .form-group-row,\n  .form-group {\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .data-eficacia-form-group {\n    width: 100%;\n  }\n\n  .date-select {\n    width: 100%;\n  }\n\n  .fields {\n    flex: 1;\n    min-height: auto !important;\n  }\n\n  .first-filter {\n    flex-direction: column;\n    width: 100%;\n\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n\n    .btn {\n      margin: 1rem 0rem;\n      width: 90%;\n    }\n  }\n\n  .filters {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    .mat-mdc-form-field {\n      width: 100%;\n    }\n  }\n\n  .login-form {\n    width: 90% !important;\n    margin: auto;\n  }\n\n  .buttons {\n    width: 100%;\n    align-items: center;\n    margin: 0rem auto;\n    margin-top: 24px;\n  }\n}\n\n@media (max-width: 1024px) {\n  .bredCrumb {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n  }\n}\n\n.container-interveniente {\n  border-radius: 1rem 1rem 0rem 0rem;\n  @media (max-width: 1024px) {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .title {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .header-container {\n    border-bottom: 1px solid;\n\n    h3 {\n      font-size: 1.2rem;\n      margin: 0rem;\n    }\n  }\n\n  .filters {\n    width: 100%;\n    display: flex;\n    // align-items: center;\n    flex-direction: column;\n\n    .row {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n\n      .mat-mdc-form-field {\n        width: 80%;\n      }\n    }\n\n    .more-filters {\n      display: flex;\n\n      justify-content: flex-end;\n\n      .mat-mdc-form-field:first-child {\n        margin-right: 2rem;\n        @media (max-width: 1024px) {\n          margin-right: 0;\n        }\n      }\n      @media (max-width: 1024px) {\n        width: 96%;\n        display: flex;\n        flex-direction: column;\n      }\n    }\n\n    button {\n      cursor: pointer;\n      padding: 1rem 2rem;\n      background-color: rgba(174, 15, 10, 1);\n      color: #fff;\n      border: none;\n      border-radius: 0.6rem;\n    }\n  }\n}\n\ntable {\n  width: 100%;\n}\n\nth {\n  font-weight: 700;\n}\n\n.entitie-list-table-wrapper {\n  overflow: auto;\n\n  th {\n    cursor: pointer;\n  }\n\n  @media (max-width: 1024px) {\n    width: 96%;\n  }\n}\n\n.document-container {\n  border-radius: 1rem 1rem 0rem 0rem;\n  @media (max-width: 1024px) {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n  }\n  .title-document {\n    font-size: 1.2rem;\n    font-weight: 700;\n  }\n\n  .header-document {\n    display: flex;\n    align-items: center;\n    span {\n      margin-left: 1rem;\n    }\n\n    .button-add {\n      font-weight: 400;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      background-color: rgba(174, 15, 10, 1);\n      color: #fff;\n      border: none;\n      border-radius: 0.6rem;\n    }\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-doc {\n    margin: 0 !important;\n    font-weight: 500;\n  }\n  .bredCrumb {\n    align-items: flex-start;\n  }\n\n  .header-document {\n    // margin: 1rem auto;\n    // margin: 1rem auto;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start !important;\n    width: 96%;\n\n    span {\n      margin: 1rem 0rem;\n      margin-left: 0px !important;\n    }\n  }\n\n  .row {\n    margin: 1rem auto;\n    flex-direction: column;\n\n    .mat-mdc-form-field {\n      width: 100% !important;\n    }\n\n    button {\n      width: 100%;\n    }\n  }\n}\n\n.legend {\n  border-bottom: 1px solid black;\n  padding: 1rem;\n  font-weight: bold;\n  margin: 1rem auto;\n  display: flex;\n  .btn-adc {\n    display: flex;\n    margin-left: 16px;\n    font-family: \"Barlow\", sans-serif !important;\n    min-width: 150px;\n  }\n  @media (max-width: 1024px) {\n    margin: 0rem;\n    width: 96%;\n  }\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n\n  .mat-mdc-form-field {\n    width: 100% !important;\n  }\n\n  .filtered-more-options {\n    width: 75%;\n    display: flex;\n    flex-direction: column;\n\n    @media (max-width: 1024px) {\n      width: 96%;\n    }\n\n    .mat-mdc-form-field {\n      width: 100% !important;\n    }\n\n    .row-filter {\n      button {\n        cursor: pointer;\n        // margin: 1rem;\n        padding: 1rem 2rem;\n        background-color: rgba(174, 15, 10, 1);\n        color: #fff;\n        border: none;\n        border-radius: 0.6rem;\n        width: 100%;\n      }\n    }\n  }\n\n  @media (max-width: 1024px) {\n    margin: 16px 0px;\n  }\n}\n\n@media (min-width: 1025px) {\n  .header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n\n    .mat-mdc-form-field {\n      width: 20% !important;\n    }\n\n    .filtered-more-options {\n      width: 75%;\n\n      .mat-mdc-form-field {\n        width: 70% !important;\n      }\n\n      .row-filter {\n        display: flex;\n        flex-direction: row;\n        align-items: center;\n        justify-content: space-between;\n\n        button {\n          margin: 1rem;\n          width: 40%;\n          display: flex;\n          align-items: center;\n          justify-content: center;\n        }\n      }\n    }\n  }\n}\n.tab-label-wrap {\n  white-space: normal;\n  word-break: break-word;\n  text-align: center; /* opcional, só se quiser centralizar */\n}\n\n.prazos-form {\n  padding: 1rem 0;\n}\n\n.prazos-content-wrapper {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 8px;\n\n  .prazos-actions-side {\n    display: flex;\n    align-items: center;\n    padding-top: 4px;\n\n    .prazo-separator {\n      color: #bbb;\n      font-size: 20px;\n      line-height: 1;\n      margin-right: 4px;\n    }\n\n    .btn-historico-prazo {\n      display: flex;\n      align-items: center;\n      gap: 4px;\n      color: #757575;\n      font-family: 'Barlow', sans-serif;\n      font-weight: normal;\n\n      mat-icon {\n        font-size: 18px;\n        height: 18px;\n        width: 18px;\n        color: #757575;\n      }\n    }\n  }\n}\n\n.prazo-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 4px 0;\n  flex-wrap: wrap;\n\n  .prazo-label {\n    width: 90px;\n    font-weight: bold;\n    font-family: 'Barlow', sans-serif;\n  }\n\n  .prazo-input-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n\n    .prazo-dias-field {\n      width: 90px;\n    }\n\n    .dias-text {\n      font-family: 'Barlow', sans-serif;\n      color: #555;\n    }\n  }\n}\n\n.prazo-save-container {\n  margin-top: 16px;\n  padding: 8px 0;\n\n  .btn-save-prazo {\n    color: rgba(174, 15, 10, 1);\n    font-family: 'Barlow', sans-serif;\n    font-weight: bold;\n\n    mat-icon {\n      margin-right: 4px;\n    }\n\n    &:disabled {\n      opacity: 0.5;\n    }\n  }\n}","@use '@angular/cdk';\n\n@mixin ripple() {\n  // The host element of an mat-ripple directive should always have a position of \"absolute\" or\n  // \"relative\" so that the ripples inside are correctly positioned relatively to the container.\n  .mat-ripple {\n    overflow: hidden;\n\n    // By default, every ripple container should have position: relative in favor of creating an\n    // easy API for developers using the MatRipple directive.\n    position: relative;\n\n    // Promote containers that have ripples to a new layer. We want to target `:not(:empty)`,\n    // because we don't want all ripple containers to have their own layer since they're used in a\n    // lot of places and the layer is only relevant while animating. Note that ideally we'd use\n    // the `contain` property here (see #13175), because `:empty` can be broken by having extra\n    // text inside the element, but it isn't very well supported yet.\n    &:not(:empty) {\n      transform: translateZ(0);\n    }\n  }\n\n  .mat-ripple.mat-ripple-unbounded {\n    overflow: visible;\n  }\n\n  .mat-ripple-element {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n\n    transition: opacity, transform 0ms cubic-bezier(0, 0, 0.2, 1);\n\n    // We use a 3d transform here in order to avoid an issue in Safari where\n    // the ripples aren't clipped when inside the shadow DOM (see #24028).\n    transform: scale3d(0, 0, 0);\n\n    // In high contrast mode the ripple is opaque, causing it to obstruct the content.\n    @include cdk.high-contrast(active, off) {\n      display: none;\n    }\n  }\n}\n","/// Emits a CSS class, `.cdk-visually-hidden`. This class can be applied to an element\n/// to make that element visually hidden while remaining available to assistive technology.\n@mixin a11y-visually-hidden() {\n  .cdk-visually-hidden {\n    border: 0;\n    clip: rect(0 0 0 0);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    width: 1px;\n\n    // This works around a Chrome bug that can cause the tab to crash when large amounts of\n    // non-English text get wrapped: https://bugs.chromium.org/p/chromium/issues/detail?id=1201444\n    white-space: nowrap;\n\n    // Avoid browsers rendering the focus ring in some cases.\n    outline: 0;\n\n    // Avoid some cases where the browser will still render the native controls (see #9049).\n    -webkit-appearance: none;\n    -moz-appearance: none;\n\n    // We need at least one of top/bottom/left/right in order to prevent cases where the\n    // absolute-positioned element is pushed down and can affect scrolling (see #24597).\n    // `left` was chosen here, because it's the least likely to break overrides where the\n    // element might have been positioned (e.g. `mat-checkbox`).\n    left: 0;\n\n    [dir='rtl'] & {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n/// @deprecated Use `a11y-visually-hidden`.\n@mixin a11y() {\n  @include a11y-visually-hidden;\n}\n\n/// Emits the mixin's content nested under `$selector-context` if `$selector-context`\n/// is non-empty.\n/// @param {String} selector-context The selector under which to nest the mixin's content.\n@mixin _optionally-nest-content($selector-context) {\n  @if ($selector-context == '') {\n    @content;\n  }\n  @else {\n    #{$selector-context} {\n      @content;\n    }\n  }\n}\n\n/// Applies styles for users in high contrast mode. Note that this only applies\n/// to Microsoft browsers. Chrome can be included by checking for the `html[hc]`\n/// attribute, however Chrome handles high contrast differently.\n///\n/// @param {String} target Type of high contrast setting to target. Defaults to `active`, can be\n///     `white-on-black` or `black-on-white`.\n/// @param {String} encapsulation Whether to emit styles for view encapsulation. Values are:\n///     * `on` - works for `Emulated`, `Native`, and `ShadowDom`\n///     * `off` - works for `None`\n///     * `any` - works for all encapsulation modes by emitting the CSS twice (default).\n@mixin high-contrast($target: active, $encapsulation: 'any') {\n  @if ($target != 'active' and $target != 'black-on-white' and $target != 'white-on-black') {\n    @error 'Unknown cdk-high-contrast value \"#{$target}\" provided. ' +\n           'Allowed values are \"active\", \"black-on-white\", and \"white-on-black\"';\n  }\n\n  @if ($encapsulation != 'on' and $encapsulation != 'off' and $encapsulation != 'any') {\n    @error 'Unknown cdk-high-contrast encapsulation \"#{$encapsulation}\" provided. ' +\n           'Allowed values are \"on\", \"off\", and \"any\"';\n  }\n\n  // If the selector context has multiple parts, such as `.section, .region`, just doing\n  // `.cdk-high-contrast-xxx #{&}` will only apply the parent selector to the first part of the\n  // context. We address this by nesting the selector context under .cdk-high-contrast.\n  @at-root {\n    $selector-context: #{&};\n\n    @if ($encapsulation != 'on') {\n      // Note that if this selector is updated, the same change has to be made inside\n      // `_overlay.scss` which can't depend on this mixin due to some infrastructure limitations.\n      .cdk-high-contrast-#{$target} {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n\n    @if ($encapsulation != 'off') {\n      .cdk-high-contrast-#{$target} :host {\n        @include _optionally-nest-content($selector-context) {\n          @content;\n        }\n      }\n    }\n  }\n}\n","// We want overlays to always appear over user content, so set a baseline\n// very high z-index for the overlay container, which is where we create the new\n// stacking context for all overlays.\n$overlay-container-z-index: 1000 !default;\n$overlay-z-index: 1000 !default;\n$overlay-backdrop-z-index: 1000 !default;\n\n// Background color for all of the backdrops\n$overlay-backdrop-color: rgba(0, 0, 0, 0.32) !default;\n\n// Default backdrop animation is based on the Material Design swift-ease-out.\n$backdrop-animation-duration: 400ms !default;\n$backdrop-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1) !default;\n\n/// Emits structural styles required for cdk/overlay to function.\n@mixin overlay() {\n  .cdk-overlay-container, .cdk-global-overlay-wrapper {\n    // Disable events from being captured on the overlay container.\n    pointer-events: none;\n\n    // The container should be the size of the viewport.\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n  }\n\n  // The overlay-container is an invisible element which contains all individual overlays.\n  .cdk-overlay-container {\n    position: fixed;\n    z-index: $overlay-container-z-index;\n\n    &:empty {\n      // Hide the element when it doesn't have any child nodes. This doesn't\n      // include overlays that have been detached, rather than disposed.\n      display: none;\n    }\n  }\n\n  // We use an extra wrapper element in order to use make the overlay itself a flex item.\n  // This makes centering the overlay easy without running into the subpixel rendering\n  // problems tied to using `transform` and without interfering with the other position\n  // strategies.\n  .cdk-global-overlay-wrapper {\n    display: flex;\n    position: absolute;\n    z-index: $overlay-z-index;\n  }\n\n  // A single overlay pane.\n  .cdk-overlay-pane {\n    // Note: it's important for this one to start off `absolute`,\n    // in order for us to be able to measure it correctly.\n    position: absolute;\n    pointer-events: auto;\n    box-sizing: border-box;\n    z-index: $overlay-z-index;\n\n    // For connected-position overlays, we set `display: flex` in\n    // order to force `max-width` and `max-height` to take effect.\n    display: flex;\n    max-width: 100%;\n    max-height: 100%;\n  }\n\n  .cdk-overlay-backdrop {\n    // TODO(jelbourn): reuse sidenav fullscreen mixin.\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n\n    z-index: $overlay-backdrop-z-index;\n    pointer-events: auto;\n    -webkit-tap-highlight-color: transparent;\n    transition: opacity $backdrop-animation-duration $backdrop-animation-timing-function;\n    opacity: 0;\n\n    &.cdk-overlay-backdrop-showing {\n      opacity: 1;\n\n      // Note that we can't import and use the `high-contrast` mixin from `_a11y.scss`, because\n      // this file will be copied to the top-level `cdk` package when putting together the files\n      // for npm. Any relative import paths we use here will become invalid once the file is copied.\n      .cdk-high-contrast-active & {\n        // In high contrast mode the rgba background will become solid\n        // so we need to fall back to making it opaque using `opacity`.\n        opacity: 0.6;\n      }\n    }\n  }\n\n  .cdk-overlay-dark-backdrop {\n    background: $overlay-backdrop-color;\n  }\n\n  .cdk-overlay-transparent-backdrop {\n    // Define a transition on the visibility so that the `transitionend` event can fire immediately.\n    transition: visibility 1ms linear, opacity 1ms linear;\n    visibility: hidden;\n    opacity: 1;\n\n    // Note: as of Firefox 57, having the backdrop be `background: none` will prevent it from\n    // capturing the user's mouse scroll events. Since we also can't use something like\n    // `rgba(0, 0, 0, 0)`, we work around the inconsistency by not setting the background at\n    // all and using `opacity` to make the element transparent.\n    &.cdk-overlay-backdrop-showing {\n      opacity: 0;\n      visibility: visible;\n    }\n  }\n\n  .cdk-overlay-backdrop-noop-animation {\n    transition: none;\n  }\n\n  // Overlay parent element used with the connected position strategy. Used to constrain the\n  // overlay element's size to fit within the viewport.\n  .cdk-overlay-connected-position-bounding-box {\n    position: absolute;\n    z-index: $overlay-z-index;\n\n    // We use `display: flex` on this element exclusively for centering connected overlays.\n    // When *not* centering, a top/left/bottom/right will be set which overrides the normal\n    // flex layout.\n    display: flex;\n\n    // We use the `column` direction here to avoid some flexbox issues in Edge\n    // when using the \"grow after open\" options.\n    flex-direction: column;\n\n    // Add some dimensions so the element has an `innerText` which some people depend on in tests.\n    min-width: 1px;\n    min-height: 1px;\n  }\n\n  // Used when disabling global scrolling.\n  .cdk-global-scrollblock {\n    position: fixed;\n\n    // Necessary for the content not to lose its width. Note that we're using 100%, instead of\n    // 100vw, because 100vw includes the width plus the scrollbar, whereas 100% is the width\n    // that the element had before we made it `fixed`.\n    width: 100%;\n\n    // Note: this will always add a scrollbar to whatever element it is on, which can\n    // potentially result in double scrollbars. It shouldn't be an issue, because we won't\n    // block scrolling on a page that doesn't have a scrollbar in the first place.\n    overflow-y: scroll;\n  }\n}\n","// Structural styles for the autosize text fields.\n@mixin text-field-autosize() {\n  // Remove the resize handle on autosizing textareas, because whatever height\n  // the user resized to will be overwritten once they start typing again.\n  textarea.cdk-textarea-autosize {\n    resize: none;\n  }\n\n  // This class is temporarily applied to the textarea when it is being measured. It is immediately\n  // removed when measuring is complete. We use `!important` rules here to make sure user-specified\n  // rules do not interfere with the measurement.\n  textarea.cdk-textarea-autosize-measuring {\n    @include _autosize-measuring-base;\n    height: auto !important;\n    overflow: hidden !important;\n  }\n\n  // Similar to the `cdk-textarea-autosize-measuring` class, but only applied on Firefox. We need\n  // to use this class, because Firefox has a bug where changing the `overflow` breaks the user's\n  // ability to undo/redo what they were typing (see #16629). This class is only scoped to Firefox,\n  // because the measurements there don't seem to be affected by the `height: 0`, whereas on other\n  // browsers they are, e.g. Chrome detects longer text and IE does't resize back to normal.\n  // Identical issue report: https://bugzilla.mozilla.org/show_bug.cgi?id=448784\n  textarea.cdk-textarea-autosize-measuring-firefox {\n    @include _autosize-measuring-base;\n    height: 0 !important;\n  }\n}\n\n// Core styles that enable monitoring autofill state of text fields.\n@mixin text-field-autofill() {\n  // Keyframes that apply no styles, but allow us to monitor when an text field becomes autofilled\n  // by watching for the animation events that are fired when they start. Note: the /*!*/ comment is\n  // needed to prevent LibSass from stripping the keyframes out.\n  // Based on: https://medium.com/@brunn/detecting-autofilled-fields-in-javascript-aed598d25da7\n  @keyframes cdk-text-field-autofill-start {/*!*/}\n  @keyframes cdk-text-field-autofill-end {/*!*/}\n\n  .cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms;\n  }\n\n  .cdk-text-field-autofill-monitored:not(:-webkit-autofill) {\n    // Since Chrome 80 we need a 1ms delay, or the animationstart event won't fire.\n    animation: cdk-text-field-autofill-end 0s 1ms;\n  }\n}\n\n@mixin _autosize-measuring-base {\n  // Having 2px top and bottom padding seems to fix a bug where Chrome gets an incorrect\n  // measurement. We just have to account for it later and subtract it off the final result.\n  padding: 2px 0 !important;\n  box-sizing: content-box !important;\n}\n\n// Used to generate UIDs for keyframes used to change the text field autofill styles.\n$autofill-color-frame-count: 0;\n\n// Mixin used to apply custom background and foreground colors to an autofilled text field.\n// Based on: https://stackoverflow.com/questions/2781549/\n// removing-input-background-colour-for-chrome-autocomplete#answer-37432260\n@mixin text-field-autofill-color($background, $foreground:'') {\n  @keyframes cdk-text-field-autofill-color-#{$autofill-color-frame-count} {\n    to {\n      background: $background;\n      @if $foreground != '' { color: $foreground; }\n    }\n  }\n\n  &:-webkit-autofill {\n    animation: cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  &.cdk-text-field-autofill-monitored:-webkit-autofill {\n    // Since Chrome 80 we need a 1ms delay for cdk-text-field-autofill-start, or the animationstart\n    // event won't fire.\n    animation: cdk-text-field-autofill-start 0s 1ms,\n               cdk-text-field-autofill-color-#{$autofill-color-frame-count} both;\n  }\n\n  $autofill-color-frame-count: $autofill-color-frame-count + 1 !global;\n}\n\n// @deprecated Use `autosize` and `autofill` instead.\n@mixin text-field {\n  @include text-field-autosize();\n  @include text-field-autofill();\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use '@angular/cdk';\n@use '../style/layout-common';\n@use '../theming/theming';\n\n// Private sass variables that will be used as reference throughout component stylesheets.\n$default-border-width: 3px;\n$default-border-style: solid;\n$default-border-color: transparent;\n$default-border-radius: 4px;\n\n// Mixin that renders the focus indicator structural styles.\n@mixin structural-styling($prefix) {\n  .#{$prefix}-focus-indicator {\n    position: relative;\n\n    &::before {\n      @include layout-common.fill();\n      box-sizing: border-box;\n      pointer-events: none;\n      display: var(--#{$prefix}-focus-indicator-display, none); // Hide the indicator by default.\n      border: var(\n          --#{$prefix}-focus-indicator-border-width,\n          #{$default-border-width}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-style,\n          #{$default-border-style}\n        )\n        var(\n          --#{$prefix}-focus-indicator-border-color,\n          #{$default-border-color}\n        );\n      border-radius: var(\n        --#{$prefix}-focus-indicator-border-radius,\n        #{$default-border-radius}\n      );\n    }\n\n    // By default, render the focus indicator when the focus indicator host element takes focus.\n    // Defining a pseudo element's content will cause it to render.\n    &:focus::before {\n      content: '';\n    }\n  }\n\n  // Enable the indicator in high contrast mode.\n  @include cdk.high-contrast(active, off) {\n    @include customize-focus-indicators((display: block), $prefix);\n  }\n}\n\n// Generates CSS variable declarations from a map.\n@mixin _output-variables($map) {\n  @each $key, $value in $map {\n    @if ($value) {\n      --#{$key}: #{$value};\n    }\n  }\n}\n\n// Mixin that dedups CSS variables for the strong-focus-indicators mixin.\n@mixin customize-focus-indicators($config, $prefix) {\n  $border-style: map.get($config, border-style);\n  $border-width: map.get($config, border-width);\n  $border-radius: map.get($config, border-radius);\n  $border-color: map.get($config, border-color);\n  $display: map.get($config, display);\n  $map: (\n    '#{$prefix}-focus-indicator-border-style': $border-style,\n    '#{$prefix}-focus-indicator-border-width': $border-width,\n    '#{$prefix}-focus-indicator-border-radius': $border-radius,\n    '#{$prefix}-focus-indicator-border-color': $border-color,\n    '#{$prefix}-focus-indicator-display': $display,\n  );\n\n  @if (&) {\n    @include _output-variables($map);\n  }\n  @else {\n    // We use `html` here instead of `:root`, because the\n    // latter causes some issues with internal tooling.\n    html {\n      @include _output-variables($map);\n    }\n  }\n}\n\n@mixin strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat');\n}\n\n@mixin mdc-strong-focus-indicators($config: ()) {\n  // Default focus indicator config.\n  $default-config: (\n      border-color: black,\n      display: block,\n  );\n\n  // Merge default config with user config.\n  $config: map.merge($default-config, $config);\n\n  @include customize-focus-indicators($config, 'mat-mdc');\n}\n\n@mixin strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat');\n  }\n}\n\n@mixin strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n\n@mixin mdc-strong-focus-indicators-color($config-or-theme-or-color) {\n  @if meta.type-of($config-or-theme-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $config-or-theme-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $config: theming.get-color-config($config-or-theme-or-color);\n    $border-color: theming.get-color-from-palette(map.get($config, primary));\n    @include customize-focus-indicators((\n        border-color: $border-color\n    ), 'mat-mdc');\n  }\n}\n\n@mixin mdc-strong-focus-indicators-theme($theme-or-color-config-or-color) {\n  @if meta.type-of($theme-or-color-config-or-color) == 'color' {\n    @include customize-focus-indicators((\n        border-color: $theme-or-color-config-or-color\n    ), 'mat-mdc');\n  }\n  @else {\n    $theme: theming.private-legacy-get-theme($theme-or-color-config-or-color);\n    @include theming.private-check-duplicate-theme-styles($theme, 'mat-mdc-focus-indicators') {\n      $color: theming.get-color-config($theme);\n      @if $color != null {\n        @include mdc-strong-focus-indicators-color($color);\n      }\n    }\n  }\n}\n","// This mixin ensures an element spans to fill the nearest ancestor with defined positioning.\n@mixin fill {\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n}\n","/* \n\tColors values \n\t300 = tint\n\t500 = default\n\t700 = shade\n*/\n$primary-color: (\n  500: rgba(174, 15, 10, 1),\n  300: rgba(227, 6, 19, 1),\n  700: rgba(228, 173, 181, 1),\n  contrast: (500: white,\n    300: white,\n    700: black,\n  ),\n);\n$secondary-color: (\n  500: rgba(0, 87, 158, 1),\n  300: rgba(51, 125, 192, 1),\n  700: rgba(0, 59, 109, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$warning-color: (\n  500: rgba(255, 196, 9, 1),\n  300: rgba(255, 202, 34, 1),\n  700: rgba(224, 172, 8, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);\n\n$danger-color: (\n  500: rgba(235, 68, 90, 1),\n  300: rgba(237, 87, 107, 1),\n  700: rgba(207, 60, 79, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$success-color: (\n  500: rgba(45, 211, 111, 1),\n  300: rgba(66, 215, 125, 1),\n  700: rgba(40, 186, 98, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$dark-color: (\n  500: rgba(34, 36, 40, 1),\n  300: rgba(60, 60, 59, 1),\n  700: rgba(87, 87, 86, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$medium-color: (\n  500: rgba(112, 111, 111, 1),\n  300: rgba(135, 135, 135, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: white,\n    300: white,\n    700: white,\n  ),\n);\n\n$light-color: (\n  500: rgba(227, 227, 227, 1),\n  300: rgba(245, 246, 249, 1),\n  700: rgba(189, 188, 188, 1),\n  contrast: (500: black,\n    300: black,\n    700: black,\n  ),\n);","@import \"variables\";\n\nbody {\n  font-family: \"Barlow\", sans-serif;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Montserrat\", sans-serif;\n  font-weight: 600;\n}\n\nh1 {\n  font-size: 64px;\n  line-height: 78px;\n}\n\nh2 {\n  font-size: 56px;\n  line-height: 68px;\n}\n\nh3 {\n  font-size: 48px;\n  line-height: 58px;\n}\n\nh4 {\n  font-size: 40px;\n  line-height: 48px;\n}\n\nh5 {\n  font-size: 32px;\n  line-height: 39px;\n}\n\nh6 {\n  font-size: 24px;\n  line-height: 29px;\n}\n\na {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 19px;\n  color: map-get($primary-color, 500);\n  cursor: pointer;\n  text-decoration: underline;\n}\n\ncaption {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 14px;\n}\n\nth {\n  font-weight: 700;\n  cursor: pointer;\n}\n","$spacing-sizes: (\n  0: 0px,\n  1: 8px,\n  2: 16px,\n  3: 24px,\n  4: 32px,\n  5: 40px,\n  6: 48px,\n  7: 56px,\n  8: 64px,\n  9: 72px,\n  10: 80px,\n);\n\n@each $key, $size in $spacing-sizes {\n  .p-#{$key} {\n    padding: #{$size};\n  }\n  .pt-#{$key} {\n    padding-top: #{$size};\n  }\n  .pr-#{$key} {\n    padding-right: #{$size};\n  }\n  .pb-#{$key} {\n    padding-bottom: #{$size};\n  }\n  .pl-#{$key} {\n    padding-left: #{$size};\n  }\n  .px-#{$key} {\n    padding-left: #{$size};\n    padding-right: #{$size};\n  }\n  .py-#{$key} {\n    padding-top: #{$size};\n    padding-bottom: #{$size};\n  }\n\n  .m-#{$key} {\n    margin: #{$size};\n  }\n  .mt-#{$key} {\n    margin-top: #{$size};\n  }\n  .mr-#{$key} {\n    margin-right: #{$size};\n  }\n  .mb-#{$key} {\n    margin-bottom: #{$size};\n  }\n  .ml-#{$key} {\n    margin-left: #{$size};\n  }\n  .mx-#{$key} {\n    margin-left: #{$size};\n    margin-right: #{$size};\n  }\n  .my-#{$key} {\n    margin-top: #{$size};\n    margin-bottom: #{$size};\n  }\n}\n","@use \"@angular/material\" as mat;\n@include mat.core();\n@import url(\"https://fonts.googleapis.com/icon?family=Material+Icons\");\n@import \"theme/typography.scss\";\n@import \"theme/variables.scss\";\n@import \"theme/spacing\";\n@import url(\"https://fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap\");\nhtml {\n  --mdc-outlined-text-field-focus-outline-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n  --mdc-outlined-text-field-focus-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-option-selected-state-label-text-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-datepicker-toggle-active-state-icon-color: rgba(\n    174,\n    15,\n    10,\n    1\n  ) !important;\n\n  --mdc-filled-text-field-focus-active-indicator-color: rgba(\n    135,\n    135,\n    135,\n    1\n  ) !important;\n\n  --mat-sidenav-content-background-color: white !important;\n}\n\n/* You can add global styles to this file, and also import other style files */\n/* Angular 15 adds grey background on mat form components */\n/* below removes that background color */\n/* Manipulate initial background color*/\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n/*Manipulate background color on hover and focus*/\n.mat-mdc-form-field-focus-overlay {\n  background-color: transparent !important;\n}\n\n.mdc-evolution-chip__graphic.mat-mdc-chip-graphic.ng-star-inserted {\n  width: 0px;\n  padding-left: 6px;\n  padding-right: 6px;\n\n  span {\n    display: none;\n  }\n}\n\n/* Pagination menu */\n.g-bubble-container {\n  display: flex;\n  gap: 4px;\n  margin-left: 8px;\n}\n\n.g-bubble {\n  background-color: map-get($light-color, 300);\n  border-radius: 4px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: map-get($dark-color, 500) !important;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n  font-weight: 400;\n  line-height: 24px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n.g-bubble:hover {\n  background-color: map-get($light-color, 700);\n  color: map-get($light-color, 300);\n}\n\n.g-bubble__active {\n  background-color: map-get($primary-color, 300);\n  color: map-get($light-color, 500) !important;\n  box-shadow: 0px 5px 14px 0px rgba(0, 0, 0, 0.12),\n    0px 9px 10px 0px rgba(0, 0, 0, 0.14), 0px 5px 5px 0px rgba(0, 0, 0, 0.2);\n}\n\nmat-paginator {\n  background: transparent !important;\n}\n\n.mat-mdc-paginator-range-actions {\n  margin-right: 12px !important;\n}\n\n.mat-mdc-paginator-container {\n  justify-content: center !important;\n}\n\n.mat-mdc-paginator-navigation-next,\n.mat-mdc-paginator-navigation-previous {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: map-get($dark-color, 500) !important;\n  padding: 0 !important;\n  border-radius: 4px !important;\n  width: 34px !important;\n  height: 34px !important;\n  background-color: map-get($light-color, 300) !important;\n  box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.12),\n    0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.2);\n}\n\n/* End of pagination menu */\n\nbody {\n  margin: 0;\n}\n\n.snackbar {\n  width: 50vw;\n  margin: 10px 0px !important;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snackbar-custom {\n  width: 50vw;\n  margin-top: 75px !important;\n}\n\n.snacbar-warning {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid #e0ac08;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-sucess {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid green;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.snacbar-error {\n  width: 50vw;\n  margin: 10px 0px;\n\n  .mdc-snackbar__surface {\n    background-color: map-get($light-color, 300) !important;\n    border-radius: 10px !important;\n    width: 33vw;\n    border: 1px solid red;\n  }\n\n  .mdc-snackbar__label {\n    color: black !important;\n  }\n\n  .mat-icon {\n    margin-right: 12px;\n  }\n}\n\n.flex {\n  display: flex;\n}\n\n.mat-mdc-menu-panel {\n  overflow: hidden !important;\n\n  .mat-mdc-menu-content {\n    .menu-header {\n      font-size: 12px;\n      padding: 1rem;\n      padding-bottom: 0.25rem;\n    }\n\n    .mat-mdc-menu-item {\n      margin-left: 1rem;\n      padding-left: 0;\n    }\n\n    .mat-mdc-menu-item:first-of-type {\n      margin-top: 0.75rem;\n    }\n\n    .mat-mdc-menu-item:not(:last-child) {\n      border-bottom: 1px solid map-get($light-color, 700);\n    }\n  }\n}\n\n.loading-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3000;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.sort-icon-container {\n  display: inline-flex;\n  align-items: center;\n\n  mat-icon {\n    height: 1rem;\n    width: 1rem;\n  }\n}\napp-edit-contract{\n  .btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n    @media (max-width: 767px) {\n      margin-top: 15px;\n      margin-right: 0 !important;\n      width: 40% !important;\n      height: 45px;\n    }\n  }\n}\n.btn-primary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($primary-color, 500);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    margin-right: 0 !important;\n    width: 40%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-secondary.mat-mdc-unelevated-button.mat-unthemed {\n  background: white;\n  color: map-get($primary-color, 500);\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: 2px solid map-get($primary-color, 500);\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n\n  &[disabled] {\n    background: map-get($medium-color, 700);\n  }\n}\n\n.btn-tertiary.mat-mdc-unelevated-button.mat-unthemed {\n  background: map-get($medium-color, 700);\n  color: white;\n  width: 14rem;\n  border-radius: 10px;\n  padding: 0.75rem 0;\n  border: none;\n  font-weight: bold;\n  align-self: center;\n  cursor: pointer;\n\n  @media (max-width: 767px) {\n    margin-top: 15px;\n    width: 100%;\n    height: 45px;\n  }\n}\n\n/* \n  IONIC components\n*/\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\nion-item.no-padding-full {\n  --padding-end: 0;\n  --padding-start: 0;\n  --inner-padding-end: 0;\n  --inner-padding-start: 0;\n}\nion-checkbox {\n  --checkbox-background-checked: rgba(174, 15, 10, 1);\n  --border-color-checked: rgba(174, 15, 10, 1);\n}\n\nion-input.custom-input {\n  --border-color: rgba(135, 135, 135, 1);\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.custom-input-user {\n  --border-color: #EFEFEF;\n  --padding-top: 5px;\n  --highlight-color: rgba(135, 135, 135, 1);\n}\nion-input.width-full {\n  --border-color: #EFEFEF !important;\n  --padding-top: 5px;\n  --highlight-color: rgb(37, 19, 19);\n}\n.filter-panel {\n  max-width: 100vw !important;\n}\n.date-select-modal-filter {\n  .mdc-text-field {\n    height: 35px;\n  }\n  .mat-mdc-form-field-infix {\n    height: 35px;\n    min-height: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding-top: 0px !important;\n    padding-bottom: 0px !important;\n  }\n  .select-year {\n    .mat-mdc-text-field-wrapper {\n      background-color: #f4f4f4;\n      border: 1px solid rgb(189, 188, 188);\n    }\n  }\n\n  .mdc-notched-outline__leading {\n    border: none !important;\n  }\n  .mdc-notched-outline__notch {\n    border: none !important;\n  }\n  .mdc-notched-outline__trailing {\n    border: none !important;\n  }\n}\n\n@media (min-width: 1025px) {\n  .filter-panel {\n    max-height: 33rem !important;\n    min-width: 60vw;\n  }\n\n  .anotation-panel {\n    max-width: 30rem !important;\n    max-height: 30rem !important;\n    min-width: 50vw;\n  }\n\n  .historic-panel {\n    min-width: 49.5rem;\n    min-height: 35.625rem;\n    min-width: 50vw;\n  }\n  .segments-panel {\n    width: 72vw;\n    min-width: 760px;\n    max-width: 1100px !important;\n    max-height: 90vh !important;\n  }\n  .new-highway-modal-panel {\n    min-width: 49.5rem;\n    min-height: 23.625rem;\n    min-width: 50vw;\n  }\n}\n\n@media (max-width: 1024px) {\n  .btn-actions {\n    margin-right: 15px;\n  }\n  .filter-panel {\n    min-height: 30rem;\n    max-width: 100vw !important;\n    min-width: 90vw;\n  }\n\n  .historic-panel {\n    max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n  .segments-panel {\n    max-width: 90vw !important;\n    min-width: 90vw !important;\n    max-height: 90vh !important;\n  }\n    .new-highway-modal-panel {\n  max-width: 49.5rem;\n    min-width: 90vw !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .anotation-panel {\n    width: 90%;\n  }\n}\n\n.mdc-text-field--filled:not(.mdc-text-field--disabled) {\n  background-color: transparent !important;\n}\n\n@media (max-width: 1024px) {\n  .mat-mdc-form-field-label {\n    font-size: 0.8rem;\n    /* Tamanho de fonte para dispositivos móveis */\n  }\n}\n\n.button_cad {\n  background-color: map-get($primary-color, 500);\n  padding: 0.5rem 2rem;\n  border-radius: 0.5rem;\n  color: #fff;\n  font-style: none;\n  text-decoration: none;\n\n  mat-icon {\n    color: #fff !important;\n  }\n}\n\n::ng-deep.mat-mdc-card-header-text {\n  display: none !important;\n}\n.input-error {\n  border: 1px solid red; /* Ajuste o estilo conforme necessário */\n}\n.card-mobile {\n  min-height: 10rem;\n  margin: 1rem auto;\n  border: 1px solid #cdcdcd;\n\n  .mat-mdc-card-header {\n    width: 90%;\n    display: flex;\n    margin: auto;\n    // align-items: center;\n    justify-content: space-between;\n    padding: 0rem;\n\n    p {\n      font-weight: bolder;\n      font-size: 1.2rem;\n      text-transform: uppercase;\n    }\n\n    span,\n    .subtitle {\n      font-size: 1rem;\n      font-weight: normal;\n      color: #cdcdcd;\n    }\n    @media (max-width: 1024px) {\n      width: 100%;\n      margin: 0 16px;\n    }\n  }\n\n  .mat-mdc-card-footer {\n    margin: 1rem 0rem;\n    border-top: 1px solid black;\n    display: flex;\n    align-items: center;\n\n    button {\n      width: 100%;\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n\n  .extension {\n    font-weight: bold;\n    color: map-get($primary-color, 500);\n  }\n  .formatAnotation {\n    @media (max-width: 1024px) {\n      padding: 0 16px;\n    }\n  }\n\n  .content-card {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  .content-status {\n    width: 40%;\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n\n    p {\n      font-weight: bold;\n    }\n  }\n}\n\n.card-mobile-empty {\n  border: 1px solid #cdcdcd;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nion-button.more-filters-btn {\n  --background: rgba(174, 15, 10, 1);\n  --color: white;\n  --border-radius: 10px;\n  width: 100%;\n  max-width: 15rem;\n  text-transform: capitalize;\n  font-size: 0.9rem;\n  height: 100%;\n  font-weight: 600;\n  letter-spacing: 0.08em;\n}\n\nion-item.fast-filters {\n  padding: 0.25rem 0rem;\n}\n\nion-chip.fast-filter-active-primary {\n  background-color: map-get($success-color, 700);\n  color: white;\n}\n\nion-chip.fast-filter-active-secondary {\n  background-color: map-get($danger-color, 500);\n  color: white;\n}\nion-chip.fast-filter-active-primary-contract {\n\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n\n}\n\nion-chip.fast-filter-active-secondary-contract {\n  color: #AE0F0A;\n  border: 1px solid #AE0F0A;\n  background: #E4ADB5;\n}\n.more-filters-btn-row {\n  justify-content: center;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n\n  button {\n    margin: 5px;\n  }\n\n  @media (max-width: 767px) {\n    button {\n      margin: 5px 0;\n    }\n  }\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n\n  .mat-icon {\n    width: 1rem;\n  }\n\n  .status-icon {\n    font-size: 8px;\n    align-content: center;\n    text-align: center;\n  }\n\n  .active {\n    color: map-get($success-color, 700);\n  }\n\n  .inactive {\n    color: map-get($danger-color, 500);\n  }\n}\n\nion-textarea,\nion-input {\n  --border-color: rgba(87, 87, 86, 1);\n  --padding-top: 5px !important;\n  --highlight-color: rgba(135, 135, 135, 1);\n  --highlight-color-focused: rgba(135, 135, 135, 1) !important;\n  --highlight-color-valid: rgba(135, 135, 135, 1) !important;\n  --highlight-color-invalid: rgba(174, 15, 10, 1) !important;\n}\n\nion-alert.custom-alert {\n  --backdrop-opacity: 0.7;\n}\n\nion-list.filtered-list {\n  display: flex;\n  flex-wrap: wrap;\n\n  span {\n    padding: 0.75rem 0;\n    margin: 0 0.75rem;\n    border-bottom: 1px solid map-get($light-color, 700);\n    width: 100%;\n  }\n}\n\nion-item.no-padding {\n  --padding-end: 0;\n  --padding-start: 0;\n}\n\n// Toast\nion-toast.snackbar-toast {\n  --box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  --width: fit-content;\n  --border-radius: 0.75rem;\n  --white-space: pre-line;\n}\n\nion-toast.snackbar-toast {\n  &::part(container) {\n    background: #fff;\n    color: rgba(34, 36, 40, 1);\n    width: fit-content;\n    border-radius: 0.75rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-success {\n  &::part(container) {\n    border: 1px solid rgba(45, 211, 111, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(45, 211, 111, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-error {\n  &::part(container) {\n    border: 1px solid rgba(235, 68, 90, 1);\n  }\n\n  &::part(icon) {\n    color: rgba(235, 68, 90, 1);\n    font-size: 1.25rem;\n  }\n}\n\nion-toast.snackbar-toast.toast-right {\n  --start: right;\n  --box-shadow: none;\n  --background: none;\n\n  &::part(container) {\n    transform: translateY(72px) !important;\n    box-shadow: 1px 4px 10px 4px rgba(0, 0, 0, 0.3);\n  }\n}\n\n::ng-deep.mat-tab-label {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n/* Styles for the active tab label */\n::ng-deep.mat-tab-label.mat-tab-label-active {\n  min-width: 25px !important;\n  padding: 5px;\n  background-color: transparent;\n  color: red !important;\n  font-weight: 700;\n}\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab\n  .mdc-tab-indicator__content--underline {\n  border-color: #2b2b2b;\n}\n\n// .mat-mdc-tab .mdc-tab-indicator__content--underline {\n//   border-color: #2b2b2b;\n// }\n\n::ng-deep.mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active\n  .mdc-tab__text-label {\n  color: #2b2b2b;\n}\n\n.mat-mdc-paginator-navigation-next, .mat-mdc-paginator-navigation-previous {\n      box-shadow: none !important;\n}\n.g-bubble {\n  box-shadow: none !important;\n}\napp-modal-historic-segment {\n  display: block;\n  width: 100%;\n  height: 45em;\n}\n\n.column-flex {\n  display: flex;\n  flex-flow: column;\n}\n\n.master-icon {\n  background-color: map-get($warning-color, 300);\n  color: map-get($dark-color, 500);\n  border-radius: 10px;\n  align-self: flex-start;\n  font-size: 10px;\n  padding: 0px 9px;\n  margin: 6px 0;\n  line-height: 17px;\n  font-weight: 600;\n\n  &.center-horizontal {\n    place-self: center;\n  }\n}\n\nion-popover {\n  --min-width: 375px;\n  --max-width: 500px;\n}\n.custom-tooltip-menu {\n  padding: 8px;\n  \n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  border: 1px solid #e0e0e0;\n  border-radius: 4px;\n\n  .mat-mdc-standard-chip:not(.mdc-evolution-chip--disabled) {\n    background: none;\n  }\n  .mdc-evolution-chip__text-label {\n    color: #c00;\n  }\n}\n\n.custom-tooltip-menu .filter-title {\n  font-size: 12px;\n  font-weight: bold;\n  color: #333;\n  display: block;\n  margin-bottom: 4px;\n  border-bottom: 1px solid grey;\n}\n\n.custom-tooltip-menu .tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px;\n}\n\n.custom-tooltip-menu mat-chip {\n  border: 1px solid #c00;\n  height: 20px;\n}\n\n.custom-tooltip-menu mat-chip mat-icon {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 14px !important;\n  opacity: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-right: 0px !important;\n}\n.custom-tooltip-menu mat-chip .mdc-evolution-chip__text-label {\n  color: #c00 !important;\n  cursor: pointer;\n  font-size: 12px !important;\n  opacity: 1;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab .mdc-tab-indicator__content--underline  {\n  border: 1px solid #c00 !important;\n}\n::ng-deep .mdc-tab.mat-mdc-tab.mat-mdc-focus-indicator.mdc-tab--active.ng-star-inserted.mdc-tab-indicator--active.mat-mdc-tab.mdc-tab--active .mdc-tab__text-label {\n  color: #c00 !important;\n}\nion-toggle {\n  --handle-background-checked: rgba(174, 15, 10, 1);\n  --track-background-checked: rgba(174, 15, 10, 0.38);\n}\napp-list-contracts {\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\napp-table-default{\n  thead{\n    background: #F4F4F4 !important;\n  }\n}\n.mat-expansion-panel-body{\n  padding: 0px !important;\n}\n.mat-mdc-paginator-range-actions {\n \n  overflow-wrap: anywhere !important;\n  flex-grow: 1;\n  justify-content: center !important;\n  position: relative !important;\n}\n.mat-mdc-paginator-container:has(.mat-mdc-paginator-page-size) .mat-mdc-paginator-range-actions .mat-mdc-paginator-range-label {\n  position: absolute !important;\n  left: 0 !important;\n}\n.mat-mdc-tab{\n  background-color: #F4F4F4 !important;\n}\n.mdc-tab--active{\n  background-color: white !important;\n}\n#paginator{\n  @media(max-width: 1025px){\n    width: 100%;\n  }\n\n}\nion-icon.search-icon-absolute {\n  position: absolute;\n  left: 16px;\n  top: 0;\n  bottom: 0;\n  margin: auto;\n  z-index: 3;\n}\n\nion-input.search-input {\n  label.input-wrapper {\n    --padding-start: 55px;\n  }\n\n  &.has-focus,\n  &.has-value {\n    .input-wrapper {\n      .label-text-wrapper {\n      }\n    }\n  }\n}\n.mat-mdc-icon-button[disabled] {\n    cursor: default;\n        pointer-events: auto;\n    opacity: .38;\n}\n.mat-mdc-unelevated-button[disabled] {\n    cursor: default;\n      pointer-events: auto;\n    opacity: .38;\n}\n\n.item-inner{\n  padding-right: 0 !important;\n}\n\n.mat-mdc-paginator-page-size-label {\n  @media (max-width: 496px) {\n    display: none !important;\n  }\n}\n.comentarios .mdc-text-field--outlined {\n  --mdc-outlined-text-field-outline-width: 1px;\n  --mdc-outlined-text-field-outline-color: #EFEFEF; /* Borda normal */\n  --mdc-outlined-text-field-focus-outline-color: #EFEFEF; /* Borda ao focar */\n  --mdc-outlined-text-field-container-shape: 4px;\n}\n// Gaps gerais\n.g-0 { gap: 0 !important; }\n.g-1 { gap: 0.25rem !important; }\n.g-2 { gap: 0.5rem !important; }\n.g-3 { gap: 1rem !important; }\n.g-4 { gap: 1.5rem !important; }\n.g-5 { gap: 3rem !important; }\n\n// Gaps horizontais\n.gx-0 { column-gap: 0 !important; }\n.gx-1 { column-gap: 0.25rem !important; }\n.gx-2 { column-gap: 0.5rem !important; }\n.gx-3 { column-gap: 1rem !important; }\n.gx-4 { column-gap: 1.5rem !important; }\n.gx-5 { column-gap: 3rem !important; }\n\n// Gaps verticais\n.gy-0 { row-gap: 0 !important; }\n.gy-1 { row-gap: 0.25rem !important; }\n.gy-2 { row-gap: 0.5rem !important; }\n.gy-3 { row-gap: 1rem !important; }\n.gy-4 { row-gap: 1.5rem !important; }\n.gy-5 { row-gap: 3rem !important; }\n.col {\n  flex: 1 0 0%;\n  max-width: 100%;\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.col-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n.col-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n.col-3 { flex: 0 0 23%; max-width: 23%; }\n.col-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n.col-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n.col-6 { flex: 0 0 48%; max-width: 48%; }\n.col-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n.col-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n.col-9 { flex: 0 0 73%; max-width: 73%; }\n.col-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n.col-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n.col-12 { flex: 0 0 98%; max-width: 98%; }\n\n/* Colunas responsivas */\n@media (min-width: 576px) { /* sm */\n  .col-sm-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-sm-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-sm-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-sm-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-sm-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-sm-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-sm-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-sm-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-sm-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-sm-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-sm-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-sm-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 768px) { /* md */\n  .col-md-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-md-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-md-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-md-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-md-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-md-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-md-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-md-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-md-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-md-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-md-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-md-12 { flex: 0 0 100%; max-width: 100%; }\n}\n\n@media (min-width: 992px) { /* lg */\n  .col-lg-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-lg-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-lg-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-lg-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-lg-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-lg-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-lg-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-lg-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-lg-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-lg-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-lg-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-lg-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1200px) { /* xl */\n  .col-xl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n\n@media (min-width: 1400px) { /* xxl */\n  .col-xxl-1 { flex: 0 0 6.333333%; max-width: 6.333333%; }\n  .col-xxl-2 { flex: 0 0 14.666667%; max-width: 14.666667%; }\n  .col-xxl-3 { flex: 0 0 23%; max-width: 23%; }\n  .col-xxl-4 { flex: 0 0 31.333333%; max-width: 31.333333%; }\n  .col-xxl-5 { flex: 0 0 39.666667%; max-width: 39.666667%; }\n  .col-xxl-6 { flex: 0 0 48%; max-width: 48%; }\n  .col-xxl-7 { flex: 0 0 56.333333%; max-width: 56.333333%; }\n  .col-xxl-8 { flex: 0 0 64.666667%; max-width: 64.666667%; }\n  .col-xxl-9 { flex: 0 0 73%; max-width: 73%; }\n  .col-xxl-10 { flex: 0 0 81.333333%; max-width: 81.333333%; }\n  .col-xxl-11 { flex: 0 0 89.666667%; max-width: 89.666667%; }\n  .col-xxl-12 { flex: 0 0 98%; max-width: 98%; }\n}\n.ampliacao-panel{\n  max-width: 60vw !important;\n}\n.popover-content{\n  max-height: 150px;\n}\napp-form-projetos thead tr th{\n    font-family: \"Barlow\", sans-serif !important;\n    font-weight: 500 !important;\n    font-size: 18px !important;\n    line-height: 100% !important;\n  \n}\napp-form-projetos .mat-mdc-header-cell{\n    border: none !important;\n  \n}\napp-form-projetos .mat-mdc-form-field-subscript-wrapper {\n    display: none;\n}\n\n.mdc-checkbox .mdc-checkbox__native-control:enabled:checked~.mdc-checkbox__background\n {\n    border-color: #AE0F0A !important;\n    background-color: #AE0F0A !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
